/**
 * サイドメニュー項目、ページヘッダのタイトルを表す定数
 *
 * 定数名は名詞(句)とする
 * ACTIONをするための画面タイトルは動名詞(句)とする
 * 例: EDITING_XXX, CREATING_XXX
 */
export const MENU = {
  NEW_REGISTRATION: '新規登録',
  TRUCK_MODEL: '車種',
  DUPLICATE_OF_DISPATCH_DETAIL: '配車済の配送依頼の複製',
  EDITING_DISPATCH_DETAIL: '配車情報の編集',
  // 親矢羽根ケバブから開く groupモードのタイトル（#4705。合算表示は本体クリックの内容表示へ分離）。
  // 荷主単位でまとめて編集するため「配車情報の〜」とは付けない
  BULK_EDITING_DISPATCH_GROUP: '一括編集',
  CREATING_TRUCK_MODEL: '車種の新規作成',
  CREATING_DRIVER: 'ドライバーの新規作成',
  UPDATE_DRIVER: 'ドライバーの更新',
  DRIVER: 'ドライバー',
  TRUCKS: '車両',
  CREATING_TRUCK: '車両の新規作成',
  EDITING_TRUCK: '車両の編集',
  DELETING_TRUCK: '車両の削除',
  CREATING_SHIPMENT_ORDER: '配送依頼の作成',
  CREATING_SHIPMENT_CATEGORY: '配送種別の新規作成',
  CREATING_DISPATCH_DETAIL_FROM_HISTORY: '履歴から配車',
  PARTNER: 'パートナー',
  REGISTERING_PARTNER: '新規登録(パートナー)',
  REGISTERING_SUB_PARTNER: '運送会社の新規作成',
  REGISTERING_SUB_PARTNER2: '新規登録(運送会社)',
  CREATING_SUB_PARTNER: '実運送会社の新規作成',
  SUB_PARTNER_DETAIL: '運送会社詳細',
  SUB_PARTNER: '運送会社',
  NEW_ADDITION: '新規追加',
  EDITING_DISPATCH: '運行情報の編集',
  REGISTERING_DISPATCH: '運行情報の登録',
  DELETING_SHIPMENT_ORDER: '配送依頼の削除',
  // VOC_PJ-445 #1864: 配送依頼一覧から選択した依頼をまとめて削除する
  BULK_DELETING_SHIPMENT_ORDERS: '配送依頼の一括削除',
  DELETING_SHIPMENT_ORDER_HISTORY: '配送依頼履歴の削除',
  // VOC_PJ-981 #4620: 配送依頼の取消／取消の取り消し（復活）
  REVOKING_SHIPMENT_ORDER: '配送依頼の取消',
  RESTORING_REVOKED_SHIPMENT_ORDER: '取消の取り消し',
  DELETING_AREA: 'エリアの削除',
  CHANGING_SHARED_DC: '共有拠点の変更',
  GROUPING_TRUCK: '車両のグループ設定',
  CREATING_TRUCK_GROUP: '車両グループの新規作成',
  EDITING_TRUCK_GROUP: '車両グループの編集',
  DELETING_TRUCK_GROUP: '車両グループの削除',
  CREATING_SCHEDULE: 'スケジュール枠の作成',
  // TODO: 表記ゆれ 予定？スケジュール？
  EDITING_SCHEDULE: 'スケジュールの編集',
  DELETING_DISPATCH: '運行情報の削除',
  DELETING_PLAN_SLOT: '車両枠の削除',
  HIDING_PLAN_SLOT: '車両の非表示',
  MANAGING_HIDDEN_PLAN_SLOTS: '非表示車両の管理',
  NO_HIDDEN_PLAN_SLOTS: 'この日に非表示にした車両はありません',
  PERMANENT_VEHICLES: '配車表示車両',
  SELECTING_DEPARTURE_TIME_RESTRICTION_START: '発時間制限開始の選択',
  EDITING_SHIPMENT_ORDER: '配送依頼の編集',
  REJECTING_DISPATCH: '配車依頼を却下',
  DELETING_REGULAR_GROUP_DISPATCH: '定期複製した運行情報の削除',
  DELETING_REGULAR_GROUP_DISPATCH_DETAIL: '定期複製した配送依頼の削除',
  BULK_UPDATING_STATUS: 'ステータス一括更新',
  DETACHING_REGULAR_GROUP: '定期複製設定の解除',
  DETACHING_LOGIN_ACCOUNT: 'ログインアカウントの解除',
  DISPATCH_OPERATION: '操作ログ',
  TOUR: '運行実績',
  TOUR_CSV_IMPORT: '運行実績CSVインポート',
  CONTRACT: '支払契約',
  CUSTOMER_CONTRACT: '請求契約',
  DELETING_CONTRACT: '契約の削除',
  DELETING_CUSTOMER_CONTRACT: '請求契約の削除',
  REVISING_CONTRACT: '契約の改訂',
  REVISING_CUSTOMER_CONTRACT: '請求契約の改訂',
  CHANGING_CONTRACT_TYPE: '契約種別の変更',
  UPDATING_CONTRACT_END_DATE: '適用終了日の変更',
  DELETING_TOUR: '運行実績の削除',
  RESTORING_TOUR: '運行キャンセルの解除',
  REASON_FOR_MODIFICATION: '修正理由',
  MONTHLY_CUSTOMER_REPORT: '月次請求レポート',
  CREATING_PACKAGE_CATEGORY: '荷姿の新規作成',
  CREATING_CUSTOMER: '荷主の新規作成',
  REGISTERING_CUSTOMER: '新規登録(荷主)',
  MONTHLY_TOUR_REPORT: '月次支払レポート',
  CONFIRM_DIFFERENT_DATE: '配車日確認',
  CONFIRM_TIME_RESTRICTION: '時間制限外の配置',
  VEHICLE_DISPATCH_BOARD: '配車板',
  DOWNLOADING_VEHICLE_DISPATCH_BOARD: '配車板データダウンロード',
  EXPORTING_DISPATCH_RESULTS_CSV: '配車結果CSVエクスポート',
  DOWNLOADING_IN_HOUSE_INSTRUCTION_SHEET: '配送指示書（自車）',
  EDITING_SITE: '地点の編集',
  CREATING_SITE: '地点の新規作成',
  /** 地点セレクトの候補行から荷主と地点を関連付ける際の確認モーダルタイトル（#3669） */
  LINKING_CUSTOMER_AND_SITE: '荷主と地点の関連付け',
  CREATING_AREA: 'エリアの新規作成',
  CONVERTING_SITE: '地点への変更',
  CONVERTING_AREA: 'エリアへの変更',
  DELETING_SITE: '地点の削除',
  SITE_IMPORT_HISTORY: '地点のインポート履歴',
  SHIPMENT_CATEGORY_IMPORT_HISTORY: '配送種別のインポート履歴',
  PACKAGE_CATEGORY_IMPORT_HISTORY: '荷姿のインポート履歴',
  TARIFF: 'タリフ',
  TARIFF_DETAIL: 'タリフ明細',
  TARIFF_ADDITIONAL_DETAIL: '附帯作業明細',
  TARIFF_TYPE: 'タリフ種別',
  TARIFF_VERSION: 'タリフの版',
  TARIFF_NAME_AND_CODE: 'タリフ名・コード',
  TARIFF_MASTER: 'タリフマスタ',
  TARIFF_IMPORT_INDEX: 'タリフのインポート一覧',
  REGISTERING_SITE: '新規登録(地点)',
  REGISTERING_AREA: '新規登録(エリア)',
  CREATING_TRUCK_CLASS: '車格の新規作成',
  TANKA_CONTRACT_UNIT: '個建契約単位',
  CREATING_TRUCK_TYPE: '車両属性の新規作成',
  TRUCK_TYPE: '車両属性',
  IMPORTING_TRUCK_TYPE_MASTER: '車両属性マスタのインポート',
  TRUCK_TYPE_IMPORT_HISTORY: '車両属性のインポート履歴',
  ROLLBACK_IMPORT: 'インポートの取り消し',
  RESUME_IMPORT: 'インポートの再開',
  FINISH_IMPORT: '中断した更新のインポートの終了',
  INTERRUPT_IMPORT: 'インポートの中断',
  CHARGE_TYPE: '運賃種別',
  TOUR_CONTRACT_IMPORT_ALL: '運行建契約の一括インポート',
  ADMIN_PAGE: '管理者ページ',
  DELETING_ADDITIONAL_PAYMENT_CATEGORY: '追加運賃項目の削除',
  DEACTIVATING_ADDITIONAL_PAYMENT_CATEGORY: '追加運賃項目の無効化',
  ADDITIONAL_PAYMENT_CATEGORY: '追加運賃項目',
  TAX_CATEGORIES: '税区分マスタ',
  CUSTOM_KEY_SETTINGS: 'カスタムキー',
  CREATING_TAX_CATEGORY: '税区分の新規作成',
  EDITING_TAX_CATEGORY: '税区分の編集',
  DEACTIVATING_TAX_CATEGORY: '税区分の無効化',
  CREATING_DC: '拠点の新規作成',
  DC: '拠点',
  OWN_PARTNER: '自社情報',
  MASTER_SETTINGS: 'マスタ設定',
  TRUCK_IMPORT_HISTORY: '車両のインポート履歴',
  TRUCK_MASTER_IMPORT: '車両マスタのインポート',
  TRUCK_CLASS_IMPORT_HISTORY: '車格のインポート履歴',
  TRUCK_CLASS_MASTER_IMPORT: '車格マスタのインポート',
  TRUCK_MODEL_IMPORT_HISTORY: '車種のインポート履歴',
  TRUCK_MODEL_MASTER_IMPORT: '車種マスタのインポート',
  UPDATING_SHIPMENT_ORDER: '配送依頼の更新',
  IMPORTING_SHIPMENT_ORDER: '配送依頼のインポート',
  IMPORTING_SUNTORY_DEDICATED_SHIPMENT_ORDER: 'サントリー得意先配送インポート',
  SHIPMENT_ORDER_IMPORT_HISTORY: '配送依頼のインポート履歴',
  CANCELING_CLOSING_DATE_CHANGE: '締日変更のキャンセル',
  CHANGING_CLOSING_DATE: '締日の変更',
  CHANGING_CLOSING_DATE2: '締日変更',
  IMPORTING_INVOICE_FARE: '請求運賃のインポート',
  REQUESTING_PARTNER: 'パートナーへ依頼',
  SHIPMENT_ORDER: '配送依頼',
  DISPATCH_WORK: '配車作業',
  DISPATCH_BOARD: '配車板',
  BUSINESS_MASTER_SETTINGS: '業務マスタ設定',
  OWN_PARTNER_INFO: '自社情報',
  SITES: '地点',
  CUSTOMER: '荷主',
  PACKAGE_CATEGORY: '荷姿',
  SHIPMENT_CATEGORY: '配送種別',
  SYSTEM_MASTER_SETTINGS: 'システムマスタ設定',
  USER: 'ユーザー',
  DC_USER: '拠点ユーザー',
  CREATEING_DC_USER: '拠点ユーザーの新規作成',
  PARTNER_USER: 'パートナーユーザー',
  CREATEING_PARTNER_USER: 'パートナーユーザーの新規作成',
  AREA: 'エリア',
  TRUCK_CLASS: '車格',
  IMPORTING_SITE_MASTER: '地点マスタのインポート',
  IMPORTING_SHIPMENT_CATEGORY_MASTER: '配送種別マスタのインポート',
  IMPORTING_PACKAGE_CATEGORY_MASTER: '荷姿マスタのインポート',
  IMPORTING_TARIFF: 'タリフのインポート',
  ACTUAL_TRANSPORT_STRUCTURE_MANAGEMENT: '実運送体制管理',
  ARRIVAL_AND_DEPARTURE_TIME: '発着時刻',
  BULK_OPERATION: '一括操作',
  BULK_OPERATION_CONFIRMATION: '一括操作の確認',
  DISPATCH_RESULT_REPORT_EXPORT: '帳票出力',
  CONFIRMED: '確定',
  DELETE: '削除',
  WITHDRAW: '確定解除',
  EDITING_HISTORY_NAME: '配送依頼履歴の編集',
  SWAPPING_DISPATCH: '運行情報入れ替え',
  // 未配車リストの束ねカード / 親矢羽根ホバーの子矢羽根一覧、どちらのモーダルにも使う
  SELECTING_BUNDLE_SHIPMENT_ORDER: '複数依頼の選択',
  // 親矢羽根クリックで開く、束ね内の配送依頼ごとの内容表示モーダル（#4705）
  BUNDLE_SHIPMENT_ORDER_CONTENTS: '複数依頼の内容',
  SELECTING_CARGO_INFO: '積荷情報の選択',
  ALIGNING_BUNDLE_DATES: '発日・着日の統一',
  CHANGING_DATES_IN_BULK: '日付の一括変更',
  // 配送依頼のインポートの入口（取り込み方法を選ぶモーダル、#4728）
  IMPORTING_SHIPMENT_ORDER_CSV: '配送依頼のインポート'
} as const

/**
 * サイドメニュー項目に付与する注釈（tooltip）文言。
 * マスタ系メニューの名称右にホバーで表示され、各マスタの役割を説明する。
 * キーは対応する MENU のキーに揃える。
 */
export const MENU_TOOLTIP = {
  SHIPMENT_CATEGORY:
    '配送依頼を分類する種別（チャーター便・定期便など）です。配送依頼の登録時に選択し、設定したカラーで一覧・配車板に色分け表示されるほか、請求契約とのカテゴリ別の紐付けにも使われます。',
  TRUCK_CLASS:
    '車両の大きさの区分（2t・4t・10tなど）です。車両マスタで各車両に設定し、契約の車格別運賃表（車格×車両属性）でパートナーへ支払う運賃単価を決める基準になります。',
  TRUCK_TYPE:
    '車両の仕様・形状などの属性区分（ウイング、平など）です。車両マスタで各車両に設定し、支払契約の運賃表で車格と組み合わせて、パートナーへ支払う運賃の単価を決める基準になります。',
  TANKA_CONTRACT_UNIT:
    '個建契約で数量を数える単位（ケース・パレット・個口など）です。個建の支払契約で単位ごとの単価を設定し、数量に応じてパートナーへ支払う運賃を計算します。\n\n例）単価 1,500円／パレット × 10パレット → 支払運賃 15,000円',
  CHARGE_TYPE:
    'タリフ（運賃表）と車両を突き合わせるための運賃区分です。車格・車種のマスタに設定しておくと、タリフ明細の運賃種別と照合して運賃が自動計算されます。',
  TRUCK_MODEL:
    '配送依頼で希望する車種（例: 大型・4tユニックなど）を指定する際に使われる区分です。運賃種別を紐付けておくと、タリフ（運賃表）による請求運賃の自動計算に反映されます。',
  TRUCKS:
    '配車に使うトラックを1台ずつ登録するマスタです。所属パートナー・車格・車両属性などを設定し、配車板での車両選択や運行実績・スケジュール枠に使われます。設定した車格は運賃の自動計算にも反映されます。'
} as const

/**
 * ボタン、リンクに使用されるアクションを表す定数
 * ラジオボタン、チェックボックスなどのオプション動作にも使用される
 *
 * 定数名は動詞(句)とする
 */
export const ACTIONS = {
  SAVE: '保存',
  CANCEL: 'キャンセル',
  DELETE: '削除',
  DELETE2: '削除する',
  // VOC_PJ-981 #4620: 配送依頼の取消。メニュー項目は「取り消す」、確認モーダルの OK は
  // 「取消する」とする（「取消」単体だと隣のキャンセルボタンや既存ステータスの
  // 「キャンセル」と紛らわしいため動詞化する）
  REVOKE_SHIPMENT_ORDER: '取り消す',
  REVOKE_SHIPMENT_ORDER_CONFIRM: '取消する',
  RESTORE_REVOKED_SHIPMENT_ORDER: '取消を戻す',
  RESTORE_REVOKED_SHIPMENT_ORDER_CONFIRM: '受注済に戻す',
  HIDE_PLAN_SLOT: '非表示にする',
  UNHIDE_PLAN_SLOT: '再表示する',
  EDIT: '編集',
  CREATE: '作成',
  UPDATE: '更新',
  CONFIRM: '確認',
  YES: 'はい',
  NO: 'いいえ',
  REGISTER: '登録',
  RESUME: '再開',
  RESUME2: '再開する',
  FINISH: '終了',
  FINISH2: '終了する',
  INTERRUPT: '中断',
  INTERRUPT2: '中断する',
  LOGIN: 'ログイン',
  COPY: 'コピー',
  ADD: '追加',
  SEARCH: '検索',
  RESET: 'リセット',
  APPLY: '適用',
  SUBMIT: '送信',
  APPROVE: '承認',
  REJECT: '却下',
  REJECT2: '却下する',
  HOLD: '保留',
  EXECUTE: '実行',
  CLOSE: '閉じる',
  /** 地点セレクトの候補行から荷主と地点を関連付けるボタン（#3669） */
  LINK: '関連付ける',
  /** VOC_PJ-863 #3809: 支払側附帯費用見出しの「請求側附帯費用の項目に合わせる」ボタン */
  MATCH_TO_ADDITIONAL_CHARGES: '請求側附帯費用の項目に合わせる',
  ADD_TRUCK_GROUP: '車両グループの追加',
  GO_TO_MONTHLY_TOUR_REPORT: '月次支払レポートへ',
  REVERT_TO_SHIPMENT_ORDER: '配送依頼に戻す',
  REVERT_TO_SHIPMENT_ORDER_ALL: 'まとめて配送依頼に戻す',
  CREATE_TRUCK_MODEL: '車種の新規作成',
  ADD_ITEM: '明細を追加',
  ADD_WAYPOINT: '経由地を追加',
  SHOW_ITEM: '明細',
  SAVE_HISTORY: '履歴に残す',
  KEEP_CONTENTS_IN_SAVING: '保存時に入力内容を残す',
  IMPORT_SHIPMENT_ORDER: '配送依頼のインポート',
  IMPORT_SUNTORY_DEDICATED_SHIPMENT_ORDER: 'サントリー得意先配送インポート',
  SAVE_EDIT: '編集内容の保存',
  EDIT_ORDER_NO: '配送依頼Noの編集',
  ADD_SUB_PARTNER: '運送会社を追加',
  CREATE_PARTNER: 'パートナーの新規作成',
  CREATE_SUB_PARTNER: '運送会社の新規作成',
  CREATE_ACTUAL_SUB_PARTNER: '実運送会社の新規作成',
  CONFIRM_INVOICE: '請求確認',
  GO_PREVIOUS: '前へ',
  GO_NEXT: '次へ',
  SWAP: '運行情報の入れ替え',
  FORCE_ASSIGN: '強制割当',
  RELEASE_DISPATCH: '車両ドライバー紐づけ解除',
  OPEN_SHIPMENT_ORDER_MENU: '配送依頼メニューを開く',
  OPEN_CARGO_INFO_MENU: '積荷情報を開く',
  OPEN_TOTAL_AMOUNT_MENU: '車両と荷物の総量表示を開く',
  OPEN_OPERATION_MANAGEMENT_MENU: '運行管理を開く',
  EXPORT_DISPATCH_RESULTS: '配車結果のエクスポート',
  DOWNLOAD_DISPATCH_REQUEST_FORM: '配車依頼書の出力',
  DOWNLOAD_IN_HOUSE_INSTRUCTION_SHEET: '配送指示書（自車）の出力',
  OUTPUT_FOR_EACH_TRUCK: '車両別に出力',
  CREATE_SHIPMENT_ORDER: '配送依頼の作成',
  CREATE_SCHEDULE: '予定',
  CREATE_FREE_TIME: '空き時間',
  ADD_SHIPMENT_ORDER: '配送依頼を追加',
  DISPATCH_MULTIPLE_SHIPMENT_ORDERS: '一括配車',
  ADD_TRUCK: '車両を追加',
  SORT_ASC: '昇順',
  SORT_DESC: '降順',
  UPDATE_STATUS: 'ステータス更新',
  BUNDLE_SHIPMENT_ORDERS: '複数依頼をまとめる',
  UNBUNDLE_SHIPMENT_ORDERS: 'まとめ解除',
  SEPARATE_FROM_BUNDLE: '分離',
  // 選択した依頼を束ねから外し、単一の依頼の状態に戻すボタン
  // （一覧の一括操作メニュー / 束ねの複数依頼選択モーダルの両方で使う）
  RESTORE_TO_SINGLE_SHIPMENT_ORDER: '単一の依頼に戻す',
  // 選択した依頼の発日・着日・請求計上日をまとめて変更するボタン（配車前のみ）
  BULK_UPDATE_DATES: '日付をまとめて変更',
  // 親矢羽根ホバー ⋮ のメニュー項目。束ね配下をまとめて編集する導線（#4705）
  BULK_EDIT: '一括編集',
  // 束ねの日付統一モーダル: 各依頼の日付を変えずに束ねる選択肢
  KEEP_DATE_AS_IS: 'そのまま',
  // 束ねの日付統一モーダル: カレンダーで指定した1日に全依頼を揃える選択肢
  ALIGN_DATE: '日付を揃える',
  // 束ねの日付統一モーダル: 請求計上日を荷主マスタの計上基準（発日/着日基準）で再算出する選択肢（既定）
  FOLLOW_CUSTOMER_SETTING: '荷主マスタの設定に従う',
  BUNDLE: 'まとめる',
  // 束ねの複数依頼選択モーダル: チェックした依頼を合計から外す操作（チェックボックスの説明）
  EXCLUDE_FROM_TOTAL: '合計から除外',
  // 束ねの複数依頼選択モーダル: 選択可能な行のチェックを一括で付け外しする操作
  SELECT_ALL: '全選択',
  // 一覧のまとめキー左のチェック: 同じ束ねの依頼をまとめて行選択する操作（チェックボックスの説明）
  SELECT_BUNDLE_ORDERS: 'まとめキーの依頼をすべて選択',
  CHANGE_INTO: (status: string) => `${status}に変更`,
  GROUP: 'グループ設定',
  DEACTIVATE_PERMANENT: '配車表示の終了',
  CANCEL_DEACTIVATE: '適用終了の取り消し',
  DEACTIVATE_SUBMIT: '終了する',
  CANCEL_DEACTIVATE_SUBMIT: '取り消す',
  TRANSIT_DISPATCH_TO: {
    CANCEL_REQUEST: '依頼のキャンセル',
    WITH_DRAW: '取下げ',
    REJECT: '却下'
  },
  DELETE_DISPATCH: '運行情報の削除',
  DUPLICATE_AS_REGULAR_GROUP: '定期配送として複製する',
  DUPLICATE_AS_REGULAR_GROUP_SHORT: '定期複製',
  DETACH: '解除する',
  NOT_DETACH: '解除しない',
  SHOW_DISPATCH_OPERATION: '操作ログを表示',
  CREATE_TRUCK: '車両の新規作成',
  IMPORT_TRUCK: '車両のインポート',
  SHOW_TRUCK_IMPORT_HISTORY: '車両のインポート履歴',
  SHOW_DETAIL: '詳細',
  // TODO: UPDATE_STATUSと統合したほうがよさそう
  UPDATE_STATUS2: 'ステータスの更新',
  CHANGE: '変更する',
  SHOW_HERE: 'こちら',
  SAVE_EDITED_CONTENT: '編集内容を保存',
  EXPORT_CSV: 'CSVエクスポート',
  IMPORT_CSV: 'CSVインポート',
  IMPORT_FROM_CSV: 'CSVからのインポート',
  DOWNLOAD_TEMPLATE: 'テンプレートダウンロード',
  UPLOAD_FILE: 'クリックまたはドラッグ&ドロップでファイルをアップロード',
  UPLOAD_TRUCK_DATA:
    'クリックまたはドラッグ&ドロップで車両データをアップロード',
  UPLOAD_TRUCK_CLASS_DATA:
    'クリックまたはドラッグ&ドロップで車格データをアップロード',
  UPLOAD_TRUCK_MODEL_DATA:
    'クリックまたはドラッグ&ドロップで車種データをアップロード',
  FIX_DATE: '日時を修正',
  DELETE_PACKAGE: '荷姿を削除',
  ADD_PACKAGE: '荷姿を追加',
  ADD_TOUR: '運行実績追加',
  EDIT_TOUR: '運行実績の編集',
  CANCEL_TOUR: '運行キャンセル',
  RESTORE_TOUR: 'キャンセルから戻す',
  SHOW_CANCELLED_TOURS: '確定済みのキャンセル運行を表示',
  CREATE_REVISED_CONTRACT: '改訂版の作成',
  CREATE_CONTRACT: '契約の新規作成',
  CREATE_CUSTOMER_CONTRACT: '請求契約の新規作成',
  DUPLICATE_AND_ADD_DETAIL: '複製して明細を追加',
  ADD_SITE: '配送地点を追加',
  MOVE_TOUR_LIST: '運行実績一覧へ',
  // VOC_PJ-931 #4312: 月次請求レポート詳細の非表示リストから明細を戻す操作
  SHOW_IN_REPORT: '非表示を解除',
  CONFIRM_WITHOUT_TOUR: '運行なしで確定',
  DOWNLOAD: 'ダウンロード',
  CONFIRM_ALL: '一括確定',
  AGREE_CONTENT: '内容に同意する',
  CREATE_INVOICE: '請求書を作成',
  REQUEST_CONFIRMATION_DC: 'センターへ確認依頼',
  RECONFIRM_PARTNER: 'パートナー再確認',
  REQUEST_FINAL_CONFIRMATION: '最終確認依頼',
  RECONFIRM_DC: 'センター再確認',
  UPDATE_TO_CONFIRMED: '確認済みへ更新',
  TARIFF_IMPORT: 'タリフのインポート',
  EXPORT_LATEST_TARIFF: '最新版タリフのエクスポート',
  CREATE_TANKA_CONTRACT_UNIT: '個建契約単位の新規作成',
  CREATE_TRUCK_TYPE: '車両属性の新規作成',
  UPLOAD_TRUCK_TYPE:
    'クリックまたはドラッグ&ドロップで車両属性データをアップロード',
  CREATE_CHARGE_TYPE: '運賃種別の新規作成',
  DUPLICATE: '複製',
  CALCULATE_AUTOMATICALLY: '自動計算',
  CONTAIN_ALL: 'すべてを含む',
  CONTAIN_ANY: 'いずれかを含む',
  ROLLBACK: '取り消す',
  // TODO: ROLLBACKと統合したほうがよさそう
  ROLLBACK2: '取り消し',
  CREATE_ADDITIONAL_PAYMENT_CATEGORY: '追加運賃項目の新規作成',
  CREATE_TAX_CATEGORY: '税区分の新規作成',
  DEACTIVATE: '無効化',
  CREATE_DC: '拠点の新規作成',
  UPLOAD_TOUR_CONTRACT:
    'クリックまたはドラッグ&ドロップで運行建契約をアップロード',
  IMPORT_ALL_TOUR_CONTRACT: '運行建契約の一括インポート',
  IMPORT: 'インポート',
  EXPORT: 'エクスポート',
  SELECT_FILE: 'ファイルを選択する',
  CANCEL_CLOSING_DATE_CHANGE: '締日変更をキャンセル',
  CHANGE_CLOSING_DATE: '締日を変更する',
  IMPORT_SHIPMENT_ORDER_UPDATE:
    'クリックまたはドラッグ&ドロップで配送依頼を更新',
  UPLOAD_SHIPMENT_ORDER:
    'クリックまたはドラッグ&ドロップで配送依頼をアップロード',
  SWITCH_TENANT: 'テナント切り替え',
  LOGOUT: 'ログアウト',
  RETURN: '戻る',
  // TODO: CANCEL_CLOSING_DATE_CHANGEと結合できそう
  CANCEL_CLOSING_DATE_CHANGE2: '締日変更をキャンセルする',
  UPLOAD_INVOICE_FARE:
    'クリックまたはドラッグ&ドロップで請求運賃をアップロード',
  REQUEST_TO_PARTNER: 'パートナーへ依頼',
  REPORT_CONFIRM_OPERATIONS: '運行確定を報告',
  APPROVE_REQUEST: '依頼を承認する',
  REQUEST: '依頼する',
  UPLOAD_SITE: 'クリックまたはドラッグ&ドロップで地点データをアップロード',
  UPLOAD_SHIPMENT_CATEGORY:
    'クリックまたはドラッグ&ドロップで配送種別データをアップロード',
  UPLOAD_PACKAGE_CATEGORY:
    'クリックまたはドラッグ&ドロップで荷姿データをアップロード',
  UPLOAD_TARIFF: 'クリックまたはドラッグ&ドロップでタリフデータをアップロード',
  ADD_EQUIPMENT: '装備を追加',
  LEDGER_EXPORT: '帳票出力',
  BULK_REVISION: '一括改定',
  BULK_DELETION: '一括削除',
  CONFIRMED: '確定',
  WITHDRAW: '確定解除',
  CANCEL_EDIT: '編集をキャンセル',
  CREATE_REGULAR_OPERATION: '定期運行の作成',
  /*
    定期複製の導線ラベル。複製先が配車済み(矢羽根)か未配車(配送依頼)か、
    かつ対象が既に定期運行かで 4 通りに出し分ける。
  */
  CREATE_DISPATCHED_REGULAR_OPERATION: '配車済みの定期運行として作成',
  EDIT_DISPATCHED_REGULAR_OPERATION: '配車済みの定期運行を編集',
  CREATE_NOT_DISPATCHED_REGULAR_OPERATION: '未配車の定期運行として作成',
  EDIT_NOT_DISPATCHED_REGULAR_OPERATION: '未配車の定期運行を編集',
  CLOSE_REGULAR_OPERATION_EDIT: '定期運行の編集を閉じる',
  REQUEST_PARTNER: 'パートナーへ依頼',
  ADD_MEMO: 'メモを追加',
  ADD_RELATED_SITE: '関連地点を追加'
} as const

/**
 * ステータス、状態を表す定数
 *
 * 定数名は形容詞(句)とする
 */
export const STATUSES = {
  PENDING: '処理待ち',
  // TODO: PENDINGと統合したほうがよいのでは？
  BEFORE_PROCESSING_ALLOCATED: '処理前・振り分け済',
  BEFORE_PROCESSING: '処理前',
  ALLOCATED: '振り分け済',
  ALL: 'すべて',
  PRESENT: 'あり',
  ABSENT: 'なし',
  DISPATCHED: '配車済',
  UNORDERED: '未受注',
  BEFORE_DISPATCH: '受注済',
  DISPATCHING: '配車中',
  DISPATCH_CONFIRMED: '配車確定',
  TRUCK_ASSIGNED: '車番済',
  DISPATCHED_WITH_TRUCK: '配車確定（車番済）',
  TRUCK_NOTIFIED: '車番連絡済',
  DELIVERY_INSTRUCTED: '配送指示済',
  SAME_DAY_GUIDED: '当日誘導済',
  LOADING_COMPLETED: '積込完了',
  UNLOADING_COMPLETED: '降ろし完了',
  DELIVERY_COMPLETED: '配送完了',
  CANCELLED: 'キャンセル',
  // VOC_PJ-981 #4620: 配送依頼の取消。CANCELLED（配車したが運行しなかった）とは別概念で、
  // 依頼そのものの取り消しを表す。未配車のときのみ設定できる
  REVOKED: '取消',
  PROCESSING: '処理中',
  COMPLETED: '完了',
  FAILED: 'エラー',
  // VOC_PJ-586 #5269: 契約種別タグで契約マスタに該当がない状態の表示。該当契約が無いのは
  // 異常ではなく通常あり得る状態なので FAILED（'エラー'）と分離する。FAILED は取込ジョブ系の
  // 共通ステータスが共有しており値を変えられないため別文言を新設した
  NO_CONTRACT: '該当なし',
  UNSET: '未設定',
  ACTUAL_TRUCK: '実車両',
  TEMPORARY_TRUCK: '仮車両',
  UNSELECTED: '未選択',
  ACTIVE_INACTIVE: '有効/無効',
  APPLY_STATUS: '適用中/適用終了',
  ACTIVE: '有効',
  INACTIVE: '無効',
  NO_TOUR: '運行実績なし',
  HAS_TOUR: '実績化済',
  // TODO: DISPATCHEDと統合したほうがよいのでは？
  DISPATCHED2: '配車',
  UNDISPATCHED: '未配車',
  UNDISPATCHED2: '未配車あり',
  ON_HOLD: '保留',
  REJECTED: '却下',
  NOT_ASSIGNED_DRIVER: 'ドライバー未割り当て',
  RELATED_TO_TOUR: '連携済',
  SPLITTED: '分割',
  UNCONFIRMED: '未確定',
  // TODO: CONFIRMEDと統合したほうがよさそう
  UNCONFIRMED_ONLY: '未確定のみ',
  CREATING: '作成中',
  IS_MANUAL: '手入力',
  FIXED_UNFIXED: '修正の有無',
  FIXED: '修正あり',
  UNFIXED: '修正なし',
  IS_TEMPORAL_TOUR: '臨時運行',
  TEMPORAL: '臨時',
  REGULAR: '通常',
  APPLYING: '適用中',
  WITHIN_APPLY_PERIOD: '適用期間内',
  OUT_OF_APPLY_PERIOD: '適用期間外',
  APPLY_ACTIVE: '適用中',
  APPLY_ENDED: '適用終了',
  CONFIRMED: '確定',
  // TODO: CONFIRMEDと統合したほうがよさそう
  CONFIRMED_ONLY: '確定のみ',
  ONLY_IN_HOUSE: '自車のみ',
  ONLY_PARTNERS: 'パートナーのみ',
  ONLY_EMPTY_DRIVER: 'ドライバー未設定のみ',
  ONLY_EMPTY_TRUCK: '車両未設定のみ',
  HIDE_DAY_OFF: '休車除外',
  APPROVED: '承認済み',
  ORDER_FIXED: '運行確定',
  ORDERING: '依頼中',
  PLANNING: '計画中',
  // インポートの処理中という意味だったため別出ししたがPROCESSINGと統合してしまってよい？
  IMPORTING: '処理中',
  ROLLED_BACK: '取り消し済',
  PROGRESS_DISPATCH: '配車中',
  CONFIRMED_WITH_REPORTED: '確定(連)',
  DOWNLOADING: 'ダウンロード中',
  NO_GROUP: 'グループなし',
  NOT_BILLABLE: '不可',
  BILLABLE: '可'
} as const

/**
 * 地点ごとの作業内容（WorkType）の表示名。キーは API の enum 値名
 */
export const WORK_TYPES = {
  LOADING: '積込',
  UNLOADING: '荷降し',
  OTHER: 'その他'
} as const

/**
 * 項目名を表す定数
 *
 * 定数名は名詞(句)とする
 */
// TODO: 肥大化した場合、目的の文言を捜すのが大変になるため、機能別に分割することを検討
export const LABELS = {
  // 車両リソース閾値
  WEIGHT_THRESHOLD_PERCENT: '積載率閾値（%）',
  VEHICLE_RESOURCE_THRESHOLD: '車両リソース閾値設定',
  HOURS_THRESHOLD: '稼働時間閾値（時間）',
  WEIGHT_THRESHOLD_UNIT: '%',
  HOURS_THRESHOLD_UNIT: '時間',
  // VOC_PJ-988 #4770: 環境設定セクションで 1 行に横並びする際の短縮サブラベル（単位は addonAfter で付与）
  WEIGHT_THRESHOLD_SHORT: '積載率',
  HOURS_THRESHOLD_SHORT: '稼働時間',
  VEHICLE_RESOURCE_THRESHOLD_DESCRIPTION:
    '車両リソースステータスの「一部空きあり」判定に使用する閾値を設定します。積載率と稼働時間の両方が閾値未満の場合に「一部空きあり」と判定されます。',
  // 宵積みデフォルト時間設定（拠点単位、PartnerForm 環境設定セクション内）
  PRE_LOAD_DEFAULT_PICKUP_TIME: '宵積みの目安集荷時間',
  PRE_LOAD_DEFAULT_DELIVERY_TIME: '宵積みの目安納品時間',
  PRE_LOAD_AUTO_APPLY: '宵積みデフォルト自動適用',
  // 確定ロック（拠点単位、PartnerForm 環境設定セクション内。#5601）
  SHOULD_LOCK_DISPATCH_ON_FIX: '車両行のロック設定',
  // 車両リソースステータス
  RESOURCE_STATUS_NOT_ASSIGNED: '未割当',
  RESOURCE_STATUS_PARTIALLY_AVAILABLE: '一部空きあり',
  RESOURCE_STATUS_FULL_UNCONFIRMED: '空きなし（確定前）',
  RESOURCE_STATUS_FULL_CONFIRMED: '空きなし（確定済）',
  // 運行フェーズ
  OPERATION_PHASE_NOT_STARTED: '運行前',
  OPERATION_PHASE_IN_PROGRESS: '運行中',
  OPERATION_PHASE_COMPLETED: '運行完了',
  // 積荷情報（配車板の矢羽根に載っている配送依頼の一覧）
  CARGO_INFO: '積荷情報',
  // 運行管理
  OPERATION_MANAGEMENT: '運行管理',
  CONFIRMED_VEHICLES: '確定済み車両',
  CONFIRMED_VEHICLES_UNIT: '台',
  NO_CONFIRMED_DISPATCHES: '確定済みの配車がありません',
  DEPARTURE: '出発',
  COMPLETION: '完了',
  COMPLETED_LABEL: '完了済み',
  REVERT_TO_NOT_STARTED: '出発前に戻す',
  REVERT_TO_IN_PROGRESS: '出発済みに戻す',
  // 契約関連
  CONTRACT_TYPE_SYA_DATE: '車建',
  CONTRACT_TYPE_UNKOU_DATE: '運行建',
  CONTRACT_TYPE_TANKA: '個建',
  CONTRACT_TYPE_TARIFF: 'タリフ',
  ITEM_UNIT: '単位',
  AMOUNT: '金額',
  TRUCK_MODEL: '車種',
  DC: '拠点',
  DC_COMMON_ALL: '共通（全拠点）', // 詳細フォームの読み取り表示・Select オプション
  DC_COMMON: '共通', // 一覧テーブルの短縮表示
  CODE_NAME: 'コード/名称',
  USER_NAME: 'ユーザー名',
  TRUCK_MODEL_NAME: '車種名',
  TRUCK_MODEL_CODE: '車種コード',
  DISPLAY_NAME: '表示名',
  AUTHORITY: '権限',
  SYSTEM_ADMIN_AUTHORITY: 'システム管理者権限',
  DRIVER_NAME: 'ドライバー名',
  DRIVER_COLOR: 'ドライバーカラー',
  LOGIN_ACCOUNT: 'ログインアカウント',
  CREATE_LOGIN_ACCOUNT: 'ログインアカウントを作成する',
  NO_LOGIN_ACCOUNT: 'なし',
  PHONE_NUMBER: '電話番号',
  CONTACT_NAME: '担当者',
  // #5311: 帳票の宛名にはこの値がそのまま出る。敬称もマスタに入れてもらう
  CONTACT_NAME_PLACEHOLDER: '田中 太郎　様',
  CONTACT_PHONE_NUMBER: '連絡先',
  PARTNER: 'パートナー',
  PARTNER_OFFICE: 'パートナー / 事業所',
  DESIGNATED_PARTNER: '指定パートナー',
  SUB_PARTNER: '実運送会社',
  ALREADY_REVISED: '改訂済',
  BULK_DELETE_TARGET: '削除対象',
  BULK_DELETE_NOT_DELETABLE: '削除不可',
  BULK_REVISE_TARGET: '改訂対象',
  BULK_REVISE_NOT_AVAILABLE: '改訂不可',
  // TODO: SUB_PARTNERと統合したほうがよいので？
  SUB_PARTNER2: '運送会社',
  CREATED_BY: '作成者',
  CREATED_AT: '作成日時',
  /**
   * 配送依頼の登録日（#5285 VOC_PJ-506）。日時まで出す CREATED_AT とは別ラベルで、
   * 日付だけを扱う一覧の列と検索フォームの見出しに使う
   */
  CREATED_DATE: '登録日',
  UPDATED_BY: '更新者',
  UPDATED_AT: '更新日時',
  TRUCK_NAME: '車両名',
  TRUCK_ASSIGNMENT: '車両区分',
  TRUCK_GROUP: '車両グループ',
  TRUCK_GROUP_NAME: 'グループ名',
  TRUCK_GROUP_SETTINGS: '車両のグループ設定',
  TRUCK_CODE: '車両番号',
  TRUCK_CLASS: '車格',
  TRUCK_TYPE: '車両属性',
  USAGE_TYPE: '利用タイプ',
  MAX_LOADING_CAPACITY: '最大積載量',
  DEFAULT_DRIVER: '初期ドライバー',
  APPLY_DEFAULT_DRIVER: '車両に紐づくデフォルトドライバーを適用する',
  NUMBER_PLATE: 'ナンバープレート',
  ALL_VEHICLES: '全車両',
  HOLIDAY_SETTINGS: '休日設定',
  SATURDAY: '土',
  SUNDAY: '日',
  HOLIDAY: '祝',
  SATURDAY_OFF: '土休',
  SUNDAY_OFF: '日休',
  HOLIDAY_OFF: '祝休',
  DAY_OFF: '休車',
  TOTAL_TRUCK_WEIGHT: '車両総重量',
  TOTAL_TRUCK_WEIGHT_PLACEHOLDER: '車検証の車両総重量(kg)',
  LIGHT_VEHICLE: '軽車両',
  LIGHT_VEHICLE_SHORT: '軽',
  TRUCK_STYLE: '車型',
  CARGO_SIZE_LARGE_CATEGORY: '荷台サイズ (大分類)',
  TRUCK_WIDTH_CATEGORY: '車幅区分',
  CARGO_HEIGHT_CATEGORY: '荷台高さ区分',
  CARGO_SIZE_SMALL_CATEGORY: '荷台サイズ (小分類)',
  LENGTH: '長さ',
  WIDTH: '幅',
  HEIGHT: '高さ',
  SIDE_BOARD_HEIGHT: 'あおり高',
  SIDE_BOARD_HEIGHT_FLAT_TRUCK_ONLY: 'あおり高 (平車のみ設定可能)',
  TRUCK_EQUIPMENT: '車両装備',
  EQUIPMENT_DETAILS: '装備詳細',
  SPECIAL_1: '特殊1',
  SPECIAL_2: '特殊2',
  CARGO_AREA_SPECIFICATION: '庫内仕様',
  SIDE_PANEL: '側面',
  FLOOR_PANEL: '床面',
  CARGO_AREA_SIDE_TYPE: '荷台側面種別',
  CARGO_AREA_FLOOR_TYPE: '荷台床面種別',
  OTHER_SPECIFICATION: 'その他',
  CARGO_AREA_EQUIPMENT: '庫内装備',
  EQUIPMENT_NAME: '装備名',
  EQUIPMENT_QUANTITY: '数量',
  EQUIPMENT_SIZE: 'サイズ等',
  EQUIPMENT_NOTE: '装備備考 (その他)',
  INSPECTION_DATE_3_MONTH: '3ヶ月点検日',
  INSPECTION_DATE_12_MONTH: '12ヶ月点検日',
  VEHICLE_INSPECTION_EXPIRY: '車検証有効期限',
  VEHICLE_DEADLINE_MANAGEMENT: '車両期限管理',
  INSPECTION_EXPIRED: '（期限切れ）',
  INSPECTION_DAYS_REMAINING: (days: number) => `（残り${days}日）`,
  CUSHIONING_MATERIAL: '緩衝材',
  CONCRETE_PANEL: 'コンパネ',
  LASHING_SIDE: 'ラッシング (サイド)',
  LASHING_FLOOR: 'ラッシング (床)',
  WRAPPING_MATERIAL: 'ラップ',
  RINGI: 'リンギ',
  THROUGH_RINGI: '通しリンギ',
  WIRE: 'ワイヤー',
  LEVER_BLOCK: 'レバーブロック',
  ROPE: 'ロープ',
  LARGE_SHEET: '大シート',
  MEDIUM_SHEET: '中シート',
  FLAT_COVER_SHEET: '平掛けシート',
  UNDERLAYMENT_SHEET: '下敷きシート (ブルーシート)',
  STEEL: '鉄板',
  CHECKERED: '縞板',
  SLATTED: 'すのこ',
  WOODEN: '木張',
  LOW_FLOOR: '低床',
  MIDDLE_LOW_FLOOR: '中低床',
  HIGH_FLOOR: '高床',
  DOUBLE_RAIL: '2段レール',
  SINGLE_RAIL: 'シングルレール',
  JOLODA_2: 'ジョルダー (2本)',
  JOLODA_4: 'ジョルダー (4本)',
  STANCHION_SIDE: 'スタンション (サイド)',
  STANCHION_CENTER: 'スタンション (中央部)',
  FLOOR_HOOK: '床フック',
  TWO_TIER: '二層式',
  THREE_TIER: '三層式',
  STANDARD: '標準',
  SEMI_WIDE: 'セミワイド',
  FULL_WIDE: 'フルワイド',
  FREEZER: '冷凍',
  REFRIGERATED: '冷蔵',
  INSULATED: '保冷',
  DUMP: 'ダンプ',
  TRACTOR_HEAD: 'ヘッド',
  MARITIME_CONTAINER_20FT: '海上コンテナ (20ft)',
  MARITIME_CONTAINER_40FT: '海上コンテナ (40ft)',
  RAILWAY_CONTAINER: '鉄道コンテナ',
  OPEN_TOP: 'オープントップ',
  FLOWER_TRUCK: '花車',
  FRESH_FISH_TRUCK: '鮮魚車',
  LIVESTOCK_TRUCK: '家畜輸送車',
  HANGER_TRUCK: 'ハンガー',
  POWER_GATE_FLIP_UP: 'パワーゲート (跳ね上げ)',
  POWER_GATE_RETRACTABLE: 'パワーゲート (格納)',
  ALL_AIR_SUSPENSION: '総輪エアサス',
  REAR_AIR_SUSPENSION: '後輪エアサス',
  TARPAULIN: '幌',
  ACCORDION_COVER: 'アコーディオン',
  WING: 'ウイング',
  VAN: 'バン',
  FLAT: '平',
  CRANE: 'クレーン',
  TRAILER_HEAD: 'トレーラーヘッド',
  TRAILER_CHASSIS: 'トレーラーシャーシ',
  SELF_LOADER: 'セルフローダー',
  LORRY: 'ローリー',
  BULK: 'バルク',
  TANK: 'タンク',
  MIXER: 'ミキサー',
  CAR_CARRIER: 'キャリアカー',
  GARAGE: '車庫',
  ALREADY_ADDED_PREFIX: '⚠️稼働中',
  ORDER_NO: '配送依頼No',
  BUNDLE_LABEL: 'まとめキー',
  FREE_WORD: 'フリーワード',
  FREE_WORD_PLACEHOLDER: '備考・荷主名・車種名・地点名',
  BRANCH_NO: '枝番',
  FUNDAMENTAL_INFORMATION: '基本情報',
  SHIPMENT_CATEGORY: '配送種別',
  DELIVERY_STATUS: '配送ステータス',
  SHIPMENT_CATEGORY_CODE: '配送種別コード',
  SHIPMENT_CATEGORY_NAME: '配送種別名',
  SHIPMENT_CATEGORY_COLOR: '配送種別カラー',
  CUSTOMER: '荷主',
  HISTORY: '履歴',
  UPDATE_HISTORY: '更新履歴',
  ORIGIN: '発地',
  // 配送ルート編集の時刻欄（幅が狭く1文字で役割を示す）: 出発時刻 = 発 / 到着時刻 = 着
  DEPARTURE_SHORT: '発',
  ARRIVAL_SHORT: '着',
  ORIGIN_FROM: '発地（from）',
  ORIGIN_SITE_AND_AREA: '発地（発エリア）',
  ORIGIN_COLON: '発: ',
  AREA: 'エリア',
  NO_AREA: '(エリアなし)',
  DIRECTION_FILTER_MODAL_TITLE: '絞り込む方面を選択',
  SELECT_AREA: 'エリアの選択',
  AREA_NAME: 'エリア名',
  AREA_CODE: 'エリアコード',
  CHILD_AREA: '子エリア',
  DESTINATION: '着地',
  WAYPOINT: '経由地',
  // 発地・着地・経由地の地点セレクトのラベル（エリア・作業内容・備考・時間と同じ幅で揃える）
  STOP_SITE: '地点',
  DESTINATION_SITE_AND_AREA: '着地（着エリア）',
  DESTINATION_TO: '着地（to）',
  DESTINATION_COLON: '着: ',
  NOTE: '備考',
  ORIGIN_NOTE: '発地備考',
  DESTINATION_NOTE: '着地備考',
  ORIGIN_ADDRESS: '発地住所',
  DESTINATION_ADDRESS: '着地住所',
  // 配車板の操作ログが矢羽根の編集項目を 操作前 / 操作後 に出す欄（#5358）
  ORIGIN_AREA: '発エリア',
  DESTINATION_AREA: '着エリア',
  DEPARTURE_RESTRICTION_START: '発時間制限（開始）',
  DEPARTURE_RESTRICTION_END: '発時間制限（終了）',
  ARRIVAL_RESTRICTION_START: '着時間制限（開始）',
  ARRIVAL_RESTRICTION_END: '着時間制限（終了）',
  SHIPMENT_DETAILS: '明細',
  PRE_LOAD_DISPLAY: '宵積み表示',
  PRE_LOAD_DISPLAY_ON: 'あり',
  PRE_LOAD_DISPLAY_OFF: 'なし',
  EXPENSE_TAX_CATEGORY: '払い税区分',
  EXPENSE_TAX_INCLUSIVE_CATEGORY: '払い税計算方式',
  EXPENSE_ROUND_TYPE: '払い端数処理',
  INCOME_TAX_CATEGORY: '請求税区分',
  INCOME_TAX_INCLUSIVE_CATEGORY: '請求税計算方式',
  INCOME_ROUND_TYPE: '請求端数処理',
  WORK_TYPE: '作業内容',
  INCOME: '請求',
  INCOME_COUNT: '請求件数',
  INCOME_FARE: '請求運賃',
  INCOME_FARE_YEN: '請求運賃（円）', // TODO: ラベル＋UnitLabelの形に置き換える
  INCOME_RECORDING_DATE: '請求計上日',
  // 束ねの日付モーダルの行ラベル用（「請求計上日」だと 4rem のラベル列で改行されるため）
  INCOME_RECORDING_DATE_SHORT: '計上日',
  // VOC_PJ-931 #4312: 顧客へ提出する明細に載せない印。FIX 仕様書 §2.1 の文言をそのまま使う
  REPORT_DETAIL_HIDDEN: '明細非表示',
  // VOC_PJ-931 #4312: 月次請求レポート詳細で、非表示にした明細をまとめて見せるセクション
  HIDDEN_CHARGES: '非表示の明細',
  // VOC_PJ-931 #4312: 運送会社名・車種・ドライバー名を 1 列にまとめた見出し（CF-15）
  DELIVERY_TRUCK_INFO: '配送車両情報',
  INCOME_OPERATING_YEAR_MONTH: '請求計上月',
  EXPENSE_RECORDING_DATE: '払い計上日',
  EXPENSE_OPERATING_YEAR_MONTH: '支払計上月',
  /** 一覧検索の日付基準切替（VOC_PJ-939 #4387） */
  SEARCH_DATE_BASIS: '検索基準',
  SEARCH_BASIS_DEFAULT: '通常',
  SEARCH_BASIS_INCOME_CLOSING_DATE: '請求月',
  SEARCH_BASIS_EXPENSE_CLOSING_DATE: '支払月',
  SHIPPING_DATE: '発送日',
  // TODO: SHIPPING_DATEは発送日？配送日？配車日?
  SHIPPING_DATE3: '配車日',
  SHIPPING_DATE_FROM: '出荷日(From)',
  SHIPPING_DATE_TO: '出荷日(To)',
  DISPATCH_DATE_FROM: '配車日(From)',
  DISPATCH_DATE_TO: '配車日(To)',
  OUTPUT_UNIT: '出力単位',
  OUTPUT_UNIT_BY_TRUCK: '車両別',
  OUTPUT_UNIT_BY_DRIVER: 'ドライバー別',
  FRAME_LABEL: 'ラベル',
  // 予定枠・空き枠の背景色（VOC_PJ-450 #3830）
  FRAME_BACKGROUND_COLOR: '背景色',
  // 背景色の保存済みパレット（ColorPicker presets）のグループ見出し
  FRAME_COLOR_TONE_LIGHT: '淡い色',
  FRAME_COLOR_TONE_DEEP: '濃い色',
  // 背景色のパレット先頭に固定で出す、枠の種類ごとの標準色（予定枠のグレー・空き時間枠の黄）（VOC_PJ-1072）
  FRAME_COLOR_STANDARD: '標準',
  // 背景色のパレットに出す、最近保存した色（VOC_PJ-1072）
  FRAME_COLOR_RECENT: '最近使った色',
  // 枠の種類ごとの既定の背景色を利用者が決めるボタン（VOC_PJ-1072）
  SET_AS_DEFAULT_FRAME_COLOR: 'この色を既定にする',
  DEFAULT_FRAME_COLOR_SET: '既定の色に設定済み',
  // 淡い色の HEX 配列 FRAME_COLOR_VALUES（libs/api/types/shared/color-type.ts）と同じ並び順。
  // 淡い色は先頭から 20 色（白〜青灰）、濃い色は 2 番目から 20 色（赤〜墨）を同じ順で使う。
  // 画面には表示せず、選択肢の読み上げ用（aria-label）にのみ使う
  FRAME_COLOR_NAMES: [
    '白',
    '赤',
    '桃',
    '紫',
    '濃紫',
    '藍',
    '青',
    '空',
    '水',
    '青緑',
    '緑',
    '若緑',
    '黄緑',
    '黄',
    '山吹',
    '橙',
    '朱',
    '茶',
    '灰',
    '青灰',
    '墨'
  ],
  // 矢羽根編集モーダル(groupモード)の荷主単位一括編集・払い側一括編集セクションの見出し
  BULK_UPDATE: '一括更新',
  // 矢羽根編集モーダル(groupモード)の荷主単位一括編集で使用。SHIPPING_DATE(発送日)とは
  // 字面が異なる短縮表記のため区別して定義する
  SHIPPING_DATE_SHORT: '発日',
  DELIVERY_DATE: '着日',
  DEPARTURE_TIME_RESTRICTION_START: `到着時間制限\n(発地)`,
  // 発地・着地の到着時間制限を開閉するトグルリンクのラベル
  DEPARTURE_ARRIVAL_TIME_RESTRICTION: '発着時間制限',
  // 荷役作業。標準貨物自動車運送約款にもとづく書面化項目。
  // 行見出しに「委託」を含め、チェックボックスは「あり」のみとする
  // （#4938 マツケン確認済み: issuecomment-5435075303）。
  LOADING_WORK: '積込み作業の委託',
  UNLOADING_WORK: '取卸し作業の委託',
  WORK_OUTSOURCED: 'あり',
  // 予定作業時間の入力欄の左に置くラベル（#4938 レビュー指摘: 何の時間か分かるようにする）
  WORK_MINUTES_LABEL: '予定作業時間',
  WORK_MINUTES_UNIT: '分',
  // 荷役作業の備考（#4893）。委託の有無に関わらず入力できる（後述の理由はコンポーネント側）
  WORK_NOTE_LABEL: '備考',
  // TODO: DEPARTURE_TIME_RESTRICTION_START2と統合したほうがよいのでは？
  DEPARTURE_TIME_RESTRICTION_START2: '発時間制限開始',
  DEPARTURE_TIME_RESTRICTION_START3: '発時間制限開始時間',
  SPOT: 'スポット',
  REGULAR: 'レギュラー',
  TIME: '時間',
  TARGET_TRUCK: '対象車両',
  DISPATCH_DETAIL: '配車明細',
  DISPATCH_DETAIL_INFO: '配車情報',
  START: '開始',
  START_TIME: '開始時刻',
  END: '終了',
  END_TIME: '終了時刻',
  ARRIVAL_TIME_RESTRICTION_START: '到着時間制限\n(着地)',
  PACKAGE_CATEGORY: '荷姿',
  ITEM_INFORMATION: '明細情報',
  ITEM_CODE: '品目コード',
  ITEM_NAME: '品目名',
  // TODO: ITEM_NAMEと統合したほうがよさそう
  ITEM_NAME2: '品名',
  PACKAGED_LOAD_QUANTITY: '荷姿単位数量',
  // TODO: 文言＋React.Nodeの形で使っているどのように扱うか要検討
  PACKAGED_LOAD_QUANTITY2: ['荷姿単位', '数量'],
  PACKAGE_QUANTITY: '荷姿数',
  QUANTITY: '数量',
  WEIGHT: '重量',
  WEIGHT_KG: '重量(kg)', // kg単位に統一
  WEIGHT_GTE: '重量(〜以上)',
  WEIGHT_LTE: '重量(〜以下)',
  WEIGHT_MAX_ZERO_OR_LESS: '0t(重量なしも含む)',
  SHIPMENT_ORDER: '配送依頼',
  STATUS: 'ステータス',
  ALL: 'すべて',
  OTHERS: 'その他',
  ONLY_MANUAL: '手入力のみ',
  ONLY_IMPORT: 'インポートのみ',
  ITEM_COUNT: '品目件数',
  HOW_TO_CREATE_SHIPMENT_ORDER: '配送依頼作成方法',
  NAME: '名称',
  NAME_KANA: '名称（かな）',
  BASIC_INFO: '基本情報',
  DISPLAY_INFO: '表示情報',
  OTHER_SETTINGS_INFO: 'その他の設定情報',
  COMPANY_INFO: '会社情報',
  COMPANY_NAME: '会社名',
  PARTNER_DELIVERY: '配送業者',
  PARTNER_NAME: 'パートナー名',
  PARTNER_NAME_KANA: 'パートナー名（かな）',
  PARTNER_CODE: 'パートナーコード',
  OFFICE_NAME: '事業所名',
  DEPARTMENT_NAME: '部署名',
  FAX_NUMBER: 'FAX番号',
  EMAIL: 'メールアドレス',
  MANAGEMENT_PRICE: '管理料',
  // TODO: ラベル＋UnitLabelの形に置き換える
  MANAGEMENT_PRICE_YEN: '管理料(円)',
  MANAGEMENT_FEE: '管理費',
  PARTNER_ROLE_MANAGER: '管理者',
  PARTNER_ROLE_STAFF: '担当者',
  PARTNER_ROLE_DRIVER: 'ドライバー',
  PARTNER_TYPE_IN_HOUSE: '自社',
  PARTNER_TYPE_CONTRACTOR: '契約業者',
  BANK_INFO: '振込先情報',
  BANK_NAME: '銀行名',
  DESTINATION_BANK_NAME: '振込先銀行名',
  BANK_CODE: '銀行コード',
  DESTINATION_BANK_CODE: '振込先銀行コード',
  BANK_BRANCH_NAME: '支店名',
  // TODO: BANK_BRANCH_NAMEと統合したほうがよさそう？
  //       BANK_BRANCH_NAME2と分けて使うなら振込先がつく方にTRANSFER_等を付ける
  BANK_BRANCH_NAME2: '支店名',
  BANK_BRANCH_CODE: '支店コード',
  BANK_ACCOUNT_NAME: '口座名',
  // TODO: BANK_ACCOUNT_NAMEと統合したほうがよさそう？
  BANK_ACCOUNT_NAME2: '口座名',
  BANK_ACCOUNT_NUMBER: '口座番号',
  // TODO: BANK_ACCOUNT_NUMBERと統合したほうがよさそう？
  BANK_ACCOUNT_NUMBER2: '口座番号',
  BANK_ACCOUNT_TYPE: '口座種別',
  DESTINATION_BANK_ACCOUNT_TYPE: '振込先口座種別',
  BANK_ACCOUNT_TYPE_SAVINGS: '普通',
  BANK_ACCOUNT_TYPE_CHECKING: '当座',
  ENVIRONMENT_SETTING: '環境設定',
  ADDRESS_INFO: '住所情報',
  ADDRESS: '住所',
  POSTAL_CODE: '郵便番号',
  PREFECTURE: '都道府県',
  CITY: '市区町村',
  CITY_NAME: '市区町村名',
  BLOCK_NUMBER: '丁目/番地/号',
  BLOCK_NAME_AND_NUMBER: '丁名・番地',
  BUILDING_NAME: '建物名',
  BUILDING_NAME_AND_ROOM_NUMBER: '建物名・部屋番号',
  SITE: '車庫',
  AREA_WITH_PARENTHESES: '（エリア）',
  SUB_PARTNER_NAME: '運送会社名',
  ACTUAL_SUB_PARTNER_NAME: '実運送会社名',
  INVOICE_REGISTRATION_NUMBER: 'インボイス登録番号',
  CHANGE_HISTORY: '変更履歴',
  UPDATED_TYPE: '更新種別',
  BEFORE_UPDATE: '更新前',
  AFTER_UPDATE: '更新後',
  EDIT_REASON_COMMENT: '修正理由・コメント',
  APPLY_START_DATE: '適用開始日',
  APPLY_END_DATE: '適用終了日',
  START_DATE: '開始日',
  END_DATE: '終了日',
  LAST_UPDATED_AT: '最終更新日時',
  START_AT: '開始日時',
  WORK_START_AT: '業務開始日時',
  WORK_START_AT_FIXED: '業務開始日時(修正)',
  END_AT: '終了日時',
  WORK_END_AT: '業務終了日時',
  WORK_END_AT_FIXED: '業務終了日時(修正)',
  WORK_TIME: '業務時間',
  TOTAL_WORK_TIME: '合計業務時間',
  OVERTIME: '超過時間',
  NIGHT_TIME: '深夜時間',
  BASE_HOURS: '基本時間',
  MIN_HOURS: '下限時間',
  OVERTIME_ROUND: '超過時間の切り上げ・切り捨て',
  NIGHT_TIME_ROUND: '深夜時間の切り上げ・切り捨て',
  EXCESS_DISTANCE_ROUND: '超過距離の切り上げ・切り捨て',
  OVERTIME_ADJUSTMENT_TIME: '超過時間の調整時間',
  ADJUSTMENT_TIME: '調整時間',
  DEPARTING_TIME: '出時間',
  ENTRANCE_TIME: '入時間',
  REGULAR_GROUP_MARK: '[定]',
  PIN_ROW: 'ピン止め',
  UNPIN_ROW: 'ピン止めを解除',
  OPERATED_AT: '操作日時',
  OPERATOR: '操作ユーザ',
  TARGET_TRUCK_NAME: '対象車両名',
  OPERATION_TYPE: '操作種別',
  BEFORE_OPERATION: '操作前',
  AFTER_OPERATION: '操作後',
  ADDING_DISPATCH: '運行情報追加',
  UPDATING_DISPATCH: '運行情報更新',
  DELETING_DISPATCH: '運行情報削除',
  SWAPPING_DISPATCH: '運行情報入れ替え',
  UPDATING_STATUS_DISPATCH: '車両ステータス更新',
  ADDING_DISPATCH_DETAIL: '配車情報追加',
  UPDATING_DISPATCH_DETAIL: '配車情報更新',
  DELETING_DISPATCH_DETAIL: '配車情報削除',
  EXPORTING_DISPATCH_RESULT_REPORT: '帳票ダウンロード',
  DISPATCH_RESULT_REPORT_FORMAT: '帳票フォーマット',
  TYPE: '種別',
  LABEL: 'ラベル',
  TRUCK: '車両',
  DRIVER: 'ドライバー',
  OPERATION_DATE: '運行日',
  RECORDING_DATE: '計上日',
  TRUCK_AND_DRIVER: '車両/ドライバー',
  SORT_ORDER: '並び順',
  // #4609 VOC_PJ-970-1: 配送依頼ドロワーの並び替え
  DRAWER_SORT_KEY_ORDER_NO: '配送依頼No',
  DRAWER_SORT_KEY_CREATED_AT: '作成日時',
  DRAWER_SORT_KEY_UPDATED_AT: '更新日時',
  DRAWER_SORT_DISABLED_BY_DEPARTURE_TIME_RESTRICTION:
    '出発時間制限で絞り込んでいる間は、時間制限の並びが優先されます',
  SORT_KEY_PROMPT: 'ソートキー:',
  // #4488 VOC_PJ-948: 配送依頼ドロワーの「配車済みを表示しない」
  DRAWER_HIDE_DISPATCHED: '配車済みを表示しない',
  DRAWER_DISPATCHED_SECTION_HEADING: '配車済み',
  SORT_KEY_TRUCK_NAME: '車両名称',
  SORT_KEY_TRUCK_CLASS: '車格',
  SORT_KEY_TRUCK_ATTRIBUTE: '車両属性',
  SORT_KEY_PARTNER_NAME: 'パートナー名称',
  SORT_KEY_SUB_PARTNER: '運送会社',
  SORT_KEY_MAX_LOAD_CAPACITY: '最大積載量',
  SORT_KEY_MASTER_ORDER: 'マスタ画面の並び',
  TOUR: '運行実績',
  TOUR_CHANGE: '運行実績の修正',
  SYA_DATE: '車建・運行建実績',
  UNIT_OF_CALCULATION: '計算単位',
  UNIT_PRICE: '単価',
  TRUCK_RATE_DETAILS: '車両別明細',
  SITE_CODE: '地点コード',
  SITE_NAME: '地点名',
  SITE_DISPLAY_NAME_LONG: '正式名称（長）',
  SITE_DISPLAY_NAME_SHORT: '短名称',
  SITE_DISPLAY_NAME_MIDDLE: '中名称',
  SITE_DISPLAY_MODE_NAME: '地点名',
  SITE_DISPLAY_MODE_ADDRESS: '住所',
  DRAWER_DATE_SYNC: '日付連動',
  USE_SITE_MIDDLE_NAME: '地点の中表示を使用する',
  WEIGHT_DISPLAY_FORMAT: '荷物重量の表示形式',
  WEIGHT_DISPLAY_FRACTION_DIGITS_INTEGER: '整数',
  WEIGHT_DISPLAY_FRACTION_DIGITS: (digits: number) => `小数第${digits}位まで`,
  EXAMPLE_PREFIX: '例: ',
  FULL_WIDTH_PARENTHESES: (value: string) => `（${value}）`,
  START_SITES: '開始地点',
  ADDITIONAL_SITES: '追加配送地点',
  DESTINATION_SITES: '配送先地点',
  ADDITIONAL_DELIVERY_DC: '追加配送拠点',
  ADDITIONAL_DELIVERY_SITES: '追加配送地点',
  ADDITIONAL_DELIVERY_SITES_WITH_CODE_AND_NAME: '(コード/名称)',
  ADDITIONAL_DELIVERY_FARE_YEN: '追加配送運賃(円)',
  DESTINATION_SITE_TYPE: '配送先地点種別',
  DESTINATION_SITE_TYPE_EVERY: '全てを含む',
  DESTINATION_SITE_TYPE_SOME: 'いずれかを含む',
  LOCATION_AREA_CODE: '地点・エリアコード',
  LOCATION_AREA_NAME: '地点・エリア名',
  LOCATION_AREA: '地点・エリア',
  SITE_COUNT_UNIT: '地点',
  // 束ねの複数依頼選択モーダル: 合計から外している件数の見出し
  EXCLUDED: '除外',
  PACKAGE_CATEGORY_INFO: '荷姿情報',
  PACKAGE_COUNT: '荷姿数',
  DISTANCE: '走行距離',
  BASE_DISTANCE: '基本距離',
  EXCESS_DISTANCE: '超過距離',
  EXCESS_DISTANCE_KM: '超過距離(km)',
  CONTRACT_TYPE: '契約種別',
  CONTRACT_NAME: '契約名',
  CONTRACT_NUMBER: '契約番号',
  CONTRACT_INFO: '契約情報',
  UNIT_PRICE_DETAILS: '単価明細',
  APPLY_PERIOD: '適用期間',
  SUBTOTAL: '小計',
  // #3865: 運行実績追加フォームの運賃＋付帯費用の合計表示
  SUBTOTAL_EXCLUDING_TAX: '小計（税抜）',
  TOTAL_INCLUDING_TAX: '合計（税込）',
  GROSS_PROFIT: '粗利',
  // TODO: ラベル＋UnitLabelの形に置き換える
  GROSS_PROFIT_YEN: '粗利(円)',
  BASE_PRICE: '基本単価',
  // TODO: ラベル＋UnitLabelの形に置き換える
  BASE_PRICE_YEN: '基本単価(円)',
  CHARGE_AMOUNT: '請求額',
  // 矢羽根編集モーダル(groupモード)の荷主単位一括編集: 請求額(基本運賃income)の一括按分入力欄見出し
  CHARGE_AMOUNT_TOTAL_INPUT: '請求額(合計)',
  BASIC_CHARGE_AMOUNT: '基本請求額',
  // TODO: ラベル＋UnitLabelの形に置き換える
  BASIC_CHARGE_AMOUNT_YEN: '基本請求額(円)',
  OTHER_CHARGE_AMOUNT: 'その他請求額',
  // TODO: ラベル＋UnitLabelの形に置き換える
  OTHER_CHARGE_AMOUNT_YEN: 'その他請求額(円)',
  ADDITIONAL_CHARGES_AMOUNT: '追加請求額',
  // TODO: ラベル＋UnitLabelの形に置き換える
  ADDITIONAL_CHARGE_AMOUNT_YEN: '追加請求額(円)',
  ADDITIONAL_CHARGES_AMOUNT_TOTAL: '追加請求額合計',
  CHARGE: '請求金額',
  // TODO: ラベル＋UnitLabelの形に置き換える
  TOTAL_CHARGES_AMOUNT: '合計請求額',
  TOTAL_CHARGES_AMOUNT_YEN: '合計請求額(円)',
  TOTAL_AMOUNT_EXCLUDING_TAX_YEN: '税抜合計(円)',
  FARE_YEN: '運賃(円)',
  BASIC_FARE: '基本運賃',
  TOTAL_FARE: '合計運賃',
  // TODO: ラベル＋UnitLabelの形に置き換える
  TOTAL_FARE_YEN: '合計運賃(円)',
  PAYMENT_DUE_DATE: '支払期限日',
  ADDITIONAL_PAYMENTS_FARE: '追加支払運賃',
  ADDITIONAL_PAYMENTS_FARE_TOTAL: '追加支払運賃合計',
  ADDITIONAL_WORK: '追加業務',
  ADDITIONAL_WORK_FARE: '追加業務運賃',
  ADDITIONAL_DELIVERY_PAYMENTS_FARE: '追加配送運賃',
  PREMIUM_YEN: '割増(円)',
  OVERTIME_PREMIUM: '超過時間割増',
  NIGHT_TIME_PREMIUM: '深夜時間割増',
  EXCESS_DISTANCE_PREMIUM: '超過距離割増',
  TEMPORARY_SERVICE: '臨時運行',
  EDIT_REASON: '修正理由',
  SUGGESTION_FOR_UPDATE_STATUS: 'ステータス変更の提案',
  SCHEDULE: '予定',
  FREE_TIME: '空き時間',
  PALLET: 'パレット',
  SHIPMENT_INFO: '配送情報',
  SHIPMENT_ROUTE: '配送ルート',
  SHIPMENT_ROUTE_DC: (x: number) => `配送ルート（${x}拠点）`,
  FILE: 'ファイル',
  EVIDENCE_FILE: '証跡ファイル',
  STATUS_CHANGE: 'ステータス変更',
  STATUS_REJECTION: 'ステータス差し戻し',
  STATUS_REJECTION_COMMENT: 'ステータスの差戻しコメント',
  REJECTION_REASON: '差し戻し理由',
  TOTAL_WEIGHT: '合計重量',
  DAILY_REPORT_NO: '日報番号',
  STATUS_UPDATE: 'ステータスの更新',
  SELECTABLE_STATUSES: '選択可能なステータス',
  ROUND_TYPE: '端数処理',
  CAUTION: '注意',
  FIX: '修正',
  AMOUNT_YEN: '金額',
  DASHBOARD: 'ダッシュボード',
  TOUR_PENDING_TASK: '運行実績のあなたの残作業',
  MONTHLY_REPORT_LINK: (item: string) => `${item}の月次支払レポート`,
  PAYMENT_AMOUNT: '支払額',
  TOTAL_PAYMENT_AMOUNT: '支払金額合計',
  BASIC_PAYMENT_AMOUNT_YEN: '基本支払額(円)',
  PREMIUM_PAYMENT_AMOUNT: '割増支払額',
  PREMIUM_PAYMENT_AMOUNT_YEN: '割増支払額(円)',
  TOTAL_PAYMENT_AMOUNT_YEN: '支払額合計(円)',
  PREMIUM_CHARGE_AMOUNT_YEN: '割増請求額(円)',
  TOTAL_CHARGE_AMOUNT: '請求額合計',
  TOTAL_CHARGE_AMOUNT_YEN: '請求額合計(円)',
  // TODO: 粗利の計算の表示は必要であれば粗利と分けて計算だけ定数化したほうが良い
  TOTAL_INVOICED_TOTAL_PAID_GROSS_PROFIT: '粗利（合計請求額 - 合計支払額）',
  // TODO: 粗利の計算の表示は必要であれば粗利と分けて計算だけ定数化したほうが良い
  INVOICED_PAID_GROSS_PROFIT: '粗利（請求額 - 支払額 ）',
  // TODO: 意味合いとしてはTOTAL_CHARGES_AMOUNTと同じように見えるが統合できる？
  TOTAL_BILLING_AMOUNT: '請求金額合計',
  TRADING_SUSPENDED: '（取引停止中）',
  BILLING_REPORT_INFORMATION: '請求レポート情報',
  TOUR_YEAR_MONTH: '運行年月',
  RECORDING_YEAR_MONTH: '計上年月',
  // #4421 レポートの日付範囲検索
  SEARCH_BY_MONTH: '月単位',
  SEARCH_BY_DATE_RANGE: '日付範囲',
  MONTHLY_ADJUSTMENT_TOTAL_YEN: '月次調整(円)',
  DAILY_ADDITIONAL_CHARGE_AMOUNT: '日次追加請求額',
  MONTHLY_ADDITIONAL_CHARGE_AMOUNT: '月次追加請求額',
  ADDITIONAL_ITEMS: '追加項目',
  PACKAGE_CATEGORY_CODE: '荷姿コード',
  PACKAGE_CATEGORY_NAME: '荷姿名',
  PACKAGE_CATEGORY_SHORT_NAME: '荷姿短縮名',
  CUSTOMER_CODE: '荷主コード',
  CUSTOMER_NAME: '荷主名',
  CUSTOMER_NAME_KANA: '荷主名(かな)',
  SUBCONTRACT_FEE_BILLABLE: '下請手数料の請求',
  PARTNER_CONFIRMING: 'パートナー作成中',
  PARTNER_RECONFIRMING: 'パートナー再確認',
  DC_CONFIRMING: '確認待ち',
  DC_RECONFIRMING: 'センター再確認',
  DC_FINAL_CONFIRMING: 'センター最終確認待ち',
  DC_CONFIRMED: '確認済',
  PARTNER_CONFIRM: 'パートナー確認',
  DC_CONFIRM: 'センター確認',
  DC_FINAL_CONFIRM: 'センター最終確認',
  BILLING_STATUS: '請求ステータス',
  BILLING_STATUS_UNSET: '-',
  TOUR_CONFIRMED_BILLING_STATUS: '運行実績確定済み',
  FIRST_APPROVAL_PENDING_BILLING_STATUS: '一次承認待ち',
  FIRST_APPROVED_BILLING_STATUS: '一次承認済み',
  FINAL_APPROVED_BILLING_STATUS: '最終承認済み',
  TOUR_COUNT: '運行件数',
  // TODO: TOUR_COUNTと統合したほうがよい？
  TOUR_COUNT3: '運行実績件数',
  UNCONFIRMED_COUNT: '未確認件数',
  TOUR_CONFIRMATION_STATUS: '運行実績の確定状況',
  UNCONFIRMED_TOUR_DATES: '未確定の運行日数',
  MONTHLY_REPORTS_ALL_FINALIZE: '月次レポート一括確定',
  TRUCK_CLASS_AND_TYPE: '車格・車両属性',
  TRUCK_CLASS_NAME: '車格名称',
  TRUCK_CLASS_CODE: '車格コード',
  INVOICE: '御請求書',
  BILL: '請求書',
  INVOICE_AMOUNT: 'ご請求額',
  BREAKDOWN_STATEMENT: '内訳明細',
  SUBJECT: '件名',
  ATTENTION: '御中',
  MANAGEMENT_NO: '管理No.',
  BILLING_DATE: '請求日',
  TRANSFER_DESTINATION: 'お振込先',
  TRANSFER_DEADLINE: 'お振込期限',
  TRANSFER_FEE: 'お振込手数料',
  REGISTRATION_NUMBER: '登録番号',
  LAST_UPDATED_BY: '最終更新者',
  EMPTY: '-',
  ALL_SCHEDULES: '全ての予定',
  ONLY_THIS_SCHEDULE: 'この予定',
  DAILY_REPORTS_CONFIRMED_PROGRESS: '確定状況',
  TIME_DISTANCE_LATE_NIGHT: '時間・距離・深夜',
  TOTAL_UNIT_PRICE: '単価合計',
  TOTAL: '合計',
  UNIT: '単位',
  TAX_CATEGORY: '税区分',
  DEFAULT_TAX_CATEGORY: 'デフォルト税区分',
  // VOC_PJ-566,900 #4037 荷主マスタの自己参照FK（請求先荷主）
  BILLING_SHIPPER: '請求先荷主',
  // VOC_PJ-844 #3624 税計算方式（外税/内税）
  TAX_INCLUSIVE_CATEGORY: '税計算方式',
  // VOC_PJ-844 拠点マスタ（IN_HOUSE）向け: デフォルト税計算方式
  DEFAULT_TAX_INCLUSIVE_CATEGORY: 'デフォルト税計算方式',
  // 荷主マスタが持つ荷役作業の既定値（#4741）。配送依頼の作成時に初期表示する
  DEFAULT_LOADING_WORK: 'デフォルト積込み作業の委託',
  DEFAULT_UNLOADING_WORK: 'デフォルト取卸し作業の委託',
  WORK_DEFAULT_UNSET_RADIO_LABEL: '設定しない',
  WORK_OUTSOURCED_NONE_RADIO_LABEL: 'なし',
  WORK_OUTSOURCED_YES_RADIO_LABEL: 'あり',
  // VOC_PJ-844 会計情報セクション見出し（拠点/荷主マスタ共通: 税計算〜計上基準等）
  ACCOUNTING_INFO: '会計設定',
  // #4274: 月次レポート専用の税計算設定（税計算 一括/個別 + 端数処理）を開閉するトグルリンクのラベル。
  // 税メタの「端数処理（デフォルト）」と別物であることを明示するため月次レポートを冠する
  MONTHLY_REPORT_TAX_CALCULATION_SETTINGS: '月次レポート税計算設定',
  // #4274: 税メタカスケード用の端数処理デフォルト（拠点=終端必須 / 荷主=null で拠点継承）
  DEFAULT_ROUND_TYPE: 'デフォルト端数処理',
  // VOC_PJ-844 #3946: 画面表示文言を 外税→税抜 / 内税→税込 に変更
  TAX_EXCLUSIVE: '税抜',
  TAX_INCLUSIVE: '税込',
  // VOC_PJ-844 マスタ画面ラジオ向け（#3946: 文言を 税抜/税込 に統一。旧「外税（税抜）/内税（税込）」併記は廃止）
  TAX_EXCLUSIVE_RADIO_LABEL: '税抜',
  TAX_INCLUSIVE_RADIO_LABEL: '税込',
  // VOC_PJ-844 #3874: 荷主(取引先)マスタの税デフォルトは null で拠点マスタ既定を継承する。
  // 内税の 3 択ラジオ／税区分プルダウンの「継承」選択肢ラベルとして共用。
  // 文言は請求計上基準の RECORDING_DATE_TYPE_FOLLOW_DC と揃える（#3874）。
  TAX_FOLLOW_BASE_RADIO_LABEL: '拠点設定に従う',
  INCOME_RECORDING_DATE_TYPE: '請求計上基準',
  EXPENSE_RECORDING_DATE_TYPE: '払い計上基準',
  RECORDING_DATE_TYPE_SHIPPING: '発日',
  RECORDING_DATE_TYPE_DELIVERY: '着日',
  RECORDING_DATE_TYPE_FOLLOW_DC: '拠点設定に従う',
  CONSUMPTION_TAX: '消費税',
  TAX_AMOUNT: '税額',
  TAX_AMOUNT_INCLUDED: 'うち税額',
  TAX_AMOUNT_YEN: '税額(円)',
  TOTAL_TAX_AMOUNT: '合計税額',
  AMOUNT_EXCLUDING_TAX: '金額（税抜）',
  UNIT_PRICE_EXCLUDING_TAX: '単価（税抜）',
  INCLUDED_TAX: '（税込）',
  EXCLUDED_TAX: '（税抜）',
  // VOC_PJ-29,431 #1857: 配送依頼の付帯費用 3 状態 (PricingMode) UI 用ラベル
  INCLUDED_IN_FARE: '運賃込み',
  NOT_APPLICABLE: '該当なし',
  /** 配送依頼編集モーダル: 請求側附帯費用セクションタイトル (対 荷主) */
  SHIPMENT_ORDER_ADDITIONAL_CHARGES: '請求側附帯費用',
  /** 配送依頼編集モーダル: 支払側附帯費用セクションタイトル (対 パートナー) */
  SHIPMENT_ORDER_ADDITIONAL_PAYMENTS: '支払側附帯費用',
  /** 荷主マスタ詳細: デフォルト附帯費用項目セクション */
  DEFAULT_ADDITIONAL_PAYMENT_CATEGORIES: 'デフォルト附帯項目',
  TOTAL_PREMIUM_AND_ADDITIONAL_WORK_FARES: '割増・追加業務運賃合計',
  EXCESS_FARE: '超過運賃',
  ADDITIONAL_FARE: '追加運賃',
  SUBTOTAL_FARE: '運賃小計',
  ADDITIONAL_PAYMENT: '追加料金',
  PREVIOUS_MONTH_ADJUSTMENT: '前月調整',
  ADDITIONAL_PAYMENT_AND_PREVIOUS_MONTH_ADJUSTMENTS: '追加料金・前月調整',
  TOTAL_BASE_PRICE: '基本単価合計',
  TOTAL_ADDITIONAL_PAYMENTS: '追加料金・前月調整合計',
  HIGHWAY_CHARGES: '高速道路料金',
  PARKING_CHARGES: '駐車料金',
  OTHER_CHARGES: 'その他料金',
  PREVIOUS_MONTH_FARE_ADJUSTMENT: '前月運賃の調整金額',
  PREVIOUS_MONTH_CHARGES_ADJUSTMENT: '前月料金の調整金額',
  // TODO: HIGHWAY_CHARGES_DETAIL / PARKING_CHARGES_DETAIL / OTHER_CHARGES_DETAIL/ PREVIOUS_MONTH_FARE_ADJUSTMENT_DETAIL
  //       + ATTACHED_FILESでLABELとして渡されているがどう設定したほうが良いか
  HIGHWAY_CHARGES_DETAIL: '高速道路料金の',
  PARKING_CHARGES_DETAIL: '駐車料金の',
  OTHER_CHARGES_DETAIL: 'その他料金の',
  PREVIOUS_MONTH_FARE_ADJUSTMENT_DETAIL: '前月運賃調整の',
  ATTACHED_FILE: '添付ファイル',
  // TODO: ラベル＋UnitLabelの形に置き換える
  TOTAL_BASE_PRICE_YEN: '基本単価合計(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  NIGHT_TIME_YEN: '深夜時間(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  OVERTIME_YEN: '超過時間(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  EXCESS_DISTANCE_YEN: '超過距離(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  ADDITIONAL_WORK_YEN: '追加業務(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  SUBTOTAL_FARE_YEN: '運賃小計(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  HIGHWAY_YEN: '高速道路(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  PARKING_YEN: '駐車(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  OTHER_YEN: 'その他(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  CHARGES_ADJUSTMENT_YEN: '料金調整(円)',
  // TODO: ラベル＋UnitLabelの形に置き換える
  FARE_ADJUSTMENT_YEN: '運賃調整(円)',
  RELATED_CUSTOMERS: '関連荷主',
  /** 地点編集/新規作成モーダルの荷主関連付けチェックボックス欄のラベル（#3669）。地点マスタの既存フィールド「関連荷主」（RELATED_CUSTOMERS）とは別物 */
  CUSTOMER_SITE_GROUP_LINK: '荷主関連付け',
  SEARCH_SETTINGS: '検索設定',
  CONTRACT_SETTINGS: '契約設定',
  SITE_WITHOUT_AREA: '地点',
  RECOMMENDED_SITES: '関連地点',
  ALL_SITES: 'すべて',
  FILE_NAME: 'ファイル名',
  UPLOADED_AT: 'アップロード日時',
  UPLOADED_BY: 'アップロード者',
  PROCESSING_STARTED_AT: '処理開始日時',
  PROCESSING_COMPLETED_AT: '処理完了日時',
  ERROR_DETAILS: 'エラー詳細',
  UNIT_NAME: '単位名',
  TRUCK_TYPE_NAME: '車両属性名称',
  TRUCK_TYPE_CODE: '車両属性コード',
  TOTAL_PACKAGE_COUNT: '合計荷姿数',
  TOTAL_INCOME: '合計請求運賃',
  EXPENSE: '払い',
  EXPENSE_FARE: '払い運賃',
  EXPENSE_FARE_YEN: '払い運賃（円）', // TODO: ラベル＋UnitLabelの形に置き換える
  // 矢羽根編集モーダルのgroupモード(親矢羽根一括編集)。払い運賃は矢羽根ごとの合計を read-only 表示する
  EXPENSE_FARE_TOTAL: '合計払い運賃',
  CHARGE_TYPE: '運賃種別',
  TRUCK_OWNER: '車両種別',
  CONTRACTORS_TRUCK: 'パートナー',
  TRUCK_IN_HOUSE: '自車',
  MAX_LOADING_CAPACITY_TON: '最大積載量(t)', // TODO: ラベル＋UnitLabelの形に置き換える
  GROUP_SEARCH: 'グループ検索',
  SEARCH: '検索',
  // #3971: 運行実績一覧の検索欄トグル・合計サマリー
  SEARCH_CONDITIONS: '検索条件',
  DETAIL_CONDITIONS: '詳細条件',
  FARE_TOTAL: '運賃合計',
  INCOME_TOTAL: '請求合計',
  EXPENSE_TOTAL: '支払合計',
  TAX_BREAKDOWN_OF: (fareLabel: string) => `${fareLabel}の税額内訳`,
  // #6010: 運行実績詳細の運賃合計（明細表）の列見出し。料金区分は 税込／税抜、税区分は税区分マスタの名前
  FARE_SUMMARY_ITEM: '項目',
  FARE_SUMMARY_DESCRIPTION: '摘要',
  FARE_SUMMARY_PRICE: '料金',
  FARE_SUMMARY_PRICE_TYPE: '料金区分',
  // #6010: 運賃合計の基本運賃・基本請求額の行の摘要
  FARE_SUMMARY_BASE_DESCRIPTION: '運賃',
  MAX_SEARCH_TAGS: (max: number) => `最大${max}件まで`,
  MIXED_PACKAGE: '荷姿混載',
  MAXIMUM: '最大',
  HIGHLIGHT_FIRST: (items: string[]) => `${items[0]} 他 ${items.length - 1} 件`,
  TIME_RESTRICTION: '時間制限',
  DC_ROLE_MANAGER: '責任者',
  DC_ROLE_STAFF: '担当者',
  // #5598: 拠点ユーザ画面で親「拠点」の直下に入れ子で出す子ラベル。親と重なる「拠点」を省き、
  // 隣の「操作権限」とそろえて中身（その拠点を管理できるか＝拠点マネージャーか）で呼ぶ
  DC_ROLE_PERMISSIONS: '管理権限',
  DC_MANAGER: '拠点マネージャー',
  PMS_INVOICE_PAYMENT_UPDATE: '請求支払更新',
  PMS_ACHIEVEMENTS_EDIT: '実績編集',
  PMS_DAILY_APPROVAL: '日次承認',
  PMS_MONTHLY_FINAL_APPROVAL: '月次最終承認',
  PMS_PARTNER_BILLING_BASE: 'パートナー請求基本',
  USER_TYPE_OWNER: 'テナントユーザー',
  USER_TYPE_PARTNER: 'パートナーユーザー',
  USER_ROLE_ADMIN: '管理者ユーザー',
  USER_ROLE_GENERAL: '一般ユーザー',
  USER: 'ユーザー',
  PERFORMANCE_MANAGEMENT_AUTHORITY: '実績収支管理権限',
  PARTNER_USER: 'パートナーユーザー',
  DC_USER: '拠点ユーザー',
  PMS_BUSINESS_MASTER_ROLE: '業務マスタ管理権限',
  PMS_USER_MANAGEMENT_ROLE: 'ユーザ管理権限',
  PMS_PERFORMANCE_MANAGEMENT_ROLE: '実績収支管理権限',
  PMS_ROLE_PERMISSIONS: '実績収支管理ロール別権限',
  // #5598: 拠点ユーザ画面では「実績収支管理権限」の行の直下に入れ子で出すため、親と重なる「実績収支管理」を省く。
  // 兄弟の「拠点ロール」（拠点マネージャー / 担当者）と意味の違う「ロール」も使わず、中身（拠点ごとにできる操作）で呼ぶ。
  // パートナーユーザ画面は入れ子にしていないので PMS_ROLE_PERMISSIONS のまま
  NESTED_PMS_ROLE_PERMISSIONS: '操作権限',
  // #5598: 権限設定の親子関係をスクリーンリーダーに伝えるための sr-only 接尾辞。
  // 「{親ラベル}の子設定: 」の形で子権限行のラベル先頭に読み上げられる
  NESTED_CHILD_OF_SUFFIX: 'の子設定: ',
  COUNT: '件数',
  ROLLED_BACK_AT: '取り消し日時',
  ROLLED_BACK_USER: '取り消し者',
  TENANT: 'テナント',
  TENANT_INFO: 'テナント情報',
  TENANT_KEY: 'テナント識別子(URL Safe な文字列)',
  TENANT_NAME: 'テナント名',
  IS_USING_TMS: 'TMS利用フラグ',
  DC_INFO: '拠点(DC)情報',
  DC_CODE: '拠点コード',
  DC_NAME: '拠点名',
  PASSWORD: 'パスワード',
  OR: 'または',
  OKTA_SSO: 'okta（sso）',
  OTHER_OKTA_LOGIN: 'okta以外のログインはこちら',
  ROLE: '権限',
  COMPANY_INFO_FOR_PARTNER: '会社情報(パートナー向け)',
  COMPANY_INFO_FOR_DC: '会社情報(DC向け)',
  DAILY: '日次',
  MONTHLY: '月次',
  DAILY_MONTHLY: '日次・月次',
  LABEL_NAME: '項目名',
  DEFAULT_DISPLAY_MONTHLY_TOUR_REPORT: 'デフォルト表示（月次支払レポート）',
  // TODO: DEFAULT_DISPLAY_MONTHLY_TOUR_REPORTと統合したほうがよさそう
  DEFAULT_DISPLAY_MONTHLY_REPORT: 'デフォルト表示（月次レポート）',
  // VOC_PJ-865 #3819: 追加運賃項目マスタの「運賃込みデフォルト」フラグ用ラベル
  FARE_INCLUDED_BY_DEFAULT: '運賃込みデフォルト',
  // VOC_PJ-618 #5273: 追加運賃項目マスタの「合計運賃から除外」フラグ用ラベル
  EXCLUDED_FROM_TOTAL: '合計運賃から除外',
  // VOC_PJ-1070 #5755: 追加運賃項目マスタの「帳票に税込で印字する」フラグ用ラベル
  REPORT_AMOUNT_TAX_INCLUDED: '帳票に税込で印字する',
  DISPLAY: '表示',
  HIDDEN: '非表示',
  TAXATION: '課税',
  NON_TAXATION: '非課税',
  TAX_RATE: '税率',
  TAX_CATEGORY_LEGACY: '税区分（旧）',
  INVOICE_CATEGORY: 'インボイス区分',
  INVOICE_CATEGORY_TAXABLE: '課税（標準）',
  INVOICE_CATEGORY_NON_TAXABLE: '非課税',
  INVOICE_CATEGORY_NOT_TAXABLE: '不課税',
  INVOICE_CATEGORY_EXEMPT: '免税',
  ROUNDING_UP_DOWN: '切り上げ・切り捨て',
  ROUND_UP: '切り上げ',
  ROUND_DOWN: '切り捨て',
  ROUND_HALF_UP: '四捨五入',
  ROUND_TYPES_LABEL: '切り上げ・切り捨て・四捨五入',
  BULK_CALCULATION: '一括計算',
  INDIVIDUAL_CALCULATION: '個別計算',
  TAX_CALCULATION: '税計算',
  TAX_CALCULATION_METHOD_SELECT: '税計算方式を選択',
  // Boolean選択肢用
  EXISTS: 'あり',
  NOT_EXISTS: 'なし',
  // タグ用
  REQUIRED: '必須',
  // 選択状態表示用
  ITEMS_SELECTED_SUFFIX: `件を
選択中`,
  // 集計表示用
  COUNT_UNIT: '件',
  SEARCH_RESULT_TOTAL_ARIA_LABEL: '検索結果 合計 {count}件',
  // PARTNER_ROLE_MANAGERをこちらに統合したほうがよさそう？
  MANAGER: '管理者',
  OLD_CLOSING_DATE: '旧締日',
  NEW_CLOSING_DATE: '新締日',
  NEW_CLOSING_DATE_APPLICABLE_DATE: '新締日適用日',
  CLOSING_DATE: '締日',
  SHIPPING_DATES: '出荷日',
  DELIVERY_DATES: '納品日',
  OPERATING_DATE: '適用日',
  DISPATCHED_COUNT: '配車件数',
  DC_PRE_ENTRY: 'センター事前入力',
  PARTNER_PENDING: 'パートナー確認中',
  // TODO: DC_CONFIRMINGと統合できそう？
  DC_PENDING: '確認待ち',
  CONFIRMED: '確定済',
  END_OF_MONTH: '月末',
  CURRENT_CLOSING_DATE: '現在の締日',
  CLOSING_DATE_FOR_PLANNED_CHANGES: '変更予定の締日',
  EFFECTIVE_DATE_FOR_PLANNED_CHANGES: '変更適用予定日',
  TOUR_IMPORT_HISTORY: '運行実績のインポート履歴',
  SHIPMENT_ORDER_IMPORT_HISTORY: '配送依頼のインポート履歴',
  DISPATCH: '配車依頼',
  OPERATION_CONFIRMATION_REPORT: '運行確定を報告',
  NEW_CLOSING_DATE_EFFECTIVE_START_DATE: '新締日適用開始日',
  MONTH_END_CLOSING: '月末締め',
  DATE_END_CLOSING: '日締め',
  SUBCONTRACTING_HIERARCHY: '請負階層',
  ONE_PARTNER_CONTRACTOR: '1次請け',
  TWO_SUB_PARTNER: '2次請け',
  THREE_SUB_PARTNER: '3次請け',
  FOUR_SUB_PARTNER: '4次請け',
  FIVE_SUB_PARTNER: '5次請け',
  SIX_SUB_PARTNER: '6次請け',
  SEVEN_SUB_PARTNER: '7次請け',
  EIGHT_SUB_PARTNER: '8次請け',
  NINE_SUB_PARTNER: '9次請け',
  TRANSPORT_REQUEST_TWO_LOCATIONS: '輸送依頼書二箇所',
  VEHICLE_NUMBER_LIST: '車番連絡表',
  FORMAT: 'フォーマット',
  TARIFF_TYPE_WEIGHT: '重量',
  TARIFF_TYPE_TRUCK_CLASS_AND_TYPE: '車格・車両属性',
  ALL_TRUCK_TYPES: '（全属性）',
  EDITION: '版',
  CALC_RULE: '計算ルール',
  CALC_RULE_NAME: '計算ルール名',
  CALC_RULE_DESCRIPTION: '計算ルール説明',
  CALC_PARAMETERS: '計算パラメータ',
  WORKING_TIME: '作業時間',
  WORK_MINUTE: '作業時間単位',
  WORK_UNIT_PRICE: '作業時間単位単価',
  OVER_ALL_TOTAL_AMOUNTS: '車両と配送依頼の全体総量の把握',
  UNDISPATCHED: '未配車',
  PROGRESS_DISPATCH: '配車中',
  CONFIRMED2: '確定',
  NUM_TRUCKS: '車両数',
  REMAIN_IN: [' (残 ', ')'],
  DIRECTION: '方面',
  DIRECTION_FROM_TO: '方面(FromTo)',
  DIRECTION_TO_FROM: '方面(ToFrom)',
  ORDER_COUNT: '依頼件数',
  ORDER_WEIGHT: '依頼重量',
  ORIGIN_SITE_COUNT: '発地数',
  DESTINATION_SITE_COUNT: '着地数',
  TRUCK_COUNT: '車両数（台）',
  MAX_LOAD_WEIGHT: '最大積載（t）',
  PENDING: '（残）',
  SQUARE_BRACKETS: (value: string) => `[${value}]`,
  RELOAD: '再読み込み',
  BACK_TO_TOP: 'トップページへ戻る',
  HISTORY_NAME: '履歴名',
  MONEY_TYPE: '金種',
  DUE_DATE_TYPE: '期日タイプ',
  DUE_DATE_TYPE_END: '月末指定',
  DUE_DATE_TYPE_DAY: '日付指定',
  DUE_DAY: '期日',
  PAYMENT_SIGHT: '支払いサイト',
  DEPOSIT_SIGHT: '入金サイト',
  SIGHT_MONTH_1: '翌月',
  SIGHT_MONTH_2: '翌々月',
  SIGHT_MONTH_0: '当月',
  DISPATCH_MEMO: '配車メモ',
  DISPATCH_MEMO_PLACEHOLDER: 'メモを入力...',
  /**
   * 親矢羽根の配車メモ有無インジケーターのツールチップ（#4705）。
   * 束ねは依頼ごとにメモを持つため、矢羽根上では件数だけ示して中身は
   * 「複数依頼の内容」モーダルへ誘導する
   */
  DISPATCH_MEMO_EXISTS_COUNT: (count: number) => `配車メモあり ${count}件`,
  TRUCK_DEPARTURE_MEMO_PREFIX: '出庫時間：',
  TRUCK_DEPARTURE_MEMO_SET_LINK: '出庫時間を設定',
  TRUCK_DEPARTURE_MEMO_PLACEHOLDER: '出庫時間を入力',
  DEFAULT_SHIPMENT_DURATION_LINE1: 'デフォルト',
  DEFAULT_SHIPMENT_DURATION_LINE2: '運行時間',
  // 関連地点
  RELATED_SITES: '関連地点',
  // メモ
  MEMO: 'メモ',
  MEMO_TITLE: 'タイトル',
  MEMO_URL: 'URL',
  MEMO_CONTENT: '本文',
  // 配車板
  PARTNER_TYPE_CONTRACTOR_SHORT: '傭車',
  UNASSIGNED: '未割当',
  DISPATCH_VALIDATION_HAS_TOUR: '運行実績があるため変更できません',
  DISPATCH_VALIDATION_FIXED: '確定済みのため変更できません',
  DISPATCH_VALIDATION_APPROVED: '承認済みです。変更しますか？',
  // 配送依頼編集履歴保存
  HISTORY_SAVE_CHECKBOX: 'この内容を履歴に登録・更新する',
  HISTORY_OVERWRITE_PREFIX: '元の履歴「',
  HISTORY_OVERWRITE_SUFFIX: '」を上書きする',
  HISTORY_OVERWRITE: '元の履歴を上書きする',
  HISTORY_REGISTER_AS_NEW: '新しい履歴として登録する',
  HISTORY_NAME_PLACEHOLDER: '履歴の登録名称（任意）',
  HISTORY_FALLBACK_NAME: '元の履歴',
  // カスタムキー
  CUSTOM_KEY_SLOT_HEADER: 'カスタムキー',
  CUSTOM_KEY_SLOT: (slotNumber: number) => `カスタムキー${slotNumber}`,
  CUSTOM_KEY_LABEL: 'ラベル',
  CUSTOM_KEY_LABEL_PLACEHOLDER: '例: 積み合わせコード',
  CUSTOM_KEY_IS_VISIBLE: '登録・検索画面に表示',
  CUSTOM_KEY_SHOW_VALUE: '矢羽根に表示',
  CUSTOM_KEY_IS_VISIBLE_TO_PARTNER: 'パートナーに公開する',
  // #3463 VOC_PJ-829/851: isVisible=true だがラベル未設定時のフォールバック表示名
  CUSTOM_KEY_FALLBACK_LABEL: (slotNumber: number) =>
    `カスタムキー${slotNumber}`,
  // VOC_PJ-960 #4487: カスタムキー横断フリーワード検索欄のラベル。横断検索のため
  // スロット別のマスタ登録名でなく汎用名を使う
  CUSTOM_KEY_FREE_WORD: 'カスタムキー'
} as const

/**
 * 入力値の例を表す定数
 */
export const EXAMPLES = {
  BANK_NAME: '〇〇銀行',
  BANK_BRANCH_NAME: '〇〇支店',
  BANK_ACCOUNT_NAME: '口座名',
  PREFECTURE: '東京都',
  CITY: '〇〇区〇〇町',
  BUILDING_NAME: '〇〇ビル204',
  PHONE_NUMBER: '000-0000-0000',
  FAX_NUMBER: '0000-00-0000',
  EMAIL: 'sample@sample.com',
  USER_NAME: 'ユーザー名',
  BANK_CODE: '0000',
  BANK_BRANCH_CODE: '1111',
  BANK_ACCOUNT_NUMBER: '0000-0000-0000-0000',
  POSTAL_CODE: '000-0000',
  BLOCK_NUMBER: '1-1-1',
  MONEY_TYPE: '現金'
} as const

/**
 * ヘルプや注意文などの説明を表す定数
 *
 * 定数名は文形式とする
 * 口語のように意味が通れば単語省略可
 * 例:
 * - (DO YOU) SAVE?
 * - (IT WAS) NOT FOUND.
 */
export const DESCRIPTIONS = {
  /** VOC_PJ-863 #3809: 「請求側附帯費用の項目に合わせる」ボタンのTooltip文言（甲確定） */
  MATCH_TO_ADDITIONAL_CHARGES:
    '請求側附帯費用の項目だけをコピーします。金額・運賃込み・備考はコピーされません。支払側に入力済みの行がある場合は置き換わります。',
  DISPLAY_NAME_AUTO_FILL:
    '未入力の場合、選択した車両の車両名が設定されます。車両も未選択の場合は「未設定」となります。',
  DISPLAY_NAME_AUTO_FILL_PLACEHOLDER:
    '未入力の場合、選択した車両の車両名が設定されます',
  DISPLAY_NAME_PLACEHOLDER: '表示名を入力',
  AUTOMATICALLY_NUMBERED_WHEN_UNSPECIFIED: '未指定の場合は自動採番されます',
  // TODO: AUTOMATICALLY_NUMBERED_WHEN_UNSPECIFIEDと統合したほうがよさそう
  AUTOMATICALLY_NUMBERED_WHEN_UNSET: '未設定の場合は自動採番されます',
  CONTRACT_NOT_FOUND: '該当する契約が見つかりません',
  // インポート由来（外部キー付き）の依頼が選択に含まれるときの注意。
  // 束ねの日付統一モーダル / 日付一括変更モーダル / 削除確認モーダルで共有する。
  // 「明細ID」は鴻池サントリーFMT固有の呼び名なので、汎用FMTの見出しである
  // 「外部キー」を使う（外部キーを持たないインポートは対象外だと読み取れるようにする）
  INCLUDES_IMPORTED_SHIPMENT_ORDERS:
    'インポートした配送依頼（外部キーを含む）が選択されています',
  // 束ねの日付統一モーダル: 複数日付が混在した状態でまとめようとしたときの説明
  BUNDLE_DATES_MIXED:
    '選択した配送依頼に複数の日付があります。まとめる日付を選択してください。',
  // 日付一括変更モーダル: 変更対象が選択した依頼であることの説明
  BULK_DATES_CHANGE:
    '選択した配送依頼の発日・着日・請求計上日をまとめて変更します。',
  SELECT: '選択してください',
  SEARCHING: '検索中...',
  LOADING: '読み込み中...',
  SELECT_PARTNER_FIRST: '先にパートナーを選択してください',
  LOGIN_EMAIL_IMMUTABLE:
    'メールアドレスはアカウントの作成後に変更できません。変えるときはアカウントを解除して作り直してください',
  SUB_PARTNER_REQUIRES_LOGIN_ACCOUNT_DETACH:
    'ログインアカウントを解除すると設定できます',
  SELECT_TRUCK_FIRST: '先に車両を選択してください',
  SELECT_TARIFF_FIRST: '先にタリフを選択してください',
  CHANGING: '変更中...',
  SELECT_REGULAR_START_DATE: 'レギュラー適用開始日を選択してください',
  SELECT_GARAGE: '車庫を選択',
  SELECT_SUB_PARTNER: '運送会社を選択してください',
  // TODO: SELECT_SUB_PARTNERと統合したほうがよさそう
  SELECT_SUB_PARTNER2: '運送会社を選択',
  SELECT_SUB_PARTNER3: '実運送会社を選択',
  SEARCHING_PARTNERS: 'パートナーを検索...',
  SEARCHING_SUB_PARTNERS: '実運送会社を検索...',
  SEARCHING_SUB_PARTNERS2: '運送会社を検索...',
  CONTRACT_NOT_FOUND_FOR_TOUR: '運行実績に該当する契約が見つかりません',
  DO_DELETE_SHIPMENT_ORDER: 'この配送依頼を削除しますか？',
  // VOC_PJ-981 #4620
  DO_REVOKE_SHIPMENT_ORDER: 'この配送依頼を取消しますか？',
  DO_RESTORE_REVOKED_SHIPMENT_ORDER:
    'この配送依頼の取消を戻しますか？（受注済に戻ります）',
  // 配送ルート編集フォーム: 矢羽根由来の行（isAdded=false）は削除ボタン押下時に物理削除でなく無効化される旨の説明
  DISABLE_DISPATCH_GROUP_ROUTE_ROW:
    '配送依頼の矢羽根に紐づく地点です。地点の変更・削除はできず、有効/無効のみ切り替えられます',
  // #4571: 検索バー自体にフォーカスがあり、ピッカーを一つも開いていない状態
  // （次のEnterで検索が実行される状態）で表示するヒント
  SEARCH_BAR_ENTER_HINT: 'Enterで検索条件を適用',
  // #4571: 複数選択ピッカー（客先・配送種別・車種・配送ステータス）のプル
  // ダウン内、選択肢一覧の末尾に表示するヒント
  SELECT_ENTER_HINT: 'Enterで確定',
  // #4571: フリーテキスト入力の複数値ピッカー（オーダーNo・カスタムキー）で、
  // 入力欄にテキストがある場合に表示するヒント
  TEXT_INPUT_ENTER_ADD_HINT: 'Enterで条件追加',
  // #4571: 同上ピッカーのプレースホルダー（項目名 + このサフィックス）
  INPUT_PLACEHOLDER_SUFFIX: 'を入力',
  // #4571: 同上ピッカーで、入力欄が空の場合に表示するヒント。この状態での
  // Enterはピッカーを閉じる操作として扱う
  TEXT_INPUT_ENTER_CLOSE_HINT: 'Enterで閉じる',
  SPECIFY_TIME_OPTIONALLY: '何時間分か指定（任意）',
  SELECT_RANGE: '範囲を選択',
  SELECT_CONTRACT_AREA: '契約エリアを選択',
  SELECT_OCLOCK: '時刻を選択',
  SELECT_TIME: '時間選択',
  CONTRACT_NOT_FOUND_BY_TOUR_INFO_OR_TOTAL_FARE:
    '運行実績(車両情報、配送地点)から該当する契約が見つかりませんでした。配送ルートを修正するか、合計運賃を入力してください。',
  NOTICE_RE_CALCULATION_ON_ROUTE_OR_FARE_CHANGE:
    '※配送ルートを修正すると再度、該当する契約を判定し、契約に基づいて運賃が再計算されます。',
  NOTICE_CONTRACT_NOT_FOUND:
    '配送ルートを修正し、保存しても該当する契約が見つからずエラーが表示される場合は',
  NOTICE_INPUT_WORK_TIME_AND_TOTAL_FARE:
    'から業務時間と合計運賃を直接入力してください',
  LOADING_AVAILABLE_STATUSES: '利用可能なステータスを読み込み中...',
  NO_SELECTABLE_COMMON_STATUSES: '選択可能な共通ステータスがありません',
  NO_SELECTABLE_STATUSES: '選択可能なステータスがありません',
  SELECTED_STATUS: '選択されたステータス',
  HAS_CHANGE_HISTORY_TOUR: '変更履歴のある運行実績です。',
  MANUAL_INPUT_TOUR: '手入力された運行実績です。',
  DEFICIT_TOUR: '赤字である運行実績です。',
  SELECT_TRUCK: '車両を選択',
  SELECT_DRIVER: 'ドライバーを選択',
  SELECT_TRUCK_GROUP: '車両グループを選択',
  SELECT_CUSTOMER: '荷主を選択',
  SELECT_PACKAGE_CATEGORY: '荷姿を選択',
  IMPORTED_SHIPMENT_ORDER_EDIT_NOTICE_PREFIX:
    'インポートした配送依頼を編集する場合は、',
  IMPORTED_SHIPMENT_ORDER_EDIT_NOTICE_SUFFIX: 'をクリックしてください',
  // VOC_PJ-445 #1864: 配送依頼一覧からの一括削除モーダル
  BULK_DELETE_SHIPMENT_ORDERS_DESCRIPTION:
    '削除した配送依頼は元に戻せません。対象を確認してから実行してください。',
  // 取消（復元できる）と削除（復元できない）を取り違えないよう、取消の導線を案内する
  BULK_DELETE_SHIPMENT_ORDERS_REVOKE_HINT:
    '依頼を残したまま取り消したい場合は、「ステータス更新」から「取消」を選んでください。',
  BULK_DELETE_SHIPMENT_ORDERS_BUNDLE_NOTICE:
    '削除によってまとめの残りが1件以下になる場合、まとめは解除されます。',
  INPUT_EDIT_REASON: '修正理由を入力',
  INPUT_NOTE: '備考を入力',
  // TODO: INPUT_NOTE INPUT_NOTE2 どちらかに統合したほうがよさそう
  INPUT_NOTE2: '備考を入力してください',
  INPUT_PACKAGE_COUNT: '荷姿数を入力',
  INPUT_DAILY_REPORT_NO: '日報変更番号を入力',
  SELECT_STATUS: 'ステータスを選択してください',
  SELECT_TARGET_STATUS: '更新先のステータスを選択',
  BULK_DELETE_MODAL_DESCRIPTION:
    '削除対象の契約を確認し、問題なければ一括削除を実行してください。',
  BULK_DELETE_NON_DELETABLE_DESCRIPTION: '使用済みの契約は削除できません',
  BULK_REVISE_NON_REVISABLE_DESCRIPTION:
    '使用済みかつ未改訂の契約のみ改訂できます',
  ABLE_TO_BULK_DELETE_IF_DUPLICATE_AS_REGULAR_GROUP:
    '定期複製とした場合、一括削除が可能です',
  NOT_ABLE_TO_BULK_DELETE_IF_NOT_REGULAR_GROUP:
    '定期複製設定を外すと、定期複製一括削除の対象外となります。',
  SELECT_SHIPPING_DATE: '配車日を選択',
  WILL_RESET_SUB_PARTNER_TRUCK_DRIVER_IF_CHANGE_PARTNER:
    'パートナーを変更すると実運送会社・車両・ドライバーがリセットされます',
  ABLE_TO_BULK_DISPATCH_WITH_DRAG_AND_DROP_AFTER_SELECT_MULTIPLE_SHIPMENT_ORDERS:
    '配送依頼を複数選択後、ドラッグ&ドロップで一括で配車できます',
  ABLE_TO_DISPATCH_DISPATCH_GROUP_DETAIL_WITH_DRAG_AND_DROP:
    'ドラッグ&ドロップで別の車両へ配車できます',
  /** 文中に「積荷情報の選択」リンク（アイコン付き）を挟むため前後に分ける */
  NO_SELECTED_CARGO_INFO_PARTS: {
    BEFORE: '矢羽根にカーソルを合わせて',
    AFTER: 'をクリックすると、その運行の配送依頼を表示します'
  },
  NO_SHIPMENT_ORDERS_TO_DISPATCH: '配車が必要な配送依頼はありません',
  CANNOT_UPDATE_DISPATCH_STATUS: (status: string) =>
    `「${status}」の運行情報は変更できません`,
  DO_UPDATE_STATUS_INTO: (status: string) => ({
    TO_ADD_SHIPMENT_ORDER: `ステータスを「${status}」に戻すことで、運行情報を修正できるようになります。変更しますか？`
  }),
  INPUT_ORIGIN_SITE_DEST_SITE: '発地・着地を入力してください',
  INPUT_CUSTOMER: '荷主を入力してください',
  INPUT_SHIPMENT_CATEGORY: '配送種別を入力してください',
  INPUT_TRUCK_MODEL_OR_TOTAL_WEIGHT: '車種または重量を入力してください',
  INPUT_SHIPPING_DATE: '発送日を入力してください',
  INPUT_DISPLAY_NAME: '表示名を入力してください',
  SELECT_TRUCK_REQUIRED: '車両を選択してください',
  DO_DELETE_DISPATCH: 'この運行情報を削除しますか？',
  INPUT_REASON_TO_REJECT_DISPATCH: '却下の理由を入力してください',
  SELECT_ORIGIN: '発地が選択されていません',
  SELECT_DESTINATION: '着地が選択されていません',
  NO_DISPATCH_DETAILS: '配車明細がありません',
  INPUT_REASON_FOR_EACH_ITEM:
    '修正する各項目についての修正理由を入力してください',
  INPUT_REASON_TO_REVERT: '差し戻し理由を入力してください',
  NO_PENDING_TASK: 'あなたの残作業はありません',
  NO_PENDING_TASK_CELEBRATION: 'あなたの残作業はありません 🎉',
  NO_UNCONFIRMED_TOUR: '確認済ではない運行実績はありません',
  UNCONFIRMED_DAILY_TOUR: '未確定の運行日があります',
  PAST_MONTHLY_TASK:
    '全ての運行日を確定させ、追加料金・前月調整を登録してセンターへ確認依頼を行いましょう。',
  PAST_MONTHLY_TASK_INQUIRY:
    'センターの確認待ちで未確定の運行日がある場合はセンターに問い合わせてください。',
  COMPANY_NAME_FOR_INVOICE: '会社名は、請求書発行時に利用されます。',
  DISPLAY_NAME_USAGE: '表示名として利用されます。',
  PAST_MONTHLY_TASK_CONFIRMATION:
    '月次支払レポートの追加料金・前月調整を登録してセンターへ確認依頼を行いましょう。',
  SUSPENDED_CUSTOMER: '取引停止中の荷主です',
  SUSPENDED_CUSTOMER_UPDATE_ATTENTION:
    '荷主との取引は停止中です。ステータスを更新する場合は注意してください。',
  SELECT_YEAR_MONTH: '年月を選択',
  SELECT_DATE: '日付を選択',
  NOT_CONFIRMED_STATUS_EXISTS: (
    x: number
  ) => `確認済ステータスになっていない運行実績が
                      ${x}件あります`,
  INVOICE_STATEMENT: '下記の通りご請求申し上げます。',
  INPUT_NOTE_ABOUT_ADDITIONAL_PAYMENTS:
    '追加料金・前月調整についての備考を入力',
  UNCONFIRMED_TOURS: '未確定の運行日があります',
  CANNOT_CREATE_BILL_WHEN_UNCONFIRMED_TOUR:
    '未確定の運行日があるため、請求書の作成やセンターへの確認依頼ができません。',
  SHOW_MESSAGE_WHEN_UNCONFIRMED_STATUS_OR_TOUR:
    'ステータスが確認済になっていない運行実績がある場合や、運行がなく未確定の日がある場合にこのメッセージが表示されます。',
  INPUT_REASON_FOR_REJECTION: '差し戻し理由を入力',
  // TODO: INPUT_REASON_FOR_REJECTIONと統合したほうがよさそう
  INPUT_REASON_FOR_REJECTION2: '差し戻し理由を入力してください',
  ALL_DAILY_REPORTS_AND_MONTHLY_REPORTS_FINALIZED:
    '当月締め分の日報を全て確定済みにし、月次レポートを最終確認済みに変更します。',
  INVOICE_PDF_FILE_NAME: (x: string) => `${x}御中_請求書.pdf`,
  /** 配送指示書（自車）の保存名。yyyyMMdd は配車日 From */
  IN_HOUSE_INSTRUCTION_SHEET_FILE_NAME: (yyyyMMdd: string) =>
    `配送指示書（自車）_${yyyyMMdd}.xlsx`,
  // 契約フォーム関連
  // 契約関連
  SELECT_CONTRACT_TYPE: '契約種別を選択',
  SELECT_CONTRACT_TYPE2: '契約種別を選択してください',
  CONTRACT_TYPE_CHANGE_RESETS_INPUT:
    '※ 契約種別を変更すると入力済みの内容はリセットされます。',
  REVISE_CONTRACT_SET_END_DATE:
    '契約改訂にあたり、この契約の適用終了日を設定してください。',
  REVISED_CONTRACT_APPLY_START_IS: (date: string) =>
    `改訂後の契約の適用開始日は ${date} です`,
  SELECT_AREA: 'エリアを選択してください',
  SELECT_SITE_WAREHOUSE: '倉庫等を選択してください',
  SELECT_EITHER_AREA_OR_SITE:
    'エリアまたは倉庫等のいずれか一方を選択してください。',
  ENABLES_NIGHT_SURCHARGE: '設定すると深夜割増が有効になります',
  ENABLES_EXCESS_DISTANCE_SURCHARGE: '設定すると超過距離割増が有効になります',
  TIME_ADJUST_DESCRIPTION:
    '休憩時間を差し引く場合はマイナスの値、移動時間を追加する場合はプラスの値を設定してください',
  DESTINATION_SITE_TYPE_SOME_DESC:
    '(運行実績に配送先地点が1カ所以上を含まれる場合に適用される契約)',
  DESTINATION_SITE_TYPE_EVERY_DESC:
    '(運行実績にすべての配送先地点が含まれていた場合に適用される契約)',
  DRIVER_NOT_FOUND: '登録済みのドライバーが見つかりません',
  UPLOAD_TOUR_CSV: '運行実績CSVファイルをアップロード',
  CSV_FILE_UPLOAD: 'CSVファイルをアップロード',
  UPLOAD_TRUCK_DATA: '車両データ(CSVファイル)をアップロードしてください。',
  UPLOAD_TRUCK_CLASS_DATA:
    '車格データ(CSVファイル)をアップロードしてください。',
  UPLOAD_TRUCK_MODEL_DATA:
    '車種データ(CSVファイル)をアップロードしてください。',
  PLEASE: 'してください。',
  INPUT_UNIT_NAME: '単位名を入力してください',
  INPUT_CHARGE_TYPE_NAME: '運賃種別を入力してください',
  DEFAULT_DISPLAY_MONTHLY_REPORT_ADDITIONAL_PAYMENT:
    '月次支払レポートの追加料金編集時にデフォルトで表示する',
  // VOC_PJ-865 #3819: 配送依頼の附帯費用行追加時に運賃込み (pricingMode=INCLUDED) を既定にする
  FARE_INCLUDED_BY_DEFAULT_ADDITIONAL_PAYMENT:
    '配送依頼の附帯費用追加時にデフォルトで運賃込みにする',
  // VOC_PJ-618 #5273: 実費精算する費目を帳票の合計運賃から外す
  EXCLUDED_FROM_TOTAL_ADDITIONAL_PAYMENT:
    '帳票の合計運賃に金額を含めない（金額そのものは印字する）',
  // VOC_PJ-1070 #5755: 様式の欄名が税込を指している費目を帳票だけ税込で出す。
  // チェックを外すと税込欄は空欄になる（税抜の額は出さない）
  REPORT_AMOUNT_TAX_INCLUDED_ADDITIONAL_PAYMENT:
    '配車結果帳票の税込欄に税額を足して印字する（合計運賃は税抜のまま。チェックを外すと税込欄は空欄になります）',
  // VOC_PJ-1000 #5264: 費目を選んだときに配送依頼の備考へ写す初期値。
  // 写す実装が入るのと同時に案内する（#5902 の時点では保存だけを案内していた）
  NOTE_ADDITIONAL_PAYMENT_CATEGORY:
    '配送依頼でこの費目を選んだとき、備考が空ならこの内容が入ります（入力済みの備考は書き換えません）',
  ONLY_CSV_FILE_CAN_BE_UPLOADED: (x: string) =>
    `CSVファイルのみアップロード可能です。選択されたファイルの種類: ${x}`,
  ONLY_EXCEL_FILE_CAN_BE_UPLOADED: (x: string) =>
    `Excelファイルのみアップロード可能です。選択されたファイルの種類: ${x}`,
  SELECT_PARTNER: 'パートナーを選択してください',
  // TODO: SELECT_PARTNERと統合したほうがよさそう
  SELECT_PARTNER2: 'パートナーを選択',
  SELECT_PARTNER_TO_REQUEST: '依頼するパートナーを選択してください',
  UPLOAD_SITE_CSV: '地点データ(CSVファイル)をアップロードしてください。',
  UPLOAD_TRUCK_TYPE_CSV:
    '車両属性データ(CSVファイル)をアップロードしてください。',
  UPLOAD_SHIPMENT_CATEGORY_CSV:
    '配送種別データ(CSVファイル)をアップロードしてください。',
  UPLOAD_PACKAGE_CATEGORY_CSV:
    '荷姿データ(CSVファイル)をアップロードしてください。',
  UPLOAD_TARIFF: 'タリフデータ(Excelファイル)をアップロードしてください。',
  SELECT_CLOSING_DATE: '締日を選択してください',
  CLOSING_DATE_SHORT_MONTH_NOTE:
    '29日・30日は、その日が存在しない月では末日で締まります',
  CALCULATING: '計算中...',
  ABOUT_THE_CALCULATION_PERIOD: '計算期間について',
  INITIAL_PERIOD_ON_CLOSING_DATE_CHANGE:
    '締日変更により、初回の計算期間が通常と異なる場合があります。',
  NEXT_PERIOD_ON_CLOSING_DATE_CHANGE:
    'に変更した場合、次回の請求は以下の期間での計算になります。',
  SELECT_SUBCONTRACTING_HIERARCHY: '請負階層を選択',
  EXPLAIN_OF_CUSTOMER_CONTRACT_NAME_SEARCH: `下記の条件で検索が行えます。\n・契約名の部分一致\n・契約コード(-前)の部分一致\n・契約コードの完全一致`,
  CANNOT_EDIT_OR_DELETE_BECAUSE_USED_IN_SHIPMENT: `配送に紐づいているため \n適用終了日の編集のみ可能です`,
  CANNOT_EDIT_OR_DELETE_BECAUSE_ALREADY_REVISED: `改定済みのため \n適用終了日の編集のみ可能です`,
  BULK_OPERATION_PROGRESS: (x: string) => `以下を一括で${x}します`,
  NO_TARGET_DATA: '対象は0件です',
  CANNOT_DESELECT_EDITING_SHIPMENT_ORDER:
    '編集中の配送依頼のため解除できません',
  CANNOT_DESELECT_HAS_TOUR_ORDER:
    '運行実績に登録された定期運行は解除できません',
  CANNOT_DESELECT_TOUR_BEFORE_SHIPMENT_DATE:
    'この配送依頼の発送日より前の定期運行は解除できません',
  OTHER_SHIPMENT_ORDERS_NOT_AFFECTED:
    '定期運行によって作成された他の配送依頼は変更されません',
  CHANGING_STATUS_LOCKED_DISPATCH: '変更はロックされています',
  CANNOT_EDIT_FIXED_DISPATCH:
    '変更対象の運行は「確定」のステータスのため変更することはできません。',
  WITHDRAW_FIXED_DISPATCH_TO_EDIT:
    '変更するには運行の「確定解除」を実施してステータスを「配車中」に戻してください。',
  FIXED_DATE: '日付は固定されています。',
  // 日表示の編集モーダルで経由地の時刻エラーをトーストに出すときの案内（#5548）
  SWITCH_TO_HOUR_VIEW_TO_FIX: '（時間表示に切り替えて直してください）',
  SHIPMENT_ORDER_IMPORT_JOB_LAST_UPDATED_AT:
    'このレコードの最終更新日時です。\nステータスが「処理中」のまま5分以上更新されない場合、処理が停止している可能性があります。\nその場合は「中断」→「再開」をお試しください。',
  SHIPPING_DATE_RANGE_TOOLTIP:
    '発送日は開始日〜終了日を12ヶ月以内で指定してください。',
  // #5285 VOC_PJ-506: 登録日は片側だけの指定を検索時に 12ヶ月幅へ補完する
  CREATED_AT_RANGE_TOOLTIP:
    '登録日は開始日〜終了日を12ヶ月以内で指定してください。開始日のみ／終了日のみのときは12ヶ月幅で補完します。',
  OPERATION_DATE_RANGE_TOOLTIP:
    '運行日は開始日〜終了日を12ヶ月以内で指定してください。',
  RELATED_GROUP_CODE_TOOLTIP:
    '荷主マスタの「関連地点」と、地点マスタの「関連荷主」に、グループとなる同一のコードを設定（フリーテキスト入力）することで、配送依頼の作成・編集時の発地、着地の設定時にタブ「関連地点」が表示されるようになります。',
  SITE_DISPLAY_NAME_MIDDLE_TOOLTIP:
    '配車板などで正式名称の代わりに表示される名称です（設定が有効な場合）。20文字以内で入力してください。',
  SITE_DISPLAY_NAME_SHORT_TOOLTIP:
    '配車板などで最も優先して表示される短い名称です。10文字以内で入力してください。',
  SYSTEM_ADMIN_AUTHORITY_TOOLTIP:
    '以下の操作が可能\n・拠点マスタの新規登録\n・拠点ユーザーが所属する拠点の追加と削除\n・システムマスタ設定メニュー内のすべての拠点のデータを一覧・編集（拠点の付け替えと全拠点共有に設定可能）',
  DC_MANAGER_TOOLTIP:
    'システムマスタ設定メニュー内の自拠点のデータの新規登録と編集\n※拠点マスタの新規登録は除く',
  LOGIN_ACCOUNT_TOOLTIP:
    'ドライバーが配車板を見るためのログインアカウントです。\n自社のドライバーで、実運送会社を設定していない場合だけ作成できます。\nログインすると、パートナーユーザーと同じ範囲で所属パートナーの配車板を見られます。\n作成と解除は、システム管理者権限のあるユーザーと拠点マネージャーだけが行えます。',
  MEMO_MAX_COUNT: '（最大5件）',
  CONFIRM_DIFFERENT_DATE_DISPATCH: (shippingDate: string, dropDate: string) =>
    `発送日（${shippingDate}）と異なる日付（${dropDate}）に配置しようとしています。よろしいですか？`,
  CONFIRM_TIME_RESTRICTION_DISPATCH:
    '配置先の時間が配送依頼の発着時間制限外です。\nこのまま保存しますか？',
  DISPATCHING: '配車中...',
  SWAP_FUTURE_DATES_WARNING: (date: string) =>
    `${date} より後の以下の日にも運行予定があります`,
  SWAP_SCOPE_TODAY_ONLY: (date: string) => `${date} のみ入れ替え`,
  SWAP_SCOPE_UNTIL: (fromDate: string, toDate: string) =>
    `${fromDate} から ${toDate} まで一括入れ替え`,
  SWAP_SOURCE_LABEL: '変更元',
  SWAP_TARGET_LABEL: '変更先',
  SWAP_DATE_FORMAT: (month: number, day: number) => `${month}月${day}日`,
  PRE_LOAD_AUTO_APPLY:
    '配車板で宵積み（前日集荷・翌日納品）の配送依頼を矢羽根として配置するときに使用する、目安集荷時間と目安納品時間のデフォルトを拠点単位で設定します。\n自動適用 OFF の場合は配置時にこの設定値を適用せず、ドロップした時間軸を保持します。',
  SHOULD_LOCK_DISPATCH_ON_FIX:
    '配車を確定した車両行を、配車板で変更できないようにするかを拠点単位で設定します。\nON の場合、確定した配車日の車両行は矢羽根の追加・移動・編集・削除や車両・ドライバーの変更ができません。直すときは確定解除してから再確定してください。\nOFF の場合、確定後も確定前と同じ操作ができ、配車の状態は確定のまま残ります。\nパートナーに矢羽根の中身が見えるかどうかは、この設定に関わらず確定済みかどうかで決まります。',
  WEIGHT_DISPLAY_FORMAT:
    '配送依頼の荷物重量を画面上でどの単位・小数桁数で表示するかを拠点単位で設定します。取り扱う品目に合わせて選んでください（軽量な品目はkg、重量物はtが読みやすくなります）。\n100gはtなら小数第4位、kgなら小数第1位で表せます。選べる桁数は単位によって変わり（tは小数第5位まで、kgは小数第2位まで）、単位を切り替えると桁数は「整数」に戻ります（切替前の桁数がその単位で有効かどうかに関わらず毎回リセットされます）。\n車両の最大積載量・車両総重量、およびCSV・帳票の出力はこの設定の対象外です。',
  DRAWER_DATE_SYNC:
    '矢羽根ページで、配車板の横スクロールでの日付変更時に、配送依頼ドロワー側の日付も連動して変更させる設定です',
  PINNED_SELECTED_SHIPMENT_ORDERS_NOTICE: (count: number) =>
    `選択中の${count}件は現在のページ・絞り込み結果に含まれないため先頭に表示しています`,
  // 束ねから分離した配送依頼は配車にも残せない（束ねのメンバーと配車の中身を一致させる）
  SEPARATE_DISPATCHED_FROM_BUNDLE_NOTICE: (count: number) =>
    `分離する配送依頼のうち${count}件は配車済みです。分離すると配車も解除され、配送依頼一覧に戻ります。よろしいですか？`,
  LINK_SITE_WITH_CUSTOMER: (customerName: string) =>
    `「${customerName}」と関連付ける`,
  ALREADY_LINKED_WITH_CUSTOMER: '既にこの荷主と関連付いています',
  CURRENT_CUSTOMER_SITE_GROUP_LINK: (
    customerId: number,
    customerName: string
  ) => `現在の関連荷主: #${customerId}_${customerName}`,
  CURRENT_CUSTOMER_SITE_GROUP_LINK_NONE: '現在の関連荷主: 未設定',
  SELECT_CUSTOMER_TO_RELINK_SITE_GROUP: '荷主を選択すると、付け替えができます',
  CUSTOMER_SITE_GROUP_LINK_TOOLTIP:
    '荷主にコードが未設定の場合、荷主名称がそのまま新しいコードとして荷主・地点の両方に設定されます',
  /** 地点セレクトの候補行「関連付ける」ボタン押下時の確認モーダル本文（#3669） */
  LINK_SITE_WITH_SELECTED_CUSTOMER: (siteName: string, customerName: string) =>
    `地点「${siteName}」を、荷主「${customerName}」と関連付けます。`
} as const

export const IMPORTED_SHIPMENT_ORDER_EDIT_NOTICE_PARTS = {
  prefix: DESCRIPTIONS.IMPORTED_SHIPMENT_ORDER_EDIT_NOTICE_PREFIX,
  suffix: DESCRIPTIONS.IMPORTED_SHIPMENT_ORDER_EDIT_NOTICE_SUFFIX
} as const

/**
 * 単位を表す定数
 * <UnitLabel>で使用
 */
export const UNITS = {
  MASS: {
    TON: 't',
    KILOGRAM: 'kg'
  },
  QUANTITY: {
    NUMBER: '件',
    PIECE: '個',
    DAI: '台',
    TIMES: '回'
  },
  CURRENCY: {
    // TODO: 括弧ありなしはUnitLabel側で制御したほうがよいかも
    YEN_PARENTHESES: '(円)',
    YEN: '円'
  },
  DATETIME: {
    DAY: '日',
    HOUR: '時間',
    MINUTE: '分'
  },
  DISTANCE: {
    KM: 'km'
  },
  WEIGHT: {
    TON_PARENTHESES: '(t)',
    TON: 't'
  }
} as const

export const DISPLAY_SCALE_LABELS = {
  UNIT: {
    HOUR: '時',
    DAY: '日'
  },
  SIZE: {
    LARGE: '大',
    MEDIUM: '中',
    SMALL: '小'
  }
} as const

/**
 * フォーマットを表す定数
 */
export const FORMAT = {
  YEAR_MONTH: 'yyyy年M月度',
  YEAR_MONTH_JA: 'yyyy年 MM月',
  CONCRETE_PANEL: '縦*横*厚み',
  RINGI: '60角、75角、90角、その他 ()',
  WIRE: '3分、4分、6分',
  LEVER_BLOCK: '(  ) t締め',
  ROPE: '(  ) m',
  COLON: '：'
} as const

/**
 * アクション前に確認するメッセージを表す定数
 *
 * 定数名は文形式とする
 * 口語のように意味が通れば単語省略可
 * 例:
 * - DO (YOU) SAVE?
 * - (IT WAS) NOT FOUND.
 */
export const CONFIRMATION_MESSAGES = {
  DELETE: (itemName: string) => `「${itemName}」を削除しますか？`,
  CLEAR: (itemName: string) => `「${itemName}」をクリアしますか？`,
  SAVE: '保存しますか？',
  CANCEL: '変更内容が失われますが、キャンセルしますか？',
  UPDATE: '更新しますか？',
  LEAVE_PAGE: 'このページを離れますか？行った変更は保存されません。',
  DELETE_TOUR: 'この運行実績を削除しますか？',
  RESTORE_TOUR: '運行キャンセルを解除し、キャンセル前の状態に戻しますか？',
  SELECTED_ITEMS: '選択中の',
  COUNT_SELECTED_ITEMS: '件を',
  UPDATE_SELECTED_ITEMS: 'へ更新しますか？',
  DELETE_TRUCK: 'この車両を削除しますか？',
  DELETE_DISPATCH: 'この運行情報を削除しますか？',
  DELETE_PLAN_SLOT: 'この車両枠を削除しますか？',
  HIDE_PLAN_SLOT: 'この車両をこの日だけ配車板から非表示にしますか？',
  DELETE_PLAN_SLOT_PERIOD:
    'この期間を削除しますか？\n適用期間内に配車情報があれば削除できません',
  DELETE_PERMANENT_PLAN_SLOT:
    'この車両の配車表示を削除しますか？\n適用期間内に配車情報があれば削除できません',
  CANCEL_DEACTIVATE_PERMANENT: '適用終了を取り消して、再び配車表示にしますか？',
  CREATE_PERMANENT_WITHOUT_TRUCK:
    '車両が設定されていません。未設定として登録します。よろしいですか？',
  DELETE_DISPATCH_DETAIL: 'この配送依頼を削除しますか？',
  DETACH_REGULAR_GROUP: '定期複製設定を解除しますか？',
  DETACH_LOGIN_ACCOUNT:
    'ログインアカウントを解除しますか？このメールアドレスではログインできなくなります。ドライバーは残り、編集からアカウントを作り直せます。',
  DELETE_CONTRACT: 'この契約を削除しますか？',
  DELETE_CUSTOMER_CONTRACT: 'この請求契約を削除しますか？',
  DELETE_CUSTOMER_CONTRACTS: '選択中の請求契約を一括削除しますか？',
  CHANGE_CONTRACT_TYPE: '契約種別を変更しますか？',
  UNCONFIRMED_DAILY_FINALIZED_ALL: (x: number) => `未承認の日次が ${x}
                    件あります。まとめて確定しますか？`,
  DELETE_SITE: 'この地点を削除しますか？',
  DELETE_AREA: 'このエリアを削除しますか？',
  SYSTEM_MASTER_UNSHARE:
    '共有を解除すると他拠点ではこの項目を選択・編集できなくなります',
  CONFIRM_DELETE_ITEM: 'この項目を削除しますか？',
  CONFIRM_DEACTIVATE_ITEM:
    'この項目を無効化します。過去データの参照は引き続き可能ですが、選択肢には表示されなくなります。よろしいですか？',
  IMPORTED: 'インポート済みの',
  ROLLBACK_INVOICED_FARE: 'の請求運賃を取り消しますか？',
  ROLLBACK_SHIPMENT_ORDER: 'の配送依頼を取り消しますか？',
  ROLLBACK_IMPORTED_INVOICED_FARE_PREFIX: 'インポート済み',
  ROLLBACK_IMPORTED_INVOICED_FARE_SUFFIX: '件の請求運賃を取り消しますか？',
  ROLLBACK_IMPORTED_SHIPMENT_ORDER: 'インポート済み配送依頼を取り消しますか？',
  // 取込の取消で外れる明細と残る明細（#5686。一覧は出さず、決まりだけを伝える）
  ROLLBACK_IMPORTED_SHIPMENT_ORDER_DETAIL:
    'このインポートで登録・更新した明細が外れ、元には戻せません。あとのインポートで更新した明細は残ります。明細がすべて外れた配送依頼は「取消」になり、配車されていれば配車から外れます。',
  CANNOT_UNDO_THIS_OPERATION: '※ この操作は取り消せません。',
  CONFIRM_CANCEL_CLOSING_DATE_CHANGE_CANNOT_UNDO:
    '予約されている締日変更をキャンセルします。この操作は取り消せません。',
  CONFIRM_RESUMING_IMPORT: 'このインポートを再開しますか？',
  CONFIRM_FINISHING_IMPORT:
    '中断したインポートは終了します（再開はできません）。同じ CSV を「配送依頼のインポート」から入れ直してください',
  CONFIRM_INTERRUPTING_IMPORT: 'このインポートを中断しますか？',
  FORCE_ASSIGN_TRUCK: (truckName: string) =>
    `選択された車両「${truckName}」は、既に別の案件に割り当てられています。元の割り当てを解除して、こちらの案件に変更しますか？`,
  RELEASE_DISPATCH: 'この配車行の車両・ドライバーの紐づけを解除しますか？',
  OVERWRITE_SITE_GROUP_CODE: (customerName: string) =>
    `この地点は既に別の荷主グループに設定されています。「${customerName}」のグループに変更しますか？`
} as const

/**
 * アクション後に成功したことを通知するメッセージを表す定数
 *
 * 定数名は文形式とする
 * 口語のように意味が通れば単語省略可
 * 例:
 * - DO (YOU) SAVE?
 * - (IT WAS) NOT FOUND.
 */
export const SUCCESS_MESSAGES = {
  SUCCEEDED_TO_REGISTER: '登録に成功しました',
  REGISTERED: '登録しました',
  SAVED: '保存しました',
  UPDATED: '更新しました',
  DELETED: '削除しました',
  UPDATED_ORDER_NO: '配送依頼Noを更新しました',
  BUNDLED_SHIPMENT_ORDERS: '配送依頼をまとめました',
  BULK_UPDATED_DATES: '日付を変更しました',
  UNBUNDLED_SHIPMENT_ORDERS: '束ねを解除しました',
  SEPARATED_FROM_BUNDLE: '束ねから分離しました',
  SEPARATED_FROM_BUNDLE_WITH_DISPATCH: (count: number) =>
    `束ねから分離し、${count}件の配車を解除しました`,
  REGISTERED_SUB_PARTNER: '実運送会社を登録しました',
  REGISTERED_TRUCK: '車両を登録しました',
  UPDATED_TRUCK: '車両を更新しました',
  UPDATED_MEMO: 'メモを更新しました',
  UPDATED_STATUS: (x: string) => `ステータスを ${x} に更新しました`,
  SUCCESS_COUNT_UPDATED_STATUS: (x: number) =>
    `${x}件のステータスを更新しました`,
  SUCCESS_COUNT_UPDATED_STATUS_INTO: (x: number, status: string) =>
    `${x}件のステータスを「${status}」に更新しました`,
  REGISTERED_DRIVER: 'ドライバーを登録しました',
  ADDED_TOUR: '運行実績を追加しました',
  UPDATED_TOUR: '運行実績を更新しました',
  DELETED_TOUR: '運行実績を削除しました',
  CANCELED_TOUR: '運行実績をキャンセルしました',
  RESTORED_TOUR: '運行キャンセルを解除しました',
  UPDATED_COUNT_TOUR: (x: number) => `${x} 件の運行実績を更新しました`,
  UPDATED_APPLY_END_DATE: '適用終了日を更新しました',
  CREATED_REVISED_CONTRACT: '契約を複製し、改訂版を作成しました',
  UPDATED_ADDITIONAL_PAYMENT_AND_PREVIOUS_MONTH_ADJUSTMENTS:
    '追加料金・前月調整を更新しました',
  REGISTERED_CUSTOMER: '荷主を登録しました',
  UPDATED_MONTHLY_STATUS: (x: string) => `月次ステータスを ${x} に更新しました`,
  UPDATED_BILLING_STATUS: (x: string) => `請求ステータスを ${x} に更新しました`,
  UPDATED_BILLING_STATUSES: (successCount: number, failureCount: number) =>
    failureCount > 0
      ? `${successCount}件の請求ステータスを更新しました（${failureCount}件は更新できませんでした）`
      : `${successCount}件の請求ステータスを更新しました`,
  FINALIZED_MONTHLY_REPORTS: '月次レポートを一括確定しました',
  UPDATED_ADDITIONAL_PAYMENTS: '追加料金・前月調整を更新しました',
  CONFIRMED_DAILY_REPORT: (x: string) => `${x} の日次レポートを確定しました`,
  REGISTERED_SITE: '地点を登録しました',
  UPDATED_SITE: '地点を更新しました',
  /** 地点セレクトの候補行から荷主と地点を関連付けた（#3669） */
  LINKED_CUSTOMER_WITH_SITE: '荷主と地点を関連付けました',
  REGISTERED_SHIPMENT_CATEGORY: '配送種別を登録しました',
  REGISTERED_PACKAGE_CATEGORY: '荷姿を登録しました',
  ADJUSTED_FOR_RESTRICTION_TIME: '時間制限に合わせて配車時間を自動調整しました',
  REGISTERED_DISPATCH: '運行情報を登録しました',
  UPDATED_DISPATCH: '運行情報を更新しました',
  SWAPPED_DISPATCH: '運行情報を入れ替えました',
  FORCE_ASSIGNED_DISPATCH: '車両を強制割当しました',
  RELEASED_DISPATCH: '車両・ドライバーの紐づけを解除しました',
  DETACHED_LOGIN_ACCOUNT: 'ログインアカウントを解除しました',
  REVERTED_TO_SHIPMENT_ORDER: '配送依頼に戻しました',
  DUPLICATED_SHIPMENT_ORDER: '配送依頼を複製しました',
  REGISTERED_SCHEDULE: 'スケジュール枠を登録しました',
  UPDATED_SCHEDULE: '予定枠の内容を更新しました',
  UPDATED_SHIPMENT_ORDER: '配送依頼を更新しました',
  SUCCEEDED_TO_DISPATCH_AND_UPDATE_STATUS_INTO: (status: string) =>
    `ステータスを${status}に変更し、配車を完了しました`,
  SUCCEEDED_TO_UPDATE_DISPATCH_AND_UPDATE_STATUS_INTO: (status: string) =>
    `ステータスを${status}に変更し、配車情報を更新しました`,
  UPDATED_STATUS_INTO: (status: string) =>
    `ステータスを${status}に変更しました`,
  HID_CUSTOMER_CHARGE_IN_REPORT: '明細を非表示にしました',
  SHOWED_CUSTOMER_CHARGE_IN_REPORT: '明細の非表示を解除しました',
  DOWNLOADED: 'ダウンロードしました',
  CHANGED_EXPENSE: '支払運賃が変更になりました',
  DELETED_SHIPMENT_ORDER: '配送依頼を削除しました',
  DELETED_DISPATCH_FRAME: '枠を削除しました',
  // VOC_PJ-445 #1864: 一覧からの一括削除
  DELETED_SHIPMENT_ORDERS: (count: number) =>
    `${count}件の配送依頼を削除しました`,
  // VOC_PJ-981 #4620。既存の ROLLED_BACK_SHIPMENT_ORDER（インポートのロールバックで
  // 使用中・文言が「配送依頼を取り消しました」）とは別機能なので流用しない
  REVOKED_SHIPMENT_ORDER: '配送依頼を取消しました',
  RESTORED_REVOKED_SHIPMENT_ORDER: '配送依頼の取消を戻しました',
  DELETED_DISPATCH: '運行情報を削除しました',
  TRANSITED_DISPATCH_TO: {
    CANCEL_REQUEST: '依頼をキャンセルしました',
    WITH_DRAW: '運行確定を取下げました',
    REJECT: '配車依頼を却下しました',
    HOLD: '配車依頼を保留にしました'
  },
  SKIPPED_DELETING: (total: number, skipped: number) =>
    `${total}件中${skipped}件はエラーのため削除をスキップしました`,
  SKIPPED_DUPLICATING: (total: number, skipped: number) =>
    `${total}件中${skipped}件は重複していたため複製をスキップしました`,
  SKIPPED_DUPLICATING_DISPATCH: (total: number, skipped: number) =>
    `運行情報は${total}件中${skipped}件はエラーのため複製をスキップしました`,
  SKIPPED_DUPLICATING_DISPATCH_DETAIL: (total: number, skipped: number) =>
    `配送依頼は${total}件中${skipped}件はエラーのため複製をスキップしました`,
  SUCCEEDED_TO_DELETE: '削除に成功しました',
  SUCCEEDED_TO_HIDE: '配車板から非表示にしました',
  SUCCEEDED_TO_UNHIDE: '配車板に再表示しました',
  SUCCEEDED_TO_DEACTIVATE: '配車表示の終了に成功しました',
  SUCCEEDED_TO_DEACTIVATE_ITEM: '項目を無効化しました',
  SUCCEEDED_TO_CANCEL_DEACTIVATE: '適用終了の取り消しに成功しました',
  SUCCEEDED_TO_UPDATE: '更新に成功しました',
  BULK_DELETE_SUMMARY: (successCount: number, totalCount: number) =>
    `${successCount} / ${totalCount} 件の削除に成功しました`,
  BULK_REVISE_SUMMARY: (successCount: number, totalCount: number) =>
    `${successCount} / ${totalCount} 件の改訂に成功しました`,
  RESCHEDULED_DISPATCH_DETAIL: '配車予定を更新しました',
  UPDATED_DRIVER: 'ドライバーを変更しました',
  ADDED_SHIPMENT_ORDER: '配送依頼を追加しました',
  CANCELED_REQUEST: '依頼をキャンセルしました',
  GROUPED_TRUCK: '車両グループを設定しました',
  SORTED_TRUCK: '車両を並び替えました',
  ROLLED_BACK_SHIPMENT_ORDER: '配送依頼を取り消しました',
  SUCCEEDED_TO_DUPLICATE: '複製に成功しました',
  SUCCEEDED_TO_DUPLICATE_SAME_DATE: '配送依頼一覧に複製されました',
  SUCCEEDED_TO_UPDATE_SHIPMENT_ORDER_DISPATCH_DETAIL:
    '配送依頼・配車情報を更新しました',
  ROLLED_BACK_IMPORT: 'インポートを取り消しました',
  RESUMED_IMPORT: 'インポートを再開しました',
  FINISHED_IMPORT: '中断したインポートを終了しました',
  INTERRUPTED_IMPORT: 'インポートを中断しました',
  STARTED_TOUR_CONTRACT_IMPORT: '運行建契約のインポートを開始しました',
  STARTED_TRUCK_IMPORT: '車両データのインポートを開始しました',
  STARTED_TRUCK_CLASS_IMPORT: '車格データのインポートを開始しました',
  STARTED_TRUCK_MODEL_IMPORT: '車種データのインポートを開始しました',
  UPDATED_CLOSING_DATE: '締日を更新しました',
  // TODO: CREATEDと統合したほうがよさそう
  SUCCEEDED_TO_CREATE: '作成に成功しました',
  REGISTERED_DC: '拠点を登録しました',
  STARTED_UPDATING_SHIPMENT_ORDER: '配送依頼の更新を開始しました',
  STARTED_IMPORTING_SHIPMENT_ORDER: '配送依頼のインポートを開始しました',
  STARTED_IMPORTING_SUNTORY_DEDICATED_SHIPMENT_ORDER:
    'サントリー得意先配送インポートを開始しました',
  STARTED_IMPORTING_TOUR_CSV: '運行実績のインポートを開始しました',
  CANCELED_CLOSING_DATE_CHANGE: '締日変更をキャンセルしました',
  STARTED_INVOICE_FARE_IMPORT: '請求運賃のインポートを開始しました',
  SUCCEEDED_TO_REQUEST_PARTNER: (totalCount: number, successCount: number) =>
    `パートナーへ依頼が完了しました（対象: ${totalCount}件、成功: ${successCount}件）`,
  SUCCEEDED_TO_CONFIRM_OPERATIONS: (totalCount: number, successCount: number) =>
    `運行確定が完了しました（対象: ${totalCount}件、成功: ${successCount}件）`,
  SUCCEEDED_TO_WITHDRAW_OPERATIONS: (
    totalCount: number,
    successCount: number
  ) =>
    `確定解除が完了しました（対象: ${totalCount}件、成功: ${successCount}件）`,
  SUCCEEDED_TO_BULK_APPROVE: (totalCount: number, successCount: number) =>
    `依頼一括承認が完了しました（対象: ${totalCount}件、成功: ${successCount}件）`,
  STARTED_SITE_IMPORT: '地点データのインポートを開始しました',
  STARTED_TRUCK_TYPE_IMPORT: '車両属性データのインポートを開始しました',
  STARTED_SHIPMENT_CATEGORY_IMPORT: '配送種別データのインポートを開始しました',
  STARTED_PACKAGE_CATEGORY_IMPORT: '荷姿データのインポートを開始しました',
  STARTED_TARIFF_IMPORT: 'タリフデータのインポートを開始しました',
  CONVERTED_TO_SITE: '地点に変更しました',
  CONVERTED_TO_AREA: 'エリアに変更しました',
  TRUCK_GROUP_FILTER_CONFIGURED: 'グループ検索のフィルターに設定しました',
  DIRECTION_FILTER_CONFIGURED: 'を配送依頼の検索条件に設定しました'
} as const

export const COMMON_HTTP_ERROR_MESSAGE = {
  RESPONSE_CODE_500:
    'サーバーで予期しないエラーが発生しました。\n継続して発生する場合はページを再読み込みしてもう一度お試しください。\n\nエラーの詳細は自動的に送信され、開発チームが調査いたします。\n解消しない場合は、下記のエラーIDを添えてサポートまでご連絡ください。\n\nエラーID: ',
  RESPONSE_CODE_503: `サーバ負荷が高いため処理を中断しました。\n時間をおいて再度お試しください。`,
  RESPONSE_CODE_409: {
    DEFAULT:
      'データの更新で競合が発生しました。\nデータの再更新を実施して再度お試しください。',
    DB_RECORD_NOT_FOUND:
      '更新対象のデータが見つかりませんでした。\nデータの再更新を実施して再度お試しください。',
    DB_UNIQUE_CONSTRAINT:
      '指定の値がすでに存在するため更新できませんでした。\nデータの再更新を実施して再度お試しください。',
    // 配車板の楽観ロック（層1: 配車構造 / 層2: 配送依頼）。
    // 層で文言を分けるのは、ユーザーが次に見るべき場所が違うため
    // （層1=矢羽根の並び、層2=配送依頼の中身）。
    STALE_DISPATCH_STRUCTURE:
      '他の利用者が配車を変更したため保存できませんでした。\n最新の状態に更新したので、内容を確認して再度お試しください。',
    STALE_SHIPMENT_ORDER:
      '他の利用者が配送依頼を変更したため保存できませんでした。\n最新の状態に更新したので、内容を確認して再度お試しください。'
  },
  NETWORK_ERROR:
    '通信エラーが発生しました。\nネットワーク接続を確認して再度お試しください。',
  TIMEOUT_ERROR:
    'タイムアウトが発生しました。\n時間をおいて再度お試しください。'
}

/**
 * アクション後に失敗したことを通知するメッセージを表す定数
 *
 * 定数名は文形式とする
 * 口語のように意味が通れば単語省略可
 * 例:
 * - DO (YOU) SAVE?
 * - (IT WAS) NOT FOUND.
 */
export const ERROR_MESSAGES = {
  FAILED_TO_REGISTER: '登録に失敗しました',
  INVALID_CREDENTIALS: 'ユーザー名またはパスワードが正しくありません。',
  AUTH0_ENV_LOAD_ERROR: 'エラーが発生しました。\nリロードしてください。',
  AUTH0_LOGIN_ERROR: 'エラーが発生しました。再度お試しください。',
  MISSING_AUTH_CODE_OR_STATE: '認証コードまたはステート情報が見つかりません',
  SESSION_VALIDATION_FAILED: 'セッションの検証に失敗しました',
  FAILED_TO_SAVE: '保存に失敗しました',
  FAILED_TO_LOAD: '読み込みに失敗しました',
  FAILED_TO_UPDATE_DRIVER: 'ドライバーの変更に失敗しました',
  FAILED_TO_UPDATE_REPORT_DETAIL_HIDDEN: '明細非表示の変更に失敗しました',
  FAILED_TO_DELETE: '削除に失敗しました',
  FAILED_TO_HIDE: '非表示に失敗しました',
  FAILED_TO_UNHIDE: '再表示に失敗しました',
  FAILED_TO_DEACTIVATE: '配車表示の終了に失敗しました',
  FAILED_TO_DEACTIVATE_ITEM: '無効化に失敗しました',
  CONTRACT_DELETE_FAILED: (contractName: string, reason: string) =>
    `${contractName} の削除に失敗しました：${reason}`,
  CONTRACT_REVISE_FAILED: (contractName: string, reason: string) =>
    `${contractName} の改訂に失敗しました：${reason}`,
  UNKNOWN_ERROR_REASON: '原因不明のエラー',
  NO_BULK_DELETE_TARGET: '削除対象が選択されていません',
  CANNOT_DELETE_USED_CONTRACT: '使用済みの契約は削除できません。',
  NO_BULK_REVISE_TARGET: '改訂対象が選択されていません',
  REVISION_ALLOWED_ONLY_UNREVISED: '使用済みかつ未改訂の契約のみ改訂できます。',
  NETWORK_ERROR: 'ネットワークエラーが発生しました',
  VALIDATION_ERROR: '入力内容に誤りがあります',
  PERMISSION_ERROR: '権限がありません',
  NOT_FOUND: 'データが見つかりません',
  SERVER_ERROR: 'サーバーエラーが発生しました',
  NO_TARGET_DATA: '対象のデータがありません',
  FAILED_TO_REGISTER_TRUCK: '車両の登録に失敗しました',
  FAILED_TO_UPDATE_TRUCK: '車両の更新に失敗しました',
  FAILED_TO_REGISTER_DRIVER: 'ドライバーの登録に失敗しました',
  FAILED_TO_UPDATE_ORDER_NO: '配送依頼Noの更新に失敗しました',
  FAILED_TO_BUNDLE_SHIPMENT_ORDERS: '配送依頼のまとめに失敗しました',
  FAILED_TO_BULK_UPDATE_DATES: '日付の変更に失敗しました',
  FAILED_TO_UNBUNDLE_SHIPMENT_ORDERS: '束ねの解除に失敗しました',
  FAILED_TO_SEPARATE_FROM_BUNDLE: '束ねからの分離に失敗しました',
  FAILED_TO_REGISTER_SUB_PARTNER: '実運送会社の登録に失敗しました',
  PARTNER_NOT_FOUND: '該当するパートナーが見つかりません',
  SUB_PARTNER_NOT_FOUND: '該当する実運送会社が見つかりません',
  FAILED_TO_STATUS_UPDATING: 'ステータスの更新中にエラーが発生しました',
  FAILED_TO_STATUS_UPDATE: 'ステータスの更新に失敗しました',
  COUNT_FAILED_TO_UPDATE_STATUS: (x: number) =>
    `${x} 件のステータスの更新に失敗しました`,
  INCOMPLETE_INPUT: '入力に不備があります',
  COMPLETED_TO_UPDATE_STATUS_BUT_FAILED_TO_UPDATE_DISPATCH:
    'ステータス変更は完了しましたが、配車情報の更新に失敗しました',
  FAILED_TO_ADD_TOUR: '運行実績の追加に失敗しました',
  FAILED_TO_CANCEL_TOUR_CHECK_STATUS:
    'この運行実績はキャンセルできません。現在のステータスを確認してください。',
  FAILED_TO_UPDATE_TOUR: '運行実績の更新に失敗しました',
  FAILED_TO_DELETE_TOUR: '運行実績の削除に失敗しました',
  FAILED_TO_CANCEL_TOUR: '運行実績のキャンセルに失敗しました',
  FAILED_TO_RESTORE_TOUR: '運行キャンセルの解除に失敗しました',
  FAILED_TO_DETACH_LOGIN_ACCOUNT: 'ログインアカウントの解除に失敗しました',
  FAILED_TO_REGISTER_DISPATCH: '運行情報の登録に失敗しました',
  FAILED_TO_UPDATE_DISPATCH: '運行情報の更新に失敗しました',
  FAILED_TO_SWAPPED_DISPATCH: '運行情報の入れ替えに失敗しました',
  FAILED_TO_REVERT_TO_SHIPMENT_ORDER: '配送依頼の取り消しに失敗しました',
  FAILED_TO_DUPLICATE_SHIPMENT_ORDER: '配送依頼の複製に失敗しました',
  FAILED_TO_DELETE_SHIPMENT_ORDER: '配送依頼の削除に失敗しました',
  FAILED_TO_DELETE_DISPATCH_FRAME: '枠の削除に失敗しました',
  // VOC_PJ-445 #1864: 一覧からの一括削除
  FAILED_TO_DELETE_SHIPMENT_ORDERS: '配送依頼の削除に失敗しました',
  // VOC_PJ-981 #4620
  FAILED_TO_REVOKE_SHIPMENT_ORDER: '配送依頼の取消に失敗しました',
  FAILED_TO_RESTORE_REVOKED_SHIPMENT_ORDER:
    '配送依頼の取消の取り消しに失敗しました',
  FAILED_TO_DISPATCH: '配車の実行に失敗しました',
  FAILED_TO_SHOW_EDITING_VIEW: '編集画面の表示に失敗しました',
  FAILED_TO_UPDATE_STATUS: 'ステータスの更新に失敗しました',
  FAILED_TO_CHANGE_STATUS: 'ステータスの変更に失敗しました',
  DISPATCH_RESULT_REPORT_NOT_FOUND: '帳票出力対象データが存在しません',
  // TODO: スケジュール？スケジュール枠？
  FAILED_TO_REGISTER_SCHEDULE: 'スケジュールの登録に失敗しました',
  FAILED_TO_UPDATE_SCHEDULE: '予定枠の更新に失敗しました',
  NO_DC_SELECTED: '拠点IDが選択されていません',
  NO_DC_FOUND: '拠点が見つかりませんでした',
  NOT_DC_MANAGER: '拠点マネージャーのみ編集できます',
  TARIFF_EXPORT_FAILED: 'タリフエクスポートに失敗しました',
  FAILED_TO_UPDATE_SHIPMENT_ORDER: '配送依頼の更新に失敗しました',
  FAILED_TO_TRANSIT_DISPATCH_TO: {
    CANCEL_REQUEST: '依頼のキャンセルに失敗しました',
    WITH_DRAW: '取下げに失敗しました',
    REJECT: '却下処理に失敗しました',
    HOLD: '保留処理に失敗しました'
  },
  FAILED_TO_RESCHEDULE_DISPATCH_DETAIL: '配車予定の更新に失敗しました',
  FAILED_TO_ADD_SHIPMENT_ORDER: '配送依頼の追加に失敗しました',
  CANNOT_MOVE_SPOT_TRUCK_TO_REGULAR:
    'スポット車両はレギュラー車両に移動できません',
  CANNOT_MOVE_REGULAR_TRUCK_TO_SPOT:
    'レギュラー車両はスポット車両に移動できません',
  COUNT_FAILED_TO_UPDATE_TOUR: (x: number) =>
    `${x} 件の運行実績の更新に失敗しました`,
  FAILED_TO_DOWNLOAD: 'ダウンロードに失敗しました',
  FAILED_TO_EXPORT_CSV: 'CSVエクスポートに失敗しました',
  FAILED_TO_DOWNLOAD_DISPATCH_RESULT_REPORT: `帳票の作成に失敗しました
再度ダウンロードを試してください`,
  TOUR_NOT_FOUND: '運行実績がありません',
  // VOC_PJ-931 #4312: 非表示リストが空・取得失敗のときにパネルが白紙になるのを防ぐ
  HIDDEN_CHARGE_NOT_FOUND: '非表示にした明細がありません',
  FAILED_TO_FETCH_HIDDEN_CHARGES: '非表示にした明細の取得に失敗しました',
  FAILED_TO_UPDATE_ADDITIONAL_CHARGES: '追加請求の更新に失敗しました',
  FAILED_TO_REGISTER_PACKAGE_CATEGORY: '荷姿の登録に失敗しました',
  FAILED_TO_REVISE_CONTRACT: '契約の改訂に失敗しました',
  FAILED_TO_UPDATE_APPLY_END_DATE: '適用終了日の更新に失敗しました',
  FAILED_TO_REGISTER_CUSTOMER: '荷主の登録に失敗しました',
  FAILED_TO_UPDATE_MONTHLY_STATUS: '月次ステータスの更新に失敗しました',
  FAILED_TO_UPDATE_BILLING_STATUS: '請求ステータスの更新に失敗しました',
  FAILED_TO_FINALIZE_MONTHLY_REPORT: '月次レポートの一括確定に失敗しました',
  FAILED_TO_UPDATE_ADDITIONAL_PAYMENTS:
    '追加料金・前月調整の更新に失敗しました',
  FAILED_TO_CONFIRMATION: '確定に失敗しました',
  FAILED_TO_REGISTER_SITE: '地点の登録に失敗しました',
  FAILED_TO_UPDATE_SITE: '地点の更新に失敗しました',
  FAILED_TO_LINK_SITE_WITH_CUSTOMER:
    '地点は保存されましたが、荷主との関連付けに失敗しました',
  /** 地点セレクトの「関連付ける」ボタンで地点側の更新自体が失敗（#3669） */
  FAILED_TO_LINK_CUSTOMER_WITH_SITE: '荷主と地点の関連付けに失敗しました',
  /** 地点側の更新は成功したが、荷主コード未設定時のバックフィルが失敗（#3669） */
  FAILED_TO_BACKFILL_CUSTOMER_SITE_GROUP_CODE:
    '地点は関連付けられましたが、荷主側のコード設定に失敗しました',
  FAILED_TO_EXPORT_DISPATCH_RESULTS: '配車結果のエクスポートに失敗しました',
  FAILED_TO_DOWNLOAD_DISPATCH_REQUEST_FORM:
    '配車依頼書のダウンロードに失敗しました',
  FAILED_TO_DOWNLOAD_DISPATCH_REQUEST_FORM_FOR_EACH_TRUCK:
    '配車依頼書（車両ごと）のダウンロードに失敗しました',
  FAILED_TO_DOWNLOAD_IN_HOUSE_INSTRUCTION_SHEET:
    '配送指示書（自車）のダウンロードに失敗しました',
  TRUCK_NOT_FOUND: '車両情報が見つかりません',
  FAILED_TO_SORT_TRUCK: '並び替えに失敗しました',
  FAILED_TO_DUPLICATE: '複製に失敗しました',
  FAILED_TO_UPDATE: '更新に失敗しました',
  FAILED_TO_DELETE_DISPATCH: '運行情報の削除に失敗しました',
  ESTIMATED_CHARGE_NOT_FOUND: '該当の契約金額が見つかりませんでした',
  ESTIMATED_CHARGE_INCOME_NOT_FOUND: '該当の請求契約金額が見つかりませんでした',
  FAILED_TO_GROUP_TRUCK: '車両グループの設定に失敗しました',
  FAILED_TO_CALCULATED_ESTIMATED_CHARGE: '契約運賃の取得に失敗しました',
  FAILED_TO_ALREADY_ADDED_DISPATCH_DETAIL:
    '指定された日時には既に予定が入っています',
  FAILED_TO_ROLLBACK_IMPORT: 'インポートの取り消しに失敗しました',
  FAILED_TO_RESUME_IMPORT: 'インポートの再開に失敗しました',
  FAILED_TO_FINISH_IMPORT: '中断したインポートの終了に失敗しました',
  FAILED_TO_INTERRUPT_IMPORT: 'インポートの中断に失敗しました',
  FAILED_TO_REGISTER_SHIPMENT_CATEGORY: '配送種別の登録に失敗しました',
  FAILED_TO_IMPORT_TOUR_CONTRACT: '運行建契約のインポートに失敗しました',
  FAILED_TO_START_TRUCK_IMPORT: '車両データのインポートに失敗しました',
  FAILED_TO_START_TRUCK_CLASS_IMPORT: '車格データのインポートに失敗しました',
  FAILED_TO_START_TRUCK_MODEL_IMPORT: '車種データのインポートに失敗しました',
  FAILED_TO_CREATE: '作成に失敗しました',
  OVER_MAX_FILE_SIZE_MB: (x: number) =>
    `ファイルの上限サイズ${x}MBを超えています`,
  FAILED_TO_GET_UPLOAD_DESTINATION_URL:
    'アップロード先のURLの取得に失敗しました',
  DUPLICATE_FILE_NAME: 'ファイル名が重複しています',
  DUPLICATE_FILE_NAME_ERROR: 'ファイル名重複エラー',
  SELECT_FILE: 'ファイルを選択してください',
  UPLOAD_FILE_CORRECTLY: 'ファイルを正しくアップロードしてください',
  FAILED_TO_REGISTER_DC: '拠点の登録に失敗しました',
  FAILED_TO_IMPORT_SHIPMENT_ORDER: '配送依頼のインポートに失敗しました',
  FAILED_TO_IMPORT_SUNTORY_DEDICATED_SHIPMENT_ORDER:
    'サントリー得意先配送インポートに失敗しました',
  FAILED_TO_IMPORT_TOUR_CSV: '運行実績のインポートに失敗しました',
  INVALID_SEARCH_PARAMETERS: '検索パラメータが不正です',
  LOOKING_FOR_CANNOT_DISPLAYED: 'お探しのページは表示できません',
  LOOKING_FOR_COULD_NOT_FOUND: 'お探しのページは見つかりませんでした',
  ERROR_IN_ROUTER: '予期しないエラーが発生しました',
  ERROR_IN_ROUTER_DESCRIPTION:
    'ご迷惑お掛けして申し訳ございません。\nページを再読み込みしてもう一度お試しください。',
  ERROR_IN_ROUTER_EVENT_ID_DESCRIPTION:
    'エラーの詳細は自動的に送信され、開発チームが調査いたします。\n解消しない場合は、下記のエラーIDを添えてサポートまでご連絡ください。\n\nエラーID:',
  FAILED_TO_CANCEL_CLOSING_DATE_CHANGE: '締日変更のキャンセルに失敗しました',
  FAILED_TO_UPDATE_CLOSING_DATE: '締日の更新に失敗しました',
  FAILED_TO_IMPORT_INVOICE_FARE: '請求運賃のインポートに失敗しました',
  FAILED_TO_SOME_REQUESTS: '一部の依頼が失敗しました:',
  REQUEST_PARTNER_ERROR: 'パートナーへの依頼でエラーが発生しました:',
  FAILED_TO_REQUEST_PARTNER: 'パートナーへの依頼に失敗しました',
  FAILED_TO_SOME_CONFIRM_OPERATIONS: '一部の運行確定が失敗しました:',
  CONFIRM_OPERATIONS_ERROR: '運行確定でエラーが発生しました:',
  FAILED_TO_CONFIRM_OPERATIONS: '運行確定に失敗しました',
  FAILED_TO_SOME_BULK_APPROVE: '一部の承認が失敗しました:',
  BULK_APPROVE_ERROR: '依頼一括承認でエラーが発生しました:',
  FAILED_TO_BULK_APPROVE: '依頼一括承認に失敗しました',
  FAILED_TO_SITE_IMPORT: '地点データのインポートに失敗しました',
  FAILED_TO_TRUCK_TYPE_IMPORT: '車両属性データのインポートに失敗しました',
  FAILED_TO_SHIPMENT_CATEGORY_IMPORT:
    '配送種別データのインポートに失敗しました',
  FAILED_TO_PACKAGE_CATEGORY_IMPORT: '荷姿データのインポートに失敗しました',
  FAILED_TO_START_TARIFF_IMPORT: 'タリフデータのインポートに失敗しました',
  SEARCH_CONDITION_ERROR: '検索条件に使用できない文字が含まれています',
  FAILED_TO_CONVERT_TO_SITE: '地点への変更に失敗しました',
  FAILED_TO_CONVERT_TO_AREA: 'エリアへの変更に失敗しました',
  CONVERT_TO_ISO_STRING_ERROR: 'toISOString変換エラー:',
  FAILED_TO_BULK_OPERATION: (company: string, action: string) =>
    `${company}の${action}が失敗しました。時間をあけて再度実行してください。`,
  FAILED_TO_FIND_TRUCK_GROUP: '車両グループが見つかりませんでした',
  SHIPPING_DATE_REQUIRED: '発送日の開始日と終了日を指定してください。',
  SHIPPING_DATE_RANGE_EXCEEDED:
    '発送日の検索期間は12ヶ月以内で指定してください。',
  // #4568 逆転レンジ（From > To）
  SHIPPING_DATE_RANGE_REVERSED:
    '発送日の終了日は開始日と同じ日か、それより後の日付を指定してください。',
  // #5285 VOC_PJ-506 登録日レンジ。片側指定は補完するため必須エラーは持たない
  CREATED_AT_RANGE_REVERSED:
    '登録日の終了日は開始日と同じ日か、それより後の日付を指定してください。',
  CREATED_AT_RANGE_EXCEEDED: '登録日の検索期間は12ヶ月以内で指定してください。',
  // #4557 運行実績一覧の運行日。#4421 がレポートの計上日に
  // OPERATING_DATE_RANGE_EXCEEDED を使っているため、こちらは TOUR_ 接頭辞で分ける
  TOUR_OPERATING_DATE_REQUIRED: '運行日の開始日と終了日を指定してください。',
  TOUR_OPERATING_DATE_RANGE_EXCEEDED:
    '運行日の検索期間は12ヶ月以内で指定してください。',
  OPERATING_YEAR_MONTH_RANGE_EXCEEDED:
    '運行年月の検索期間は12カ月以内で指定してください',
  OPERATING_YEAR_MONTH_REQUIRED: '計上月を指定してください。',
  // #4421 レポートの日付範囲検索
  OPERATING_DATE_RANGE_REVERSED:
    '計上日の終了日は開始日と同じ日か、それより後の日付を指定してください。',
  OPERATING_DATE_RANGE_EXCEEDED:
    '計上日の検索期間は12カ月以内で指定してください。',
  CUSTOMER_REQUIRED_FOR_CLOSING_DATE:
    '締日基準（請求月）検索では荷主を指定してください。',
  MASTER_NOTE_REQUIRED: 'タイトル、URL、本文のいずれかを入力してください'
} as const

/**
 * アクション後に警告が発生したことを通知するメッセージを表す定数
 *
 * 定数名は文形式とする
 * 口語のように意味が通れば単語省略可
 * 例:
 * - DO (YOU) SAVE?
 * - (IT WAS) NOT FOUND.
 */
export const WARN_MESSAGES = {
  CUSTOMER_CONTRACTS_REVISE_FAILED_EXISTS:
    '処理に失敗した契約が存在するのでチェックが付いた契約を確認した後に最新の状態を表示するため再検索してください',
  DEACTIVATE_HIDES_AFTER_END_DATE:
    '適用終了日より後の日付は、配車板に表示されなくなります。'
} as const

/**
 * マスタ画面の並び順プリセット (VOC_PJ-769 #3160) 系メッセージ
 */
export const PLAN_SLOT_SORT_PRESET_MESSAGES = {
  // PresetSelectBar
  SELECT_PLACEHOLDER: 'プリセット未選択',
  CLEAR_ACTIVE: 'デフォルト',
  CREATE_NEW: '新規プリセット作成',
  OPEN_MANAGE: 'プリセット管理(名前変更・削除)',

  // 操作ヒント (PlanSlotsTable 上部)
  DRAG_HINT: '行をドラッグして並び替えできます',

  // DirtyEditBanner
  LEAVE_CONFIRM:
    '編集中のプリセット並び順は保存されていません。このページを離れますか？',
  DRAFT_NOTICE_NAMED: (name: string) =>
    `${name} の並び順を変更しました（未保存）`,
  DRAFT_NOTICE_FALLBACK: '並び順を変更しました（未保存）',
  DISCARD: '破棄',
  SAVE_AS: '名前を付けて保存',
  OVERWRITE: '上書き保存',

  // PresetManageModal
  MANAGE_TITLE: 'プリセット管理',
  MANAGE_EMPTY: 'プリセットが登録されていません。',
  NAME_REQUIRED: 'プリセット名は空にできません',
  CONFIRM_DELETE: (name: string) =>
    `プリセット「${name}」を削除します。よろしいですか？`,
  RENAME: '名前変更',
  SELECTED_MARK: '(選択中)',

  // 規定 (isDefault) 表示
  DEFAULT_MARK: '★',
  SET_AS_DEFAULT: '配車板の規定にする',
  DEFAULT_BADGE: '(規定)',
  DEFAULT_ARIA_LABEL: '規定',
  DEFAULT_PRESET_ARIA_LABEL: '規定プリセット',

  // 親行 columns: 適用期間件数列
  APPLY_PERIODS_LABEL: '適用期間',
  PERIOD_COUNT_UNIT: '件',
  PERIOD_COUNT_HISTORY_PREFIX: '/ 履歴',
  PERIOD_COUNT_HISTORY_ONLY: '履歴のみ',

  // PresetSwitchConfirmModal
  SWITCH_CONFIRM_TITLE: '未保存の並び順があります',
  SWITCH_CONFIRM_PREFIX: '現在のプリセット',
  SWITCH_CONFIRM_SUFFIX: 'の並び順に未保存の変更があります。どうしますか？',
  SWITCH_DISCARD: '破棄して切替',
  SWITCH_OVERWRITE: '上書き保存して切替',

  // SaveAsPresetModal
  NAME_PLACEHOLDER: 'プリセット名(30文字まで)',

  // 「名前を付けて保存」初期値サフィックス
  COPY_SUFFIX: ' のコピー',

  // Error messages
  PARTNER_NOT_SELECTED: 'partner が選択されていません'
} as const

/**
 * 配車板並び順プリセット (#3159 DispatchBoardSortPreset) 用メッセージ。
 *
 * 設計書 §6 操作一覧 + mock A3 `a3-mixed-pc.tsx` の文言を本実装用に整理。
 * #3160 マスタ用 (PLAN_SLOT_SORT_PRESET_MESSAGES) と同形だが、本件は配車板側で
 * 文言を「配車板〜」に差別化、isDefault/setDefault 系は本件 scope 外で省略、
 * 過去日警告 + プリセット上限 (20 件) 系を追加。
 */
export const DISPATCH_BOARD_SORT_PRESET_MESSAGES = {
  PRESET_LIMIT: 20,

  // PresetSelectBar
  SELECT_PLACEHOLDER: '並び順プリセット',
  CLEAR_ACTIVE: 'マスタ既定 + 当日SPOT末尾',
  CREATE_NEW: '新規配車板プリセット作成',
  OPEN_MANAGE: '配車板プリセット管理(名前変更・削除)',

  // DirtyEditBanner
  LEAVE_CONFIRM:
    '編集中の配車板並び順は保存されていません。このページを離れますか？',
  DRAFT_NOTICE_NAMED: (name: string) =>
    `配車板プリセット「${name}」の並び順を変更しました（未保存）`,
  DRAFT_NOTICE_FALLBACK: '配車板の並び順を変更しました（未保存）',
  DISCARD: '前回保存した並びに戻す',
  SAVE_AS: '名前を付けて保存',
  OVERWRITE: '上書き保存',

  // PresetManageModal
  MANAGE_TITLE: '配車板プリセット管理',
  MANAGE_EMPTY: '配車板プリセットが登録されていません。',
  // BE DTO の @IsNotEmpty と文言を揃える (30 文字超は antd Input の maxLength={30}
  // で入力段階で防げるためトースト文言は持たない)
  NAME_REQUIRED: 'プリセット名を入力してください',
  CONFIRM_DELETE: (name: string) =>
    `配車板プリセット「${name}」を削除します。よろしいですか？`,
  RENAME: '名前変更',

  // SaveAsPresetModal
  NAME_PLACEHOLDER: '配車板プリセット名(30文字まで)',
  COPY_SUFFIX: ' のコピー',

  // PresetSwitchConfirmModal (isDirty 中の切替 / 日付切替確認)
  SWITCH_CONFIRM_TITLE: '未保存の並び順があります',
  SWITCH_CONFIRM_PREFIX: '現在の配車板プリセット',
  SWITCH_CONFIRM_SUFFIX: 'の並び順に未保存の変更があります。どうしますか？',
  SWITCH_DISCARD: '破棄して切替',
  SWITCH_OVERWRITE: '上書き保存して切替',

  // プリセット上限
  PRESET_LIMIT_REACHED: (limit: number) =>
    `配車板プリセットは ${limit} 件までです。不要なものを削除してから新規作成してください。`,
  DUPLICATE_NAME: '同じ名前のプリセットがあります',

  // Error messages
  PARTNER_NOT_SELECTED: 'partner が選択されていません',

  // Select の × Clear 押下時 (Preset 選択解除 + draft クリア)
  RESET_TO_MASTER_DEFAULT: '配車表示車両マスタ設定の状態にリセットしました',

  // 旧並び順 (v2 localStorage) の手動マイグレーション
  LEGACY_ORDER_MIGRATE_BUTTON: '旧並び順を移行',
  LEGACY_ORDER_MIGRATE_PRESET_NAME_PREFIX: '移行 ',
  LEGACY_ORDER_MIGRATE_SUCCESS: (name: string) =>
    `旧並び順を「${name}」プリセットに移行しました`,
  LEGACY_ORDER_MIGRATE_PARSE_ERROR:
    '旧並び順の読み込みに失敗しました。データを破棄します。',
  LEGACY_ORDER_MIGRATE_EMPTY:
    '旧並び順の中に当日の車両行が無かったため、移行をキャンセルしました。'
} as const

/**
 * 配送依頼 汎用CSVインポート（独自フォーマット・マッピング対応）のUI文言。
 * VOC_PJ-592 #4071。ウィザード（①ファイル選択・開始行 ②マッピング ③プレビュー ④取込実行）で使用。
 */
export const SHIPMENT_ORDER_CSV_IMPORT = {
  // ステップ見出し
  STEP_MAPPING: 'マッピング設定',
  STEP_PREVIEW: 'プレビュー・エラー確認',
  STEP_EXECUTE: '取り込み実行',

  // ステップ1: ファイル選択・開始行
  SELECT_CSV_FILE: 'CSVファイルを選択',
  FILE_ALERT_MESSAGE:
    '取り込むCSVファイルを選択し、ヘッダー行・データ開始行・開始列を確認してください',
  FILE_ALERT_DESCRIPTION:
    '1行目が項目名（ヘッダー）か、いきなりデータかを選びます。タイトル行や不要な左側の列がある場合は、データ開始行・開始列をずらせます。',
  CLICK_OR_DROP_CSV:
    'クリックまたはドラッグ&ドロップでCSVファイルをアップロード',
  ONLY_CSV_FILE:
    '※ 取り込めるのは CSV 形式のみです（文字コードは自動判定します。Excel .xlsx は CSV で保存してから取り込んでください）。',
  CHANGE_FILE: 'ファイルを変更',
  FILE_SUMMARY: (rows: number, cols: number, encoding: string) =>
    `CSV / ${rows} 行 × ${cols} 列 ・ 文字コード: ${encoding}`,
  ENCODING_FIELD_LABEL: '文字コード',
  ENCODING_AUTO: '自動判定',
  ENCODING_HINT: '文字化けする場合は選び直してください',
  FIRST_ROW: '1行目',
  FIRST_ROW_HEADER: '項目名（ヘッダー）',
  FIRST_ROW_DATA: 'データ（ヘッダー無し）',
  HEADER_ROW: 'ヘッダー行',
  DATA_START_ROW: 'データ開始行',
  START_COLUMN: '開始列',
  ROW_SUFFIX: '行目',
  ROW_FROM_SUFFIX: '行目から',
  COLUMN_SUFFIX: '列目',
  COLUMN_FROM_SUFFIX: '列目から',
  FILE_PREVIEW: 'ファイルプレビュー',
  LEGEND_HEADER_ROW: 'ヘッダー行',
  LEGEND_SKIP_BEFORE_START: 'スキップ（開始行・開始列より前）',
  COLUMN_LABEL: (idx: number) => `列${idx + 1}`,
  NO_FILE_SELECTED: 'ファイルが選択されていません',

  // ステップ2: マッピング設定（④）
  MAPPING_ALERT_MESSAGE:
    'アップロードしたCSVの各列を、ロジGoの配送依頼項目に紐づけてください',
  MAPPING_ALERT_DESCRIPTION:
    '1つの項目は1列にしか割り当てられません（選んだ項目は他列の候補から消えます）。取り込まない列は空欄のまま。★ の必須項目をすべて紐づけると次に進めます。',
  MAPPING_RECAP_HEADER: (headerRowNo: number) =>
    `1行目: 項目名（ヘッダー / ${headerRowNo}行目）`,
  MAPPING_RECAP_NO_HEADER: '1行目: データ（ヘッダー無し）',
  MAPPING_RECAP_START_ROW: (startRowNo: number) =>
    `データ開始行: ${startRowNo} 行目`,
  MAPPING_REQUIRED_LABEL: '必須項目チェック',
  MAPPING_COL_HEADER_CSV: 'アップロードしたCSVの列',
  MAPPING_COL_HEADER_LOGI: 'ロジGoの配送依頼項目',
  MAPPING_DATA_PREVIEW: (preview: string) => `先頭データ: ${preview}`,
  MAPPING_DATA_EMPTY: '（空）',
  MAPPING_NOT_IMPORT: '（取り込まない）',
  MAPPING_MISSING_REQUIRED: (labels: string) => `未割当の必須項目: ${labels}`,
  MAPPING_SKIP_HINT:
    '必須項目が列に紐づいているかをここで確認できます。未紐づけの項目はクリックすると「列が無いので後で手入力する」に切り替えられます（次の確認画面で1件ずつ、または一括で値を入力できます）。',
  MAPPING_SKIP_TOOLTIP_MARK: 'クリック: 列が無いので後で手入力する',
  MAPPING_SKIP_TOOLTIP_UNMARK: 'クリック: 列に紐づける（手入力予定を解除）',
  MAPPING_SKIP_SUFFIX: '（手入力予定）',

  // フッター
  // 取り込み方法を選ぶ前（行き先が決まっていない）の「次へ」
  NEXT: '次へ',
  NEXT_MAPPING: '次へ（マッピング）',
  NEXT_PREVIEW: '次へ（プレビュー）',
  EXECUTE_IMPORT: '取り込み実行',
  BACK: '戻る',
  BACK_MAPPING: '戻る（マッピング）',
  FILE_FOOTER_NOTE:
    '1行目の扱い・データ開始行・開始列を確認したら次へ進みます。',
  PARSE_ERROR:
    'CSVファイルの読み込みに失敗しました。ファイルをご確認ください。',
  FILE_TOO_LARGE: (mb: number) =>
    `ファイルサイズが大きすぎます（${mb}MB まで）。分割してから取り込んでください。`,
  PREVIEW_TRUNCATED: (limit: number, total: number) =>
    `先頭 ${limit} 行のみ表示（全 ${total} 行）`,
  // マスタ参照項目の名称表示トグル。ONでコード列に「コード/名称」形式で名称を追記する。
  PREVIEW_SHOW_MASTER_NAMES: '荷主・発着地等の名称も表示する',

  // ステップ0: 取り込み方法
  // 取り込み方法を選ぶと同じ画面の下にファイル選択が出るため、1 段にまとめる
  STEP_METHOD: '取り込み方法・ファイル選択',
  METHOD_ALERT_MESSAGE: '取り込み方法を選択してください',
  METHOD_ALERT_DESCRIPTION:
    '取り込む CSV の形に合わせて選びます。保存した列の対応は対応づけの手間を省くためのもので、選んだあとも内容を確認・修正できます。',
  METHOD_STANDARD_TITLE: 'ロジGo規定フォーマットで取り込む',
  METHOD_STANDARD_DESCRIPTION:
    'ロジGo が決めた列の並びの CSV を、そのまま取り込みます（テンプレートをダウンロードできます）。',
  METHOD_SAVED_TITLE: '保存した列の対応で取り込む',
  METHOD_SAVED_DESCRIPTION:
    '前に保存した列の対応（フォーマット）を読み込んで取り込みます。読み込んだ後に確認・修正できます。',
  METHOD_ADHOC_TITLE: '列を対応づけて取り込む',
  METHOD_ADHOC_DESCRIPTION:
    '列の並びや名前が違う CSV を、ロジGo の項目に対応づけて取り込みます。',
  // サントリー様の CSV は、それぞれ既存の取り込み（別モーダル）へ渡す
  METHOD_SUNTORY_INTERNAL_TITLE: 'サントリー社内移動',
  METHOD_SUNTORY_INTERNAL_DESCRIPTION:
    'サントリー様の社内移動CSV（Shift_JIS）を、確認画面で中身を見てから取り込みます。',
  METHOD_SUNTORY_DEDICATED_DESCRIPTION:
    'サントリー様の得意先出荷CSV（Shift_JIS）を、確認画面で中身を見てから取り込みます。',
  // サントリー様の CSV: 画面では読めないため、事前チェックが読んだ行を確認画面に並べる。
  // マスタに無いエラーのセルは画面で選び直せ、それ以外（読み取りで落ちた行など）はファイルを直す
  SUNTORY_FILE_ALERT_MESSAGE:
    '取り込むサントリー様のCSVファイルを選択してください',
  SUNTORY_FILE_ALERT_DESCRIPTION:
    '※ 取り込めるのは CSV 形式のみです（サントリー様のCSVは Shift_JIS として読み込みます）。',
  SUNTORY_CHECKING: 'ファイルの中身を確認しています',
  SUNTORY_CHECK_FAILED:
    'ファイルの中身を確認できませんでした。もう一度「戻る」から選び直してください',
  SUNTORY_PREVIEW_SUMMARY: (total: number, errors: number) =>
    `対象 ${total} 件  エラー ${errors} 件`,
  SUNTORY_PREVIEW_HAS_ERRORS:
    'エラーがあるため、まだ取り込めません。荷主・配送種別・発地・着地・荷姿・車種・パートナーの赤いセルは、その場で選び直せます。それ以外のエラーは、CSVファイルを直してから選び直してください。',
  SUNTORY_RECHECKING: '直した値で確認しています',
  SUNTORY_PREVIEW_EMPTY: '取り込む行がありません',
  SUNTORY_PREVIEW_ERROR_HEADER: 'エラー',
  // 読み取りの段階で落ちた行（値が読めずマスタの照合まで進めない行）の見分け方と理由
  SUNTORY_READ_FAILURE_IDENTITY: (
    line: number,
    detailId: string | null,
    destName: string | null,
    itemName: string | null
  ) =>
    `CSV ${line} 行目（明細ID ${detailId ?? '-'}・届先 ${destName ?? '-'}・品目 ${itemName ?? '-'}）`,
  SUNTORY_READ_FAILURE_DETAIL: (
    column: string,
    value: string,
    expected: string
  ) =>
    `「${column}」が${value === '' ? '空欄' : `「${value}」`}です。${expected}にしてください`,
  SUNTORY_SKIPPED_TITLE: (count: number) =>
    `読み飛ばした行（取り込みません） ${count} 件`,
  SUNTORY_SKIPPED_LINE_HEADER: 'CSV の行',
  SUNTORY_SKIPPED_REASON_HEADER: '理由',
  SUNTORY_SKIPPED_DETAIL_ID_HEADER: '明細ID',
  SUNTORY_SKIPPED_DEST_HEADER: '届先',
  SUNTORY_SKIPPED_ITEM_HEADER: '品目',
  SUNTORY_SKIP_REASON: {
    NO_DISPATCH_NO: '配車NO が空',
    NON_PRODUCT_ITEM: '品目コードに PAL- を含む（パレット等）'
  },
  METHOD_SAVED_SELECT_LABEL: '保存した列の対応',
  METHOD_SAVED_SELECT_PLACEHOLDER: 'フォーマットを選択してください',
  METHOD_SAVED_SELECT_EMPTY:
    'この拠点に保存した列の対応はまだありません（「列を対応づけて取り込む」の確認画面で保存できます）',
  MAPPING_TEMPLATE_APPLIED: (name: string, count: number) =>
    `フォーマット「${name}」を初期値として適用しました（${count} 列）。内容を確認し、必要に応じて修正してください。`,

  // ステップ: 確認画面（プレビュー・エラー確認）
  PREVIEW_ALERT_MESSAGE: '取り込み内容を確認してください',
  PREVIEW_ALERT_DESCRIPTION:
    'マッピング結果を配送依頼項目の並びで表示しています。形式エラー（日付・数値・必須空欄）・マスタ参照エラー（未登録コード）の行は赤色で表示されます。',
  PREVIEW_SUMMARY: (total: number, ok: number, err: number) =>
    `対象 ${total} 件 / 取り込み可能 ${ok} 件 / エラー ${err} 件`,
  PREVIEW_ERROR_REASON_DATE: '日付として読み取れません',
  PREVIEW_ERROR_REASON_NUMBER: '数値として読み取れません',
  PREVIEW_ERROR_REASON_REQUIRED_EMPTY: '必須項目が空です',
  // 時間制限のクロスフィールド検証（出典:
  // create-shipment-order-create-form-value.ts の custom() バリデータ）
  PREVIEW_ERROR_REASON_TIME_RESTRICTION_PAIR_REQUIRED:
    '開始・終了はセットで入力してください（片方だけでは登録できません）',
  PREVIEW_ERROR_REASON_TIME_RESTRICTION_ORDER_INVALID:
    '終了は開始以降の時刻にしてください',
  PREVIEW_ERROR_REASON_ARRIVAL_BEFORE_DEPARTURE:
    '着地の時間制限（開始）は、発地の時間制限（開始）以降にしてください',
  // マスタ参照項目（荷主/配送タイプ/発着地/パートナー/車種/荷姿）の存在チェック
  // （実マスタ検索 API の候補との突き合わせ。BE の validateRow のメッセージ形式に寄せる）
  PREVIEW_ERROR_REASON_MASTER_NOT_FOUND: '未登録または有効でないコードです',
  PREVIEW_EXCLUDE_ERRORS: 'エラー行を除外して取り込む',
  PREVIEW_STANDARD_NOTE:
    'ロジGo規定フォーマットとして読み取り、形式チェック（日付・数値・必須空欄）とマスタとの突き合わせ（未登録コード・明細IDの重複など）を行いました。',
  PREVIEW_STANDARD_MISMATCH:
    'ロジGo規定フォーマットの列が見つかりません。ヘッダー行が規定の列名と一致していないため、このファイルはロジGo規定フォーマットとして取り込めません。「列を対応づけて取り込む」で取り込んでください。',
  PREVIEW_EDIT_HINT:
    '赤いセルはその場で修正できます（修正すると再検証されます）。修正内容は取り込みデータにのみ反映され、元のファイルは変更されません。',
  BULK_FILL_TITLE: '必須項目の一括入力',
  // 運行計画のある行のまとめキーは使わない（#5786、行エラーにしない）。確認画面でそれと分かるように出す
  PREVIEW_BUNDLE_KEY_IGNORED_TITLE: (n: number) =>
    `運行計画のある ${n} 行のまとめキーは使いません`,
  PREVIEW_BUNDLE_KEY_IGNORED_DESCRIPTION:
    '運行計画（配車キー）のある行は、行ごとに配車板へ載せるため束ねません。束ねたい配送依頼は、運行計画の無い別のファイルに分けて取り込み（ロジGo規定フォーマットでは運行計画の 8 列（枠種別〜支払金額）を消す。列を対応づける取込では運行計画の項目を対応づけない）、配車板で配車してください。',
  BULK_FILL_DESCRIPTION:
    '必須項目のうち、列が無い項目と、エラーのある行がある項目に、まとめて値を入れられます。値を入れて「適用」を押すと、その項目にエラーのある行と、この画面で直した行に入ります（一度もエラーにならなかった行の値は変えません）。下の表で行を選択していれば、選択した行にだけ入ります（列の見出しの絞り込みで行を絞ってから選択できます。対象にならない行は選択できません）。自動登録はされません。内容を確認してから取り込み実行ボタンを押してください。1件ずつ直したい場合は下の表のセルを直接編集できます。',
  BULK_FILL_PLACEHOLDER: '入れる値',
  BULK_FILL_APPLY_ERROR_ROWS: (n: number) => `エラー・修正済みの ${n} 行に適用`,
  BULK_FILL_APPLY_SELECTED: (n: number) => `選択した ${n} 行に適用`,
  // 列の見出しで絞り込んでいて、行を選んでいないときの案内（#4728 で約束）。絞り込みだけでは対象は狭まらない
  BULK_FILL_FILTERED_NO_SELECTION:
    '絞り込んだ行だけに入れるときは、表の見出しのチェックで行を選んでください（選ばないと、絞り込みに関係なく対象の行すべてに入ります）',
  BULK_FILL_SELECTED_ROWS: (n: number) =>
    `表で ${n} 行を選択しています。適用すると選択した行にだけ入ります`,
  BULK_FILL_CLEAR_SELECTION: '選択を解除',
  PREVIEW_ROW_NO_HEADER: '行',
  PREVIEW_ERROR_DETAIL_HEADER: 'エラー内容',
  // 確認画面の情報密度見直し（表の上の操作行・セルの吹き出し編集）
  PREVIEW_FILTER_ERROR_ROWS: 'エラー行だけ表示',
  PREVIEW_GLOBAL_ISSUES_TITLE: 'ファイル全体の問題があります',
  PREVIEW_SITE_AUTO_CREATE_COUNT: (n: number) => `地点の自動作成 ${n} 件`,
  PREVIEW_SITE_AUTO_CREATE_ITEM: (rowNo: number, label: string, code: string) =>
    `${rowNo} 行目の${label}「${code}」は地点マスタに無いため、取り込み時に地点を作成します`,
  PREVIEW_SERVER_CHECKING: 'マスタとの突き合わせを確認中',
  PREVIEW_SERVER_CHECK_FAILED: 'マスタとの突き合わせを確認できませんでした',
  PREVIEW_SERVER_RECHECK: '最新の内容で確認し直す',
  UPLOAD_FAILED:
    'ファイルのアップロードに失敗しました。もう一度ファイルを選んでください',
  SAVE_FORMAT_FAILED:
    'フォーマットの保存に失敗しました（取り込みは受け付けています）',
  PREVIEW_FILTER_ERROR_COLUMNS: 'エラーのある列だけ表示',
  PREVIEW_SUMMARY_TOTAL: (n: number) => `対象 ${n} 件`,
  PREVIEW_SUMMARY_OK: (n: number) => `取り込み可能 ${n} 件`,
  PREVIEW_SUMMARY_ERROR: (n: number) => `エラー ${n} 件`,
  PREVIEW_EMPTY_CELL: '（空欄）',
  PREVIEW_CELL_EDIT_TITLE: (label: string, rowNo: number) =>
    `${rowNo} 行目: ${label}`,
  PREVIEW_CELL_EDIT_HINT: 'Enter またはこの吹き出しの外をクリックで確定します',
  PREVIEW_CELL_EDITED: '修正済み',
  PREVIEW_ROW_ERRORS_TITLE: (rowNo: number) => `${rowNo} 行目のエラー`,
  BULK_FILL_COUNT: (n: number) => `（${n} 項目）`,

  // フォーマット保存（任意操作）
  SAVE_FORMAT_TITLE: 'このマッピングをフォーマットとして保存',
  SAVE_FORMAT_DESCRIPTION:
    '保存すると、次回から「保存した列の対応で取り込む」で初期値として呼び出せます。',
  SAVE_FORMAT_NAME_LABEL: 'フォーマット名',
  SAVE_FORMAT_NAME_PLACEHOLDER: '例: イオン集荷DATA（東京RG）',
  // 保存したフォーマットは定義として扱う（#5695）。CSV に無い列があるか、対応づけを変えたら、取り込む前に保存し直す
  SAVED_FORMAT_MISSING_COLUMNS: (columns: string) =>
    `保存した列の対応のうち、この CSV に見つからない列があります: ${columns}。見つからない列のまま取り込むことはできません。対応づけを直して、下で保存し直してください。`,
  SAVED_FORMAT_EDITED:
    '保存した列の対応から変えています。取り込む前に、変えた内容を保存してください。',
  SAVED_FORMAT_SAVE_UPDATE: (name: string) => `「${name}」を更新する`,
  SAVED_FORMAT_SAVE_NEW: '別の名前で保存する',
  SAVED_FORMAT_SAVE_REQUIRED:
    '保存した列の対応を、更新するか別の名前で保存してください',
  SAVED_FORMAT_NAME_DUPLICATED:
    'この拠点に同じ名前の保存した列の対応があります',
  SAVED_FORMAT_DELETE: '削除',
  SAVED_FORMAT_DELETE_CONFIRM: (name: string) =>
    `保存した列の対応「${name}」を削除します。よろしいですか？`,
  SAVED_FORMAT_DELETED: (name: string) =>
    `保存した列の対応「${name}」を削除しました`,
  SAVED_FORMAT_DELETE_FAILED: '保存した列の対応を削除できませんでした',

  // ステップ: 完了
  DONE_MESSAGE:
    '取り込みを受け付けました。処理はバックグラウンドで進み、結果はインポート履歴で確認できます。',
  DONE_SUMMARY_REGISTERED: (n: number) => `取り込み対象 ${n} 件`,
  DONE_SUMMARY_EXCLUDED: (n: number) => `除外（エラー） ${n} 件`,
  DONE_FORMAT_SAVED: (name: string) =>
    `フォーマット「${name}」を保存しました。次回から「保存した列の対応で取り込む」で選べます`,
  // 取り込んだあとに取り出せるファイル（#5697・#5737）。完了画面とインポート履歴に同じものを出す
  DONE_CUT_OUT_TITLE: '失敗した行・修正を反映した CSV',
  DONE_CUT_OUT_DESCRIPTION:
    '取り込んだ CSV と同じ形・同じ文字コードで書き出します。失敗した行は、一番右の「エラー内容」の列に取り込めなかった理由が入っています。直してそのまま取り込み直せます（「エラー内容」の列は取り込まれません）。修正を反映した CSV は、確認画面で直した値を入れた取り込み分です。どちらもインポート履歴からも取り出せます。',
  CUT_OUT_FAILED_REASON_HEADER: 'エラー内容',
  HISTORY_EXCLUDED_COUNT: (count: number) => `確認画面で除外 ${count} 件`,
  DONE_CUT_OUT_FAILED: (count: number) => `失敗した行（${count} 件）`,
  DONE_CUT_OUT_IMPORTED: (count: number) => `修正を反映した CSV（${count} 件）`,
  CUT_OUT_FILE_SUFFIX: {
    failed: '_失敗した行',
    imported: '_修正反映',
    changes: '_修正箇所'
  },
  // インポート履歴のファイル名の下に出す、取り込んだときに残したファイルのリンク
  HISTORY_CUT_OUT_LINK_LABELS: {
    FAILED: '失敗した行',
    IMPORTED: '修正を反映した CSV',
    CHANGES: '修正箇所の一覧'
  },
  CUT_OUT_UPLOAD_FAILED:
    '失敗した行・修正を反映した CSV をインポート履歴に残せませんでした。取り込みは続けます',
  // サントリー様の修正箇所の一覧（行は確認画面の行番号。行を見分けるために明細IDを添える）
  SUNTORY_CHANGES_HEADERS: ['行', '明細ID', '項目', '修正前', '修正後'],
  SUNTORY_DOWNLOAD_CHANGES: (count: number) => `修正箇所の一覧（${count} 件）`,
  SUNTORY_DOWNLOAD_IMPORTED: '修正を反映した CSV',
  SUNTORY_DOWNLOAD_IMPORTED_HINT:
    '直した値のうち荷主・発地・着地を元の列に入れた CSV を、元の CSV と同じ形で書き出します。配送種別・荷姿・車種・パートナーの直しは CSV に入れる列が無いので、修正箇所の一覧で確認してください。どちらもインポート履歴からも取り出せます。',
  SUNTORY_DOWNLOAD_IMPORTED_FAILED: '修正を反映した CSV を書き出せませんでした',
  // サントリー様の社内移動 CSV の見出し名（BE の suntory-shipment-order-csv-parser.ts が読む列名と同じ）
  SUNTORY_INTERNAL_COLUMNS: {
    SHIPMENT_TYPE: '出荷タイプ',
    INTERNAL_MOVE: '社内移動',
    DETAIL_ID: '明細ＩＤ',
    CARRIER_CODE: '運送会社コード',
    ORIGIN: '払・受払場所',
    DEST_INTERNAL_MOVE: '受・受払場所',
    DEST_CUSTOMER: '届先コード'
  },
  SUNTORY_DOWNLOAD_CHANGES_HINT:
    '何行目の何を、何から何に直したかの一覧です。インポート履歴からも取り出せます。',

  // 登録内容プレビュー: 型変換・グルーピング済みの値で「こう登録されます」を実データで見せる
  REGISTRATION_PREVIEW_TITLE: '登録内容プレビュー',
  REGISTRATION_PREVIEW_DESCRIPTION:
    '実際にロジGoへ登録される際の項目グループ・値の形です（日付・数値は型変換済み）。マスタ参照コード（荷主コード等）はAPI側でIDへ解決されます。',
  REGISTRATION_PREVIEW_SAMPLE_NOTE: (shown: number, total: number) =>
    total > shown
      ? `先頭${shown}件を表示（登録対象は全${total}件、以降も同じ形で登録されます）`
      : `全${total}件を表示`,
  REGISTRATION_PREVIEW_ROW_LABEL: (rowNo: number) => `${rowNo}件目`,
  REGISTRATION_PREVIEW_MASTER_CODE_TAG: 'コード',
  REGISTRATION_PREVIEW_EMPTY: '登録対象の行がありません',

  // フッター（追加分）
  NEXT_FILE: '次へ（ファイル選択）',
  NEXT_CONFIRM: '次へ（確認）',
  BACK_METHOD: '戻る（取り込み方法・ファイル選択）',
  STANDARD_FILE_ALERT_MESSAGE:
    '取り込むCSVファイル（ロジGo規定フォーマット）を選択してください'
} as const

/** 必須項目を示すマーク（マッピングのSelect option・必須進捗タグで使用）。 */
export const REQUIRED_MARK = '★'

/**
 * #4728: 標準フォーマットの列仕様ヘルプ（通常フォーマット経路のヘルプ表示用）。
 * 内容の信源: docs/csv-column-reference.md §7（事実台帳）＋ imports-shipment-order.service.ts /
 * imports-shipment-order-error.service.ts の実装確認（Site自動作成 :797 / 荷主コード存在チェック :56-66）。
 * 発明した仕様は書かない。
 */
export const SHIPMENT_ORDER_CSV_STANDARD_HELP = {
  OPEN: 'ロジGo規定フォーマットの列仕様を見る',
  TITLE: '配送依頼 ロジGo規定フォーマット 列仕様',
  RULES_TITLE: '全体ルール（できること）',
  RULES: [
    '文字コードは自動判定されます（UTF-8 / Shift-JIS）。',
    '列はヘッダー名で識別するため、並び順は自由です。配送依頼セットの34列はヘッダーとして全列そろえてください（値の必須/任意は列ごと）。',
    '運行計画セット（8列）は、配車の枠まで同時に登録するときだけ足します。1列でも含めると、8列すべてが必要になります。',
    '配送依頼の発送日・着日・時間制限は依頼そのものの内容で、運行計画の項目は「どの車両の、どの日の、何時から何時に矢羽根を置くか」を決めます。',
    '無関係な列が含まれていてもエラーにならず無視されます。',
    'テンプレートには任意の「取消」の列も入っています。取り消したい行にだけ「○」を入れます（外部キーが必要）。使わないときは空欄のままか、列ごと消して構いません。',
    '振り分けキーが同じで、荷主・発着地・発送日・着日などの条件も同じ行は、1件の配送依頼の明細にまとまります。振り分けキーが空の行は、条件が同じでもまとめず、1行で1件の配送依頼になります。',
    'テンプレートには任意の「まとめキー」の列も入っています。同じ値を入れた行で作る配送依頼どうしを束ねます（配送依頼は別々のまま）。使うのは、この取込で新しく作る配送依頼の行だけです。外部キーで前の明細を上書きする行（すでにある配送依頼の行）と、運行計画（配車キー）のある行では使いません（エラーにはせず無視し、すでにある配送依頼の束ねも変えません）。取り込んだあと配送依頼一覧の「まとめキー」には、CSV に入れた値ではなく、システムが束ねに付けた値（例: 4-3CH-K89T）が出ます。取り込みを一時停止して再開すると、停止の前と後で束ねが分かれます。片側が 1 件だけのときは、その配送依頼は束ねに入らないので、配送依頼一覧で束ねてください。',
    '外部キーを設定しておくと、同じ外部キーの行を取り込み直したときに、前の配送依頼の明細を上書きします。外部キー未設定の行は常に新規作成です。',
    '未登録の発地/着地コードは、地点が自動作成されます（名称・備考はCSVの値を使用）。',
    '未登録の荷主コードは行エラーになります（「未登録または有効でない荷主コードがあります」）。',
    'カスタムキーは拠点のカスタムキーマスタでラベル設定＋表示ONのスロットのみ、ラベルとヘッダーの完全一致で取り込まれます（前後の空白のみ除去。全角/半角の違いはマッチせず無視されるので注意）。'
  ],
  GROUP_BASE: '配送依頼セット（34列・ヘッダーとして全列そろえる）',
  GROUP_DISPATCHED:
    '運行計画セット（8列・配車の枠まで同時に登録するときだけ足す）',
  GROUP_OPTIONAL: '任意の列（無くても読める・1列ずつ足せる）',
  OPTIONAL_COLUMNS: [
    { name: '取消', required: false },
    { name: 'まとめキー', required: false }
  ],
  COL_HEADER_NAME: '列名',
  COL_HEADER_REQUIRED: '値の必須',
  COL_HEADER_DESCRIPTION: '形式・補足',
  REQUIRED_LABEL: '必須',
  OPTIONAL_LABEL: '任意',
  BASE_COLUMNS: [
    {
      name: '外部キー',
      required: false
    },
    {
      name: '振り分けキー',
      required: false
    },
    {
      name: '配送タイプ',
      required: false
    },
    {
      name: '発送日',
      required: false
    },
    { name: '着日', required: true },
    {
      name: '発地コード',
      required: true
    },
    {
      name: '発地名称',
      required: false
    },
    {
      name: '発地契約エリアコード',
      required: false
    },
    {
      name: '着地コード',
      required: true
    },
    {
      name: '着地名称',
      required: false
    },
    {
      name: '着地契約エリアコード',
      required: false
    },
    { name: '着地住所', required: false },
    {
      name: '着地備考',
      required: false
    },
    { name: '品目コード', required: false },
    { name: '品目名称', required: false },
    { name: '数量（Ｃ/Ｓ）', required: false },
    { name: '重量（Ｋｇ）', required: false },
    { name: '荷姿', required: false },
    {
      name: '荷姿積載商品数量',
      required: false
    },
    {
      name: '荷主コード',
      required: false
    },
    { name: '荷主名', required: false },
    { name: '備考', required: false },
    { name: '補足情報', required: false },
    {
      name: 'パートナーコード',
      required: false
    },
    { name: 'パートナー名', required: false },
    { name: '荷主伝票番号', required: false }
  ],
  ADD_INFO_COLUMNS: [
    { name: '請求金額', required: false },
    { name: '配送依頼備考', required: false },
    { name: '車種', required: false },
    {
      name: '配送条件',
      required: false
    },
    {
      name: '発地到着時間開始',
      required: false
    },
    {
      name: '発地到着時間終了',
      required: false
    },
    {
      name: '着地到着時間開始',
      required: false
    },
    {
      name: '着地到着時間終了',
      required: false
    }
  ],
  DISPATCHED_COLUMNS: [
    { name: '枠種別', required: true },
    { name: '枠ラベル', required: false },
    { name: '配車キー', required: true },
    { name: '配車日', required: true },
    {
      name: '配車枠発日時',
      required: true
    },
    {
      name: '配車枠着日時',
      required: true
    },
    {
      name: 'ドライバー拘束あり',
      required: false
    },
    { name: '支払金額', required: false }
  ],
  CUSTOM_KEY_TITLE: 'カスタムキー（拠点ごとの追加5項目）',
  CUSTOM_KEY_DESCRIPTION:
    '拠点のカスタムキーマスタで「表示ON＋ラベル設定済み」のスロットのみが対象。マスタのラベルとCSVヘッダーが完全一致した列を カスタムキー1〜5 に取り込みます。マスタが正であり、インポートでマスタが変更されることはありません。値は30文字まで（超過は行エラー）。取り込み直して前の明細を上書きするときは、マッチしたスロットの値で上書きされます。'
} as const

/**
 * #4728: 標準フォーマットのヘッダー名 → 配送依頼項目の固定マッピング。
 * 出典: logi-go-api/src/shared/constants/shipment-order-csv-headers.constant.ts の列名。
 * 通常フォーマット経路の確認画面で、汎用と同じ形式チェック（buildPreview）を共用するために使う
 * （専用のヘッダー警告でなく行単位エラー表示に統一。1列も一致しない場合のみ不一致警告を出す）。
 * 取り込み・事前チェックの正は BE の標準パーサーで、この FE 側マップは確認画面表示用の近似。
 */
export const SHIPMENT_ORDER_CSV_STANDARD_HEADER_FIELDS = {
  外部キー: 'externalKey',
  振り分けキー: 'orderNo',
  配送タイプ: 'shipmentCategoryId',
  発送日: 'shippingDate',
  着日: 'deliveryDate',
  発地コード: 'originSiteId',
  着地コード: 'destSiteId',
  発地名称: 'originName',
  発地契約エリアコード: 'originContractAreaCode',
  着地名称: 'destName',
  着地契約エリアコード: 'destContractAreaCode',
  着地住所: 'destAddress',
  着地備考: 'destNote',
  品目コード: 'itemCode',
  品目名称: 'itemName',
  '数量（Ｃ/Ｓ）': 'quantity',
  '重量（Ｋｇ）': 'weight',
  荷姿: 'packageCategoryId',
  荷姿積載商品数量: 'packagedLoadQuantity',
  荷主コード: 'customerId',
  荷主名: 'customerName',
  荷主伝票番号: 'customerOrderNumber',
  取消: 'revoke',
  まとめキー: 'bundleKey',
  補足情報: 'supplement',
  パートナー名: 'partnerName',
  備考: 'note',
  パートナーコード: 'partnerId',
  車種: 'truckModelId',
  請求金額: 'income',
  支払金額: 'payment',
  配車日: 'dispatchDate',
  カスタムキー1: 'customKey1',
  カスタムキー2: 'customKey2',
  カスタムキー3: 'customKey3',
  カスタムキー4: 'customKey4',
  カスタムキー5: 'customKey5',
  // 追加情報セット（ADD_INFO_HEADERS）・運行計画セット（DISPATCHED_HEADERS）の残り13列
  // （SHIPMENT_ORDER_CSV_STANDARD_HELP の「セット単位で任意」の説明と対応させる）。出典:
  // logi-go-api/src/shared/constants/shipment-order-csv-headers.constant.ts の
  // ADD_INFO_HEADERS / DISPATCHED_HEADERS のヘッダー文字列と完全一致させる。
  配送依頼備考: 'shipmentOrderNote',
  配送条件: 'carrierType',
  発地到着時間開始: 'departureTimeRestrictionStart',
  発地到着時間終了: 'departureTimeRestrictionEnd',
  着地到着時間開始: 'arrivalTimeRestrictionStart',
  着地到着時間終了: 'arrivalTimeRestrictionEnd',
  枠種別: 'dispatchSlotType',
  枠ラベル: 'dispatchSlotLabel',
  配車キー: 'dispatchKey',
  配車枠発日時: 'dispatchSlotDepartureAt',
  配車枠着日時: 'dispatchSlotArrivalAt',
  ドライバー拘束あり: 'hasDriverRestraint'
} as const

/**
 * マッピング先「ロジGoの配送依頼項目」のグループ表示名（VOC_PJ-592 #4071）。
 * key は features/shipment-order-csv-import/models/logi-fields.ts の LogiFieldGroup と対応。
 */
export const LOGI_FIELD_GROUP_LABELS = {
  required: '必須項目',
  shipping: '配送情報',
  charge: '運賃・費用',
  item: '明細項目',
  customKey: 'カスタムキー',
  dispatched: '配車済み情報'
} as const

/**
 * マッピング先「ロジGoの配送依頼項目」の表示ラベル（VOC_PJ-592 #4071）。
 * key は create-shipment-order-create-form-value.ts のスキーマキーに対応。
 */
export const LOGI_FIELD_LABELS = {
  customerId: '荷主',
  shipmentCategoryId: '配送種別',
  originSiteId: '発地（積地）',
  destSiteId: '着地（降地）',
  shippingDate: '発日（積日）',
  deliveryDate: '着日（降日）',
  orderNo: '配送依頼No',
  partnerId: 'パートナー（協力会社）',
  packageCategoryId: '荷姿',
  truckModelId: '車種',
  departureTimeRestrictionStart: '発地到着時間開始',
  departureTimeRestrictionEnd: '発地到着時間終了',
  arrivalTimeRestrictionStart: '着地到着時間開始',
  arrivalTimeRestrictionEnd: '着地到着時間終了',
  shipmentOrderNote: '配送依頼備考',
  carrierType: '配送条件',
  note: '備考',
  income: '請求運賃（円）',
  itemCode: '品目コード',
  itemName: '品目名',
  packagedLoadQuantity: '荷姿単位数量',
  quantity: '数量（C/S）',
  weight: '重量（kg）',
  externalKey: '外部キー',
  originName: '発地名称',
  originContractAreaCode: '発地契約エリアコード',
  destName: '着地名称',
  destContractAreaCode: '着地契約エリアコード',
  destAddress: '着地住所',
  destNote: '着地備考',
  customerName: '荷主名',
  partnerName: 'パートナー名',
  customerOrderNumber: '荷主伝票番号',
  revoke: '取消',
  bundleKey: 'まとめキー',
  supplement: '補足情報',
  customKey1: 'カスタムキー1',
  customKey2: 'カスタムキー2',
  customKey3: 'カスタムキー3',
  customKey4: 'カスタムキー4',
  customKey5: 'カスタムキー5',
  dispatchSlotType: '枠種別',
  dispatchSlotLabel: '枠ラベル',
  dispatchKey: '配車キー',
  dispatchDate: '配車日',
  dispatchSlotDepartureAt: '配車枠発日時',
  dispatchSlotArrivalAt: '配車枠着日時',
  hasDriverRestraint: 'ドライバー拘束あり',
  payment: '支払金額'
} as const

/**
 * マッピング先「ロジGoの配送依頼項目」グループの反映先（マッピング項目リファレンスで表示）。
 * グループ分けはマッピング画面のSelectの optgroup と同じ。
 */
export const LOGI_FIELD_GROUP_REFLECTION: Record<
  keyof typeof LOGI_FIELD_GROUP_LABELS,
  string
> = {
  required: '配送依頼の基本情報（必須欄）',
  shipping: '配送依頼の基本情報（任意欄）',
  charge: '配送依頼の運賃・費用',
  item: '配送依頼の明細行（1CSV行=明細1行）',
  customKey: '配送依頼のカスタムキー欄（拠点マスタ設定に依存）',
  dispatched: '配車情報（配車板に表示される配車枠）'
} as const

/**
 * マッピング先「ロジGoの配送依頼項目」の項目別リファレンス（何を入力できるか・形式・反映先の補足）。
 * 標準フォーマットの列仕様（SHIPMENT_ORDER_CSV_STANDARD_HELP）と重複する項目は同じ説明文を再利用し、
 * 標準フォーマットに無い項目（請求計上日・税区分・払い運賃・荷姿数等）は新規に記述。
 * keyof LOGI_FIELD_LABELS で全項目を型強制（項目追加時に説明の書き漏れをコンパイルエラーで検知）。
 */
export const SHIPMENT_ORDER_CSV_FIELD_REFERENCE: Record<
  keyof typeof LOGI_FIELD_LABELS,
  string
> = {
  customerId: '指定時は登録済みで有効な荷主コードが必要（未登録は行エラー）',
  shipmentCategoryId: '配送種別マスタのコードで指定',
  originSiteId: '地点マスタと突合。未登録コードは地点を自動作成',
  destSiteId: '地点マスタと突合。未登録コードは地点を自動作成',
  shippingDate: '空の場合は着日と同じ日付になる',
  deliveryDate: '配送依頼の基準日（必須）',
  orderNo:
    '配送依頼Noとして登録。同じ値で条件（荷主・発着地・発送日・着日など）も同じ行は、1件の配送依頼の明細にまとめる。空の行は1行で1件の配送依頼になる',
  partnerId:
    '実際に配送を担当する運送会社（協力会社）を指定する場合に使う。空欄なら未割当のまま登録され、あとから配車時に割り当てられる',
  packageCategoryId:
    '荷姿マスタのコードで指定。コードは「業務マスタ設定 > 荷姿」で確認できる',
  truckModelId:
    '車種マスタのコードで指定。コードは「業務マスタ設定 > 車種」で確認できる',
  departureTimeRestrictionStart:
    '発地の時間制限（開始）。例: 2026/9/1 8:00。終了とセットで入力（片方だけは不可）',
  departureTimeRestrictionEnd:
    '発地の時間制限（終了）。例: 2026/9/1 12:00。開始以降の時刻にする',
  arrivalTimeRestrictionStart:
    '着地の時間制限（開始）。例: 2026/9/1 14:00。終了とセットで入力（片方だけは不可）。発地の時間制限（開始）以降にする',
  arrivalTimeRestrictionEnd:
    '着地の時間制限（終了）。例: 2026/9/1 18:00。開始以降の時刻にする',
  shipmentOrderNote: '配送依頼備考として登録（基本情報の「備考」とは別項目）',
  carrierType: '配送条件。自由入力の文字列（固定の選択肢はない）',
  note: '配送依頼の備考として登録',
  income: '請求運賃（円）。数値',
  itemCode: '明細行の品目コード',
  itemName: '明細行の品目名',
  packagedLoadQuantity: '数値。荷姿数の算出に使用',
  quantity: '数値（0以上）',
  weight: '数値（0以上）',
  externalKey:
    '取り込み直したときに前の明細を見分ける番号。同じ外部キーの行を取り込み直すと、前の配送依頼の明細を上書きする',
  originName:
    '発地の名称。発地コードがマスタに無く地点を自動作成するときの地点名に使う',
  originContractAreaCode:
    '発地の契約エリアコード。エリアマスタに登録済みのコードで指定',
  destName:
    '着地の名称。着地コードがマスタに無く地点を自動作成するときの地点名に使う',
  destContractAreaCode:
    '着地の契約エリアコード。エリアマスタに登録済みのコードで指定',
  destAddress: '着地の住所。着地の地点を自動作成するときの住所に使う',
  destNote: '着地の備考。着地の地点を自動作成するときの備考に使う',
  customerName: '荷主の名称（取込時の参照用。荷主の特定は荷主コードで行う）',
  partnerName:
    'パートナーの名称（取込時の参照用。パートナーの特定はパートナーコードで行う）',
  customerOrderNumber: '荷主側の伝票番号',
  revoke:
    '「○」の行は取消の行として扱い、外部キー（明細ID）で登録済みの明細を外す。取消の行は外部キー・振り分けキー・発送日（空なら着日）だけを見る。明細が 0 件になった配送依頼は取消になる',
  bundleKey:
    '同じ値の行で新しく作る配送依頼どうしを束ねる（配送依頼は別々のまま）。2件以上で束ねる。使うのは、この取込で新しく作る配送依頼の行だけ。外部キーで前の明細を上書きする行（すでにある配送依頼の行）と、運行計画（配車キー）のある行では使わない（エラーにはせず無視する）。1件の配送依頼の行に違う値が入っていると行エラー',
  supplement: '補足情報（自由入力）',
  customKey1:
    '拠点のカスタムキーマスタで「表示ON」のスロットのみ有効。値は30文字まで',
  customKey2:
    '拠点のカスタムキーマスタで「表示ON」のスロットのみ有効。値は30文字まで',
  customKey3:
    '拠点のカスタムキーマスタで「表示ON」のスロットのみ有効。値は30文字まで',
  customKey4:
    '拠点のカスタムキーマスタで「表示ON」のスロットのみ有効。値は30文字まで',
  customKey5:
    '拠点のカスタムキーマスタで「表示ON」のスロットのみ有効。値は30文字まで',
  dispatchSlotType:
    '配車板に作る枠の種類を 1/2/3 で指定。1＝配送（この行の配送依頼を矢羽根にして載せる）、2＝予定、3＝空き時間（2・3 の行は配送依頼を作らず、配車板に枠だけを作る）。運行計画の項目（枠種別〜支払金額）のいずれかを紐づけると、枠種別・配車キー・配車日・配車枠発日時・配車枠着日時が必須になる',
  dispatchSlotLabel: '配車枠の表示ラベル',
  dispatchKey:
    '矢羽根を載せる車両。「パートナーコード/車両番号」か「車両の表示名」で指定する。配車キーと配車日が同じ行は、配車板の同じ車両の行に載る。車両を 1 台に決められないときはエラーにせず、車両未定の行に載る。運行計画の項目（枠種別〜支払金額）のいずれかを紐づけると、枠種別・配車キー・配車日・配車枠発日時・配車枠着日時が必須になる',
  dispatchDate:
    '矢羽根を載せる配車板の日付（配車板画面の左上の日付）。配送依頼の発送日とは別に指定する。運行計画の項目（枠種別〜支払金額）のいずれかを紐づけると、枠種別・配車キー・配車日・配車枠発日時・配車枠着日時が必須になる',
  dispatchSlotDepartureAt:
    '配車板に置く矢羽根の開始日時。配送依頼の発着日・時間制限とは別に指定する。例: 2026/9/1 8:00。運行計画の項目（枠種別〜支払金額）のいずれかを紐づけると、枠種別・配車キー・配車日・配車枠発日時・配車枠着日時が必須になる',
  dispatchSlotArrivalAt:
    '配車板に置く矢羽根の終了日時。例: 2026/9/1 18:00。運行計画の項目（枠種別〜支払金額）のいずれかを紐づけると、枠種別・配車キー・配車日・配車枠発日時・配車枠着日時が必須になる',
  hasDriverRestraint: '0/1（既定は1）',
  payment: '配車枠の支払金額（円）。数値'
} as const

/**
 * マッピング項目リファレンス（Drawer表示）のUI文言。
 * RULES は項目横断のバリデーション条件。
 * 出典: features/shipment-orders/models/create-shipment-order-create-form-value.ts の
 * custom() バリデータ（時間制限の開始/終了ペア必須・順序制約）と、
 * logi-go-api/schema.zmodel の ShipmentOrder（orderNoは@@uniqueでなく@@indexのみ＝重複可）。
 */
export const SHIPMENT_ORDER_CSV_FIELD_REFERENCE_HELP = {
  OPEN: '入力できる項目と反映先を見る',
  TITLE: '配送依頼 マッピング項目リファレンス',
  DESCRIPTION:
    'マッピング先として選べる全項目の一覧です。「反映先」は実際にロジGoへ登録される際にどこへ入るかを示します。',
  RULES_TITLE: '項目をまたぐバリデーション条件',
  RULES: [
    '発地/着地の到着時間制限は、開始・終了をセットで入力してください（片方だけでは登録できません）',
    '各時間制限の終了時刻は、同じ項目の開始時刻以降にする必要があります',
    '着地の時間制限（開始）は、発地の時間制限（開始）以降の時刻にする必要があります',
    '運行計画の項目（枠種別・枠ラベル・配車キー・配車日・配車枠発日時・配車枠着日時・ドライバー拘束あり・支払金額）は、いずれか1つでも入力すると、枠種別・配車キー・配車日・配車枠発日時・配車枠着日時が必須になります',
    '運行計画の項目は、配送依頼と同時に配車板へ矢羽根（または予定・空き時間の枠）を作るときだけ使います。配送依頼の発送日・着日・時間制限は依頼そのものの内容で、運行計画の項目は「どの車両の、どの日の、何時から何時に矢羽根を置くか」を決めます。',
    '配送依頼No（orderNo）は重複しても登録できます（一意制約はありません）'
  ],
  COL_HEADER_NAME: '項目名',
  COL_HEADER_REQUIRED: '必須',
  COL_HEADER_REFLECTION: '反映先',
  COL_HEADER_DESCRIPTION: '形式・補足',
  REQUIRED_LABEL: '必須',
  OPTIONAL_LABEL: '任意'
} as const
